export const translationRu = {
  aiProgressNotes: {
    activities: {
      0: 'посмотрели',
      1: 'создали',
      2: 'изменили',
      3: 'удалили',
    },
    alternativeDetails: {
      0: 'Мы рассмотрели ранее задокументированный {{technique}}',
      '0_f': 'Мы рассмотрели ранее задокументированную {{technique}}',
      '0_n': 'Мы рассмотрели ранее задокументированное {{technique}}',
      1: 'Мы выявили и задокументировали новый {{technique}}',
      '1_f': 'Мы выявили и задокументировали новую {{technique}}',
      '1_n': 'Мы выявили и задокументировали новое {{technique}}',
      2: 'Мы изменили ранее задокументированный {{technique}}',
      '2_f': 'Мы изменили ранее задокументированную {{technique}}',
      '2_n': 'Мы изменили ранее задокументированное {{technique}}',
      3: 'Мы удалили ранее задокументированный {{technique}}',
      '3_f': 'Мы удалили ранее задокументированную {{technique}}',
      '3_n': 'Мы удалили ранее задокументированное {{technique}}',
    },
    activitiesDetails: {
      0: 'Мы посмотрели существующий {{technique}}',
      '0_f': 'Мы посмотрели существующую {{technique}}',
      '0_n': 'Мы посмотрели существующее {{technique}}',
      1: 'Мы создали новый {{technique}}',
      '1_f': 'Мы создали новую {{technique}}',
      '1_n': 'Мы создали новое {{technique}}',
      2: 'Мы изменили существующий {{technique}}',
      '2_f': 'Мы изменили существующую {{technique}}',
      '2_n': 'Мы изменили существующее {{technique}}',
      3: 'Мы удалили существующий {{technique}}',
      '3_f': 'Мы удалили существующую {{technique}}',
      '3_n': 'Мы удалили существующее {{technique}}',
    },
    weUsed: 'Мы использовали',
    abcModels: {
      technique: 'технику ABC-модель',
      title: 'ABC-модель',
      b: 'для мысли "{{b}}"',
      a: 'в ситуации "{{a}}"',
      emotions: 'с эмоцией {{emotion}} с силой {{strength}}',
      feelings: 'с ощущениями в теле "{{feeling}}"',
      behaviors: 'и следующим поведением: "{{behavior}}"',
    },
    behaviorExperiments: {
      technique: 'технику поведенческого эксперимента',
      typeVariants: ['Активног эксперимена', 'Наблюдательного эксперимента'],
      title: 'поведенческий эксперимент',
      hypothesisA: 'для мысли (Гипотеза А) "{{hypothesisA}}"',
      hypothesisB: 'с альтернативной мыслью (Гипотеза B) "{{hypothesisB}}"',
      safetyBehaviors:
        'и охранительным(избегающим) поведением "{{safetyBehaviors}}"',
      purpose: 'Целью данного {{type}} была "{{purpose}}".',
      experiment: 'Сам эксперимент заключался в "{{experiment}}"',
      time: 'с датой, временем или продолжительностью "{{time}}"',
      place: 'с местом проведения "{{place}}"',
      people: 'с участием других людей "{{people}}"',
      resources: 'с дополнительными ресурсами "{{resources}}"',
      survey: 'с опросом "{{survey}}"',
      followUpExperimentsIdeas:
        'Идеи для будущих экспериментов: "{{followUpExperimentsIdeas}}"',
    },
    downwardArrows: {
      technique: 'технику "падающая стрела"',
      title: 'падающая стрела',
      startingThought: 'для автоматической мысли "{{startingThought}}"',
      intermediateThought:
        'с промежуточным убеждением (правилом жизни) "{{intermediateThought}}"',
      deepBelief: 'с глубинным убеждением "{{deepBelief}}"',
    },
    exposures: {
      techniques: [
        'технику экспозиции',
        'технику экспозиции с предотвращением реакции',
      ],
      titles: ['Экспозиция', 'Экспозиция с предотвращением реакции'],
      titlesHierarchy: [
        'иерархию экспозиции',
        'иерархию экспозиции с предотвращением реакции',
      ],
      fear: 'для страха или тревоги "{{fear}}"',
      obsession: 'для обсессии "{{obsession}}"',
      safetyBehaviorsToAvoid:
        'и компульсией (охранительным/избегающим поведением) "{{safetyBehaviorsToAvoid}}"',
      situationsHierarchy: 'с иерархией ситуаций или стимулов: "{{hierarchy}}"',
      lastExpositionSituationTitle:
        'Последняя экспозиция проводилась в ситуации "{{title}}"',
      lastExpositionDuration:
        'Длительность экспозиции: "{{lastExpositionDuration}}"',
      maxSudStrength: 'Максимальная сила реакции(SUD): "{{maxSudStrength}}"',
      finishSudStrength: 'конечная сила реакции (SUD) "{{finishSudStrength}}"',
      lastExposureNotes:
        'Заметки о последней экспозиции "{{lastExposureNotes}}"',
    },
    supportingCycles: {
      technique: 'технику "поддерживающий цикл"',
      title: 'поддерживающий цикл',
      name: ', названный "{{name}},"',
      forThoughts: 'с мыслями, действиями или фактами: "{{thoughts}}"',
    },
    portalCards: {
      resource: 'portalCards',
      technique: 'копинг карточку',
      frontSide: 'с лицевой стороной: "{{frontSide}}"',
      backSide: 'и обратной стороной: "{{backSide}}"',
    },
    thoughts: {
      technique: 'технику "тест дисфункциональных мыслей"',
      title: 'тест дисфункциональных мыслей',
      activatingEvent:
        'Данная мысль возникла в результате активирующего события "{{activatingEvent}}"',
      emotions: 'с эмоцией "{{emotion}}" с силой {{strength}}',
      feelings: 'с ощущениями в теле "{{feeling}}"',
      behaviors: 'и следующим поведением: "{{behaviors}}"',
      automaticThought: 'для автоматической мысли "{{automaticThought}}"',
      thoughtFor:
        'Факты, доказывающие негативную мысль, были: "{{thoughtFor}}"',
      thoughtsForAlternativeThought:
        'но у которых могут быть альтернативные объяснения: "{{thoughtsForAlternativeThought}}" данного факта',
      thoughtsAgainst:
        'Факты, опровергающие негативную мысль: "{{thoughtsAgainst}}"',
      cognitiveDistortions: 'Когнитивные искажения "{{cognitiveDistortions}}"',
      realisticThoughts:
        'Сформулированные реалистичные мысли: "{{realisticThoughts}}"',
    },
    worryTrees: {
      technique: 'технику "дерево принятия решений"',
      title: 'дерево принятия решений',
      worryAbout: 'для тревожной мысли "{{worryAbout}}"',
      options: 'с вариантами решения проблем "{{options}}"',
      plan: 'с планом действий "{{plan}}"',
      immediateAction:
        'с действиями, которые можно сделать прямо сейчас: "{{immediateAction}}"',
    },
  },
  alarmPermissionsModal: {
    settingText: 'Открыть настройки разрешений будильника',
    text: 'Вы отклонили или удалили точные разрешения будильника для CopingCard.',
    text1:
      'Без этих разрешений мы не сможем Вам запланировать для Вас напоминания по времени.',
    title: 'Точные разрешения для будильника отключены!',
  },
  anxietyScreen: {
    dynamics: 'Динамика результатов',
    gad7Info:
      'GAD-7 (Опросник на генерализированное тревожное расстройство-7) используется для быстрого скрининга на наличие клинически значимого тревожного расстройства (одного из четырех наиболее распространенных тревожных расстройств — генерализованного тревожного расстройства, панического расстройства, социальной фобии и посттравматического стрессового расстройства), особенно в амбулаторных условиях.',
    level: 'Уровень тревожности',
    newTest: 'Пройти новый опросник',
  },
  auth: {
    notAuthorized: 'У Вас нет разрешения на получение этой информации',
    tokenError: 'Ошибка проверки токена',
  },
  backgroundHeadlessNotification: {
    channelName: 'Фоновое отслеживание геолокационных напоминаний',
    text: 'Мы отслеживаем геозоны, чтобы показывать напоминания для Ваших карточек.',
    title: 'Уведомления CopingCard по геозонам включены',
  },
  backgroundLocationAuthorizationAlert: {
    cancelButton: 'Отменить',
    instructions:
      'Вы использовали геолокационные уведомления для своих карточек, но не дали нужные разрешения сервису определения местоположения. Вы должны включить «Всегда» в сервисах определения местоположения, чтобы получать уведомления о геолокации, либо отключить геолокационные уведомления для карточек, чтобы не получать это уведомление.',
    settingsButton: 'Настройки',
    titleWhenNotEnabled: 'Сервисы определения местоположения не включены',
    titleWhenOff: 'Сервисы определения местоположения ВЫКЛЮЧЕНЫ',
  },
  backgroundNotificatoinsPermissionsRationale: {
    message:
      'CopingCard использует Вашу геопозицию, чтобы присылать напоминания с копинг-картами при входе в выбранные Вами места или выходе из них — в фоновом режиме, даже когда приложение закрыто или не используется. Эти данные используются только для настроенных Вами напоминаний и никогда не передаются для рекламы. Включите доступ к геопозиции «{backgroundPermissionOptionLabel}».',
    negativeAction: 'Отменить',
    positiveAction: 'Измените на {backgroundPermissionOptionLabel}',
    title: `Разрешить {applicationName} доступ к местоположению этого устройства в фоновом режиме?`,
  },
  autoResetSettingsModal: {
    okButton: 'ОК, открыть настройки',
    text: 'Android может приостановить приложение и отозвать его разрешения, если долго его не открывать, — тогда напоминания о месте и времени перестанут приходить. Чтобы они работали надёжно, отключите «Приостанавливать неиспользуемые приложения» в настройках приложения.',
    title: 'Чтобы напоминания работали',
  },
  batterySettingsModal: {
    okButton: 'ОК, открыть настройки',
    text: 'Чтобы обеспечить доставку уведомлений, отключите оптимизацию батареи для приложения.',
    title: 'Обнаружены ограничения',
  },
  // P021 (2026-09-19) — RU approved by the founder 2026-09-19 ("change вы, ваш to uppercase variants": the polite Вы/Ваш throughout).
  transferNotify: {
    clientEmailSubject: 'Ваша практика хочет передать Вас другому специалисту',
    clientEmailGreeting: 'Здравствуйте, {{name}}!',
    clientEmailBody:
      '{{practice}} просит передать Ваше сопровождение специалисту {{newTherapist}}. Ничего не изменится, пока Вы не подтвердите запрос.',
    clientEmailAction: 'Откройте приложение, чтобы рассмотреть запрос и подтвердить или отклонить его',
    clientEmailWhere: 'В приложении CopingCard запрос ждёт Вас в разделе Настройки → Обмен данными со специалистами.',
    clientPushTitle: 'Запрос на передачу ждёт Вашего ответа',
    clientPushBody: '{{practice}} хочет передать Ваше сопровождение специалисту {{newTherapist}}. Откройте раздел обмена данными, чтобы ответить.',
    requesterEmailSubject: 'Клиент подтвердил передачу',
    requesterEmailBody:
      '{{client}} подтвердил(а) передачу специалисту {{newTherapist}}. Клиент теперь отображается на его странице клиентов.',
    signature: 'С уважением, команда CopingCard',
  },
  inviteMail: {
    subject: 'Приглашение в CopingCard',
  },
  // E34 · уведомления о домашних заданиях (блок 1d, 2026-09-28) — push и письмо, которые API отправляет
  // КЛИЕНТУ. Серверный текст на языке клиента (`lng`), в приложении не показывается. Называет терапевта и
  // название задания — и ничего клинического сверх названия (правило доски).
  homeworkNotify: {
    assigned: {
      title: 'Новое домашнее задание',
      body: '{{therapist}} назначил(а) Вам задание: «{{title}}».',
    },
    amended: {
      title: 'Домашнее задание изменилось',
      body: '{{therapist}} обновил(а) задание «{{title}}».',
    },
    cancelled: {
      title: 'Домашнее задание отменено',
      body: '{{therapist}} отменил(а) задание «{{title}}» — делать ничего не нужно.',
    },
    manual: {
      title: 'Напоминание о задании',
      body: '{{therapist}} напоминает: задание «{{title}}» ждёт Вас.',
    },
    due: {
      title: 'Подошёл срок домашнего задания',
      body:
        'Подошёл срок задания «{{title}}». Откройте его, как только сможете.',
    },
    overdue: {
      title: 'Задание всё ещё ждёт Вас',
      body:
        'Срок задания «{{title}}» прошёл два дня назад. Выполните его, как появится возможность, или пропустите и укажите причину.',
    },
    commentReply: {
      title: 'Ответ к домашнему заданию',
      body: '{{therapist}} ответил(а) в задании «{{title}}».',
    },
    appUpdate: {
      title: 'Обновите CopingCard, чтобы увидеть домашнее задание',
      body:
        '{{therapist}} назначил(а) Вам домашнее задание в CopingCard. Ваша версия приложения пока не может его показать — обновите приложение, и Вы найдёте его в разделе «Инструменты» → «Домашние задания».',
      appStore: 'Обновить в App Store (iPhone)',
      googlePlay: 'Обновить в Google Play (Android)',
    },
    yourTherapist: 'Ваш терапевт',
    emailGreeting: 'Здравствуйте, {{name}}!',
    emailGreetingNoName: 'Здравствуйте!',
    emailAction: 'Открыть в CopingCard',
    emailWhere:
      'В приложении CopingCard оно находится в разделе «Инструменты» → «Домашние задания».',
    signature: 'С уважением, команда CopingCard',
  },
  diagram: {
    alt: 'Ваша диаграмма',
    unavailable: 'Сейчас не удалось отрисовать изображение. Вот что на нём написано, чтобы ничего не потерялось:',
  },
  be: {
    tokenNotFound: 'Код приглашения не найден',
    tokenNotValid: 'Код приглашения недействителен',
    noPermissions: 'У Вас нет прав для выполнения этого действия',
    diagram: {
      error: {
        invalid: 'Не удалось отрисовать эту диаграмму. Откройте её снова или немного измените и попробуйте ещё раз.',
        busy: 'Слишком много диаграмм одновременно. Подождите минуту и попробуйте ещё раз.',
        failed: 'Сейчас не удалось отрисовать эту диаграмму. Пожалуйста, попробуйте через минуту.',
      },
    },
    // P014 (2026-09-13) — RU approved by the founder 2026-09-13.
    grantPartyNotFound:
      'Не удалось найти этого специалиста. Проверьте ссылку или код приглашения и попробуйте снова.',
    notPracticeAdmin:
      'Удалить участника может только администратор своей практики.',
    practiceAdminOnly: 'Это может сделать только администратор практики.',
    backoffice: {
      noSuchAccount: 'Аккаунта с таким e-mail нет. Проверьте адрес и попробуйте ещё раз.',
      ambiguousAccount:
        'Этот e-mail есть у нескольких аккаунтов. Выдайте доступ из CLI по ключу аккаунта.',
      revokeRefused:
        'Это членство нельзя завершить: человек не является участником или он последний участник.',
    },
    erasure: {
      ERASURE_NOT_FOUND: 'Такого человека нет. Возможно, он уже удалён — проверьте журнал удалений.',
      ERASURE_CONFIRM_MISMATCH: 'Введённый ключ не совпадает с ключом этого человека.',
      ERASURE_REASON_REQUIRED: 'Укажите причину для журнала аудита.',
      ERASURE_BLOCKED: 'Удаление заблокировано: {{detail}}',
      ERASURE_SELF: 'Вы не можете удалить свой собственный аккаунт из бэк-офиса.',
      badStatus: 'Неизвестный статус. Используйте requested, completed или all.',
    },
    notYourInvite:
      'Удалить можно только приглашение, которое Вы отправили или которое адресовано Вам.',
    notYourRelation:
      'Изменять настройки доступа можно только для своих подключений.',
    selfGrantRefused: 'Для подключения нужны два разных человека.',
    // P016 (2026-09-18) — RU approved by the founder 2026-09-18.
    nameRequired: 'Пожалуйста, укажите имя и фамилию.',
    // P018 (2026-09-19) — RU approved by the founder 2026-09-19.
    inviteNotPrepared:
      'Не удалось подготовить приглашение. Пожалуйста, попробуйте отправить его ещё раз.',
    // P020 (2026-09-19) — RU approved by the founder 2026-09-19.
    sharingEnded:
      'Обмен данными с этим специалистом завершён. Чтобы снова делиться данными, примите новое приглашение или ссылку от него.',
    // M7 (E03 + E07) — RU approved by the founder 2026-09-13.
    alreadyConnected:
      'Вы уже подключены к этому специалисту. Изменить настройки доступа можно на экране «Специалисты».',
    noPendingTransfer:
      'Нет запроса на перевод, ожидающего ответа. Попросите практику отправить новый.',
  },
  cardNotifications: {
    intro: 'Уведомления для реалистичной мысли:',
    reminderLimitTitle: 'Достигнут лимит напоминаний',
    reminderLimitText:
      'Вы достигли бесплатного лимита напоминаний по времени: {{count}}. Оформите подписку для неограниченного количества напоминаний.',
  },
  cardsScreen: {
    addCard: 'Создать новую карту',
    editCard: 'Редактировать карту',
    createFirstCard: 'Создайте свою первую карту',
    deleteError:
      'Мы не смогли удалить эту карточку. Пожалуйста, попробуйте еще раз. Если проблема повторится, напишите в support@copingcard.com и укажите код CARDS-DELETE-1.',
    resetFilterButton: 'Сбросить фильтр карточек',
    reviewCardTitle: 'Повтор карточек',
    saveError:
      'Мы не смогли сохранить эту карточку. Пожалуйста, попробуйте еще раз. Если проблема повторится, напишите в support@copingcard.com и укажите код CARDS-SAVE-1.',
    totalCount: 'Всего карточек',
  },
  channelsAndCategories: {
    channels: [
      {
        description:
          'Этот канал используется для общих уведомлений CopingCard, таких как новый функционал, обновления, новости и т.д.',
        groupId: 'CcGeneral',
        id: 'CcGeneralNews',
        name: 'Новости и обновления',
      },
      {
        description:
          'Этот канал получает временные напоминания о Ваших копинг-картах.',
        groupId: 'CcCards',
        id: 'CcCardsTime',
        name: 'Напоминания о копинг-картах по времени',
      },
      {
        description:
          'Этот канал получает геолокационные напоминания о Ваших копинг-картах.',
        groupId: 'CcCards',
        id: 'CcCardsGeolocation',
        name: 'Геолокационные напоминания о копинг-картах',
      },
      {
        description:
          'Этот канал получает напоминания о Ваших запланированных опросниках.',
        groupId: 'CcTests',
        id: 'CcTests',
        name: 'Напоминания о запланированных опросниках',
      },
    ],
    groups: [
      {
        description:
          'Эта группа используется для общих уведомлений CopingCard, таких как новый функционал, обновления, новости и т.д.',
        id: 'CcGeneral',
        name: 'Общие уведомления',
      },
      {
        description:
          'Эта группа организует напоминания для Ваших копинговых карт на основе времени и геолокации.',
        id: 'CcCards',
        name: 'Напоминания о копинг-картах',
      },
      {
        description:
          'Эта группа организует напоминания о Ваших запланированных опросниках.',
        id: 'CcTests',
        name: 'Напоминания о запланированных опросниках',
      },
    ],
  },
  common: {
    loadStatus: {
      offlineTitle: 'Нет подключения к интернету',
      offlineBody: 'Не удалось загрузить последние данные.',
      serverTitle: 'Не удаётся связаться с CopingCard',
      serverBody: 'Не удалось загрузить последние данные.',
      authBody: 'Возникла проблема с сессией. Попробуйте ещё раз.',
      staleNote:
        'Показаны сохранённые данные — обновятся, когда связь восстановится.',
      retrying: 'Обновляем…',
      persistentBody:
        'Если проблема повторяется, напишите в support@copingcard.com.',
      retry: 'Повторить',
    },
    and: 'И',
    authDebugPasswordSignInFailed:
      'Мы не смогли завершить отладочный вход. Пожалуйста, попробуйте еще раз. Если проблема повторится, напишите в support@copingcard.com и укажите код AUTH-DEBUG-1 и статус {{status}}.',
    authBootstrapUserEmailRequired:
      'Мы не смогли завершить настройку Вашей учетной записи, потому что отсутствует адрес электронной почты. Пожалуйста, выйдите из приложения и войдите снова. Если проблема повторится, напишите в support@copingcard.com и укажите код AUTH-BOOTSTRAP-1.',
    authBootstrapUserRecordMissing:
      'Мы не смогли завершить настройку Вашей учетной записи. Пожалуйста, закройте и снова откройте CopingCard, а затем попробуйте еще раз. Если проблема повторится, напишите в support@copingcard.com и укажите код AUTH-BOOTSTRAP-2.',
    authBootstrapSettingUp: 'Настраиваем Вашу учетную запись…',
    authBootstrapOffline:
      'Нет подключения к интернету. CopingCard завершит настройку, как только связь восстановится.',
    authBootstrapServerTrouble:
      'Не удаётся связаться с CopingCard. Продолжаем попытки…',
    authBootstrapSlow:
      'Это занимает больше времени, чем обычно. Проверьте подключение или повторите попытку.',
    authBootstrapSessionExpired:
      'Срок действия Вашей сессии истёк. Пожалуйста, выйдите и войдите снова.',
    authSessionProviderRequired:
      'Мы не смогли загрузить этот раздел приложения. Пожалуйста, закройте и снова откройте CopingCard. Если проблема повторится, напишите в support@copingcard.com и укажите код AUTH-SESSION-1.',
    back: 'Назад',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    continue: 'Далее',
    copyToClipboard: 'Скопировать',
    delete: 'Удалить',
    done: 'закончить',
    edit: 'Редактировать',
    emailTo: 'на',
    goBack: 'Вернуться',
    help: 'Справка',
    keyboardDone: 'Готово',
    learnMore: 'Узнать больше',
    na: 'Не доступно',
    no: 'нет',
    noResults: 'Нет результатов',
    ok: 'Ок',
    optionalData: 'Опциональная информация',
    or: 'или',
    readMore: 'Ещё',
    sort: 'Сортировать',
    sortAscending: 'Сортировать по возрастанию',
    sortDescending: 'Сортировать по убыванию',
    save: 'Сохранить',
    search: 'Поиск',
    selectDate: 'Выберите дату',
    selected: 'выбрано',
    send: 'отправить',
    timezone: 'Часовой пояс',
    tryAgain: 'попробовать снова',
    yes: 'да',
    next: 'Далее',
    unsavedChanges: 'У Вас есть несохраненные изменения',
    returnToScreen: 'Вернуться к текущему экрану',
    saveAndGoBack: 'Сохранить и вернуться назад',
    discardAndGoBack: 'Отменить изменения и вернуться назад',
    moveUp: 'Переместить вверх',
    moveDown: 'Переместить вниз',
    start: 'Старт',
    stop: 'Стоп',
    createdAt: 'Создано',
    failedToFetchImage: 'Не удалось загрузить изображение',
    uploadSuccess: 'Изображение успешно загружено',
    close: 'Закрыть',
    suffix_ordinal_one: '',
    suffix_ordinal_two: '',
    suffix_ordinal_few: '',
    suffix_ordinal_other: '',
    areYouSure: 'Вы уверены?',
  },
  countriesFallback: [
    {
      name: 'Австралия',
      value: 'AU',
    },
    {
      name: 'Австрия',
      value: 'AT',
    },
    {
      name: 'Азербайджан',
      value: 'AZ',
    },
    {
      name: 'Аландские острова',
      value: 'AX',
    },
    {
      name: 'Албания',
      value: 'AL',
    },
    {
      name: 'Алжир',
      value: 'DZ',
    },
    {
      name: 'Американское Самоа',
      value: 'AS',
    },
    {
      name: 'Ангилья',
      value: 'AI',
    },
    {
      name: 'Ангола',
      value: 'AO',
    },
    {
      name: 'Андорра',
      value: 'AD',
    },
    {
      name: 'Антарктида',
      value: 'AQ',
    },
    {
      name: 'Антигуа и Барбуда',
      value: 'AG',
    },
    {
      name: 'Аргентина',
      value: 'AR',
    },
    {
      name: 'Армения',
      value: 'AM',
    },
    {
      name: 'Аруба',
      value: 'AW',
    },
    {
      name: 'Афганистан',
      value: 'AF',
    },
    {
      name: 'Багамы',
      value: 'BS',
    },
    {
      name: 'Бангладеш',
      value: 'BD',
    },
    {
      name: 'Барбадос',
      value: 'BB',
    },
    {
      name: 'Бахрейн',
      value: 'BH',
    },
    {
      name: 'Беларусь',
      value: 'BY',
    },
    {
      name: 'Белиз',
      value: 'BZ',
    },
    {
      name: 'Бельгия',
      value: 'BE',
    },
    {
      name: 'Бенин',
      value: 'BJ',
    },
    {
      name: 'Бермуды',
      value: 'BM',
    },
    {
      name: 'Болгария',
      value: 'BG',
    },
    {
      name: 'Боливия',
      value: 'BO',
    },
    {
      name: 'Бонэйр, Синт-Эстатиус и Саба',
      value: 'BQ',
    },
    {
      name: 'Босния и Герцеговина',
      value: 'BA',
    },
    {
      name: 'Ботсвана',
      value: 'BW',
    },
    {
      name: 'Бразилия',
      value: 'BR',
    },
    {
      name: 'Британская территория в Индийском океане',
      value: 'IO',
    },
    {
      name: 'Бруней',
      value: 'BN',
    },
    {
      name: 'Буркина-Фасо',
      value: 'BF',
    },
    {
      name: 'Бурунди',
      value: 'BI',
    },
    {
      name: 'Бутан',
      value: 'BT',
    },
    {
      name: 'Вануату',
      value: 'VU',
    },
    {
      name: 'Ватикан',
      value: 'VA',
    },
    {
      name: 'Великобритания',
      value: 'GB',
    },
    {
      name: 'Венгрия',
      value: 'HU',
    },
    {
      name: 'Венесуэла',
      value: 'VE',
    },
    {
      name: 'Виргинские Острова (Великобритания)',
      value: 'VG',
    },
    {
      name: 'Виргинские Острова (США)',
      value: 'VI',
    },
    {
      name: 'Внешние малые острова (США)',
      value: 'UM',
    },
    {
      name: 'Восточный Тимор',
      value: 'TL',
    },
    {
      name: 'Вьетнам',
      value: 'VN',
    },
    {
      name: 'Габон',
      value: 'GA',
    },
    {
      name: 'Гаити',
      value: 'HT',
    },
    {
      name: 'Гайана',
      value: 'GY',
    },
    {
      name: 'Гамбия',
      value: 'GM',
    },
    {
      name: 'Гана',
      value: 'GH',
    },
    {
      name: 'Гваделупа',
      value: 'GP',
    },
    {
      name: 'Гватемала',
      value: 'GT',
    },
    {
      name: 'Гвинея',
      value: 'GN',
    },
    {
      name: 'Гвинея-Бисау',
      value: 'GW',
    },
    {
      name: 'Германия',
      value: 'DE',
    },
    {
      name: 'Гернси',
      value: 'GG',
    },
    {
      name: 'Гибралтар',
      value: 'GI',
    },
    {
      name: 'Гондурас',
      value: 'HN',
    },
    {
      name: 'Гонконг',
      value: 'HK',
    },
    {
      name: 'Гренада',
      value: 'GD',
    },
    {
      name: 'Гренландия',
      value: 'GL',
    },
    {
      name: 'Греция',
      value: 'GR',
    },
    {
      name: 'Грузия',
      value: 'GE',
    },
    {
      name: 'Гуам',
      value: 'GU',
    },
    {
      name: 'Дания',
      value: 'DK',
    },
    {
      name: 'Демократическая Республика Конго',
      value: 'CD',
    },
    {
      name: 'Джерси',
      value: 'JE',
    },
    {
      name: 'Джибути',
      value: 'DJ',
    },
    {
      name: 'Доминика',
      value: 'DM',
    },
    {
      name: 'Доминиканская Республика',
      value: 'DO',
    },
    {
      name: 'Египет',
      value: 'EG',
    },
    {
      name: 'Замбия',
      value: 'ZM',
    },
    {
      name: 'Западная Сахара',
      value: 'EH',
    },
    {
      name: 'Зимбабве',
      value: 'ZW',
    },
    {
      name: 'Израиль',
      value: 'IL',
    },
    {
      name: 'Индия',
      value: 'IN',
    },
    {
      name: 'Индонезия',
      value: 'ID',
    },
    {
      name: 'Иордания',
      value: 'JO',
    },
    {
      name: 'Ирак',
      value: 'IQ',
    },
    {
      name: 'Иран',
      value: 'IR',
    },
    {
      name: 'Ирландия',
      value: 'IE',
    },
    {
      name: 'Исландия',
      value: 'IS',
    },
    {
      name: 'Испания',
      value: 'ES',
    },
    {
      name: 'Италия',
      value: 'IT',
    },
    {
      name: 'Йемен',
      value: 'YE',
    },
    {
      name: 'Кабо-Верде',
      value: 'CV',
    },
    {
      name: 'Казахстан',
      value: 'KZ',
    },
    {
      name: 'Камбоджа',
      value: 'KH',
    },
    {
      name: 'Камерун',
      value: 'CM',
    },
    {
      name: 'Канада',
      value: 'CA',
    },
    {
      name: 'Катар',
      value: 'QA',
    },
    {
      name: 'Кения',
      value: 'KE',
    },
    {
      name: 'Кипр',
      value: 'CY',
    },
    {
      name: 'Кирибати',
      value: 'KI',
    },
    {
      name: 'Китай',
      value: 'CN',
    },
    {
      name: 'Кокосовые острова',
      value: 'CC',
    },
    {
      name: 'Колумбия',
      value: 'CO',
    },
    {
      name: 'Коморы',
      value: 'KM',
    },
    {
      name: 'Косово',
      value: 'XK',
    },
    {
      name: 'Коста-Рика',
      value: 'CR',
    },
    {
      name: 'Кот-д’Ивуар',
      value: 'CI',
    },
    {
      name: 'Куба',
      value: 'CU',
    },
    {
      name: 'Кувейт',
      value: 'KW',
    },
    {
      name: 'Кыргызстан',
      value: 'KG',
    },
    {
      name: 'Кюрасао',
      value: 'CW',
    },
    {
      name: 'Лаос',
      value: 'LA',
    },
    {
      name: 'Латвия',
      value: 'LV',
    },
    {
      name: 'Лесото',
      value: 'LS',
    },
    {
      name: 'Либерия',
      value: 'LR',
    },
    {
      name: 'Ливан',
      value: 'LB',
    },
    {
      name: 'Ливия',
      value: 'LY',
    },
    {
      name: 'Литва',
      value: 'LT',
    },
    {
      name: 'Лихтенштейн',
      value: 'LI',
    },
    {
      name: 'Люксембург',
      value: 'LU',
    },
    {
      name: 'Маврикий',
      value: 'MU',
    },
    {
      name: 'Мавритания',
      value: 'MR',
    },
    {
      name: 'Мадагаскар',
      value: 'MG',
    },
    {
      name: 'Майотта',
      value: 'YT',
    },
    {
      name: 'Макао',
      value: 'MO',
    },
    {
      name: 'Малави',
      value: 'MW',
    },
    {
      name: 'Малайзия',
      value: 'MY',
    },
    {
      name: 'Мали',
      value: 'ML',
    },
    {
      name: 'Мальдивы',
      value: 'MV',
    },
    {
      name: 'Мальта',
      value: 'MT',
    },
    {
      name: 'Марокко',
      value: 'MA',
    },
    {
      name: 'Мартиника',
      value: 'MQ',
    },
    {
      name: 'Маршалловы Острова',
      value: 'MH',
    },
    {
      name: 'Мексика',
      value: 'MX',
    },
    {
      name: 'Микронезия',
      value: 'FM',
    },
    {
      name: 'Мозамбик',
      value: 'MZ',
    },
    {
      name: 'Молдова',
      value: 'MD',
    },
    {
      name: 'Монако',
      value: 'MC',
    },
    {
      name: 'Монголия',
      value: 'MN',
    },
    {
      name: 'Монтсеррат',
      value: 'MS',
    },
    {
      name: 'Мьянма',
      value: 'MM',
    },
    {
      name: 'Намибия',
      value: 'NA',
    },
    {
      name: 'Науру',
      value: 'NR',
    },
    {
      name: 'Непал',
      value: 'NP',
    },
    {
      name: 'Нигер',
      value: 'NE',
    },
    {
      name: 'Нигерия',
      value: 'NG',
    },
    {
      name: 'Нидерланды',
      value: 'NL',
    },
    {
      name: 'Никарагуа',
      value: 'NI',
    },
    {
      name: 'Ниуэ',
      value: 'NU',
    },
    {
      name: 'Новая Зеландия',
      value: 'NZ',
    },
    {
      name: 'Новая Каледония',
      value: 'NC',
    },
    {
      name: 'Норвегия',
      value: 'NO',
    },
    {
      name: 'ОАЭ',
      value: 'AE',
    },
    {
      name: 'Оман',
      value: 'OM',
    },
    {
      name: 'Остров Буве',
      value: 'BV',
    },
    {
      name: 'Остров Мэн',
      value: 'IM',
    },
    {
      name: 'Остров Норфолк',
      value: 'NF',
    },
    {
      name: 'Остров Рождества',
      value: 'CX',
    },
    {
      name: 'Острова Кайман',
      value: 'KY',
    },
    {
      name: 'Острова Кука',
      value: 'CK',
    },
    {
      name: 'Острова Питкэрн',
      value: 'PN',
    },
    {
      name: 'Острова Святой Елены, Вознесения и Тристан-да-Кунья',
      value: 'SH',
    },
    {
      name: 'Пакистан',
      value: 'PK',
    },
    {
      name: 'Палау',
      value: 'PW',
    },
    {
      name: 'Палестина',
      value: 'PS',
    },
    {
      name: 'Панама',
      value: 'PA',
    },
    {
      name: 'Папуа — Новая Гвинея',
      value: 'PG',
    },
    {
      name: 'Парагвай',
      value: 'PY',
    },
    {
      name: 'Перу',
      value: 'PE',
    },
    {
      name: 'Польша',
      value: 'PL',
    },
    {
      name: 'Португалия',
      value: 'PT',
    },
    {
      name: 'Пуэрто-Рико',
      value: 'PR',
    },
    {
      name: 'Республика Конго',
      value: 'CG',
    },
    {
      name: 'Реюньон',
      value: 'RE',
    },
    {
      name: 'Россия',
      value: 'RU',
    },
    {
      name: 'Руанда',
      value: 'RW',
    },
    {
      name: 'Румыния',
      value: 'RO',
    },
    {
      name: 'Сальвадор',
      value: 'SV',
    },
    {
      name: 'Самоа',
      value: 'WS',
    },
    {
      name: 'Сан-Марино',
      value: 'SM',
    },
    {
      name: 'Сан-Томе и Принсипи',
      value: 'ST',
    },
    {
      name: 'Саудовская Аравия',
      value: 'SA',
    },
    {
      name: 'Северная Корея',
      value: 'KP',
    },
    {
      name: 'Северная Македония',
      value: 'MK',
    },
    {
      name: 'Северные Марианские Острова',
      value: 'MP',
    },
    {
      name: 'Сейшельские Острова',
      value: 'SC',
    },
    {
      name: 'Сен-Бартелеми',
      value: 'BL',
    },
    {
      name: 'Сен-Мартен',
      value: 'MF',
    },
    {
      name: 'Сен-Пьер и Микелон',
      value: 'PM',
    },
    {
      name: 'Сенегал',
      value: 'SN',
    },
    {
      name: 'Сент-Винсент и Гренадины',
      value: 'VC',
    },
    {
      name: 'Сент-Китс и Невис',
      value: 'KN',
    },
    {
      name: 'Сент-Люсия',
      value: 'LC',
    },
    {
      name: 'Сербия',
      value: 'RS',
    },
    {
      name: 'Сингапур',
      value: 'SG',
    },
    {
      name: 'Синт-Мартен',
      value: 'SX',
    },
    {
      name: 'Сирия',
      value: 'SY',
    },
    {
      name: 'Словакия',
      value: 'SK',
    },
    {
      name: 'Словения',
      value: 'SI',
    },
    {
      name: 'Соломоновы Острова',
      value: 'SB',
    },
    {
      name: 'Сомали',
      value: 'SO',
    },
    {
      name: 'Судан',
      value: 'SD',
    },
    {
      name: 'Суринам',
      value: 'SR',
    },
    {
      name: 'США',
      value: 'US',
    },
    {
      name: 'Сьерра-Леоне',
      value: 'SL',
    },
    {
      name: 'Таджикистан',
      value: 'TJ',
    },
    {
      name: 'Таиланд',
      value: 'TH',
    },
    {
      name: 'Тайвань',
      value: 'TW',
    },
    {
      name: 'Танзания',
      value: 'TZ',
    },
    {
      name: 'Теркс и Кайкос',
      value: 'TC',
    },
    {
      name: 'Того',
      value: 'TG',
    },
    {
      name: 'Токелау',
      value: 'TK',
    },
    {
      name: 'Тонга',
      value: 'TO',
    },
    {
      name: 'Тринидад и Тобаго',
      value: 'TT',
    },
    {
      name: 'Тувалу',
      value: 'TV',
    },
    {
      name: 'Тунис',
      value: 'TN',
    },
    {
      name: 'Туркменистан',
      value: 'TM',
    },
    {
      name: 'Турция',
      value: 'TR',
    },
    {
      name: 'Уганда',
      value: 'UG',
    },
    {
      name: 'Узбекистан',
      value: 'UZ',
    },
    {
      name: 'Украина',
      value: 'UA',
    },
    {
      name: 'Уоллис и Футуна',
      value: 'WF',
    },
    {
      name: 'Уругвай',
      value: 'UY',
    },
    {
      name: 'Фареры',
      value: 'FO',
    },
    {
      name: 'Фиджи',
      value: 'FJ',
    },
    {
      name: 'Филиппины',
      value: 'PH',
    },
    {
      name: 'Финляндия',
      value: 'FI',
    },
    {
      name: 'Фолклендские острова',
      value: 'FK',
    },
    {
      name: 'Франция',
      value: 'FR',
    },
    {
      name: 'Французская Гвиана',
      value: 'GF',
    },
    {
      name: 'Французская Полинезия',
      value: 'PF',
    },
    {
      name: 'Французские Южные и Антарктические Территории',
      value: 'TF',
    },
    {
      name: 'Херд и Макдональд',
      value: 'HM',
    },
    {
      name: 'Хорватия',
      value: 'HR',
    },
    {
      name: 'ЦАР',
      value: 'CF',
    },
    {
      name: 'Чад',
      value: 'TD',
    },
    {
      name: 'Черногория',
      value: 'ME',
    },
    {
      name: 'Чехия',
      value: 'CZ',
    },
    {
      name: 'Чили',
      value: 'CL',
    },
    {
      name: 'Швейцария',
      value: 'CH',
    },
    {
      name: 'Швеция',
      value: 'SE',
    },
    {
      name: 'Шпицберген и Ян-Майен',
      value: 'SJ',
    },
    {
      name: 'Шри-Ланка',
      value: 'LK',
    },
    {
      name: 'Эквадор',
      value: 'EC',
    },
    {
      name: 'Экваториальная Гвинея',
      value: 'GQ',
    },
    {
      name: 'Эритрея',
      value: 'ER',
    },
    {
      name: 'Эсватини',
      value: 'SZ',
    },
    {
      name: 'Эстония',
      value: 'EE',
    },
    {
      name: 'Эфиопия',
      value: 'ET',
    },
    {
      name: 'ЮАР',
      value: 'ZA',
    },
    {
      name: 'Южная Георгия и Южные Сандвичевы Острова',
      value: 'GS',
    },
    {
      name: 'Южная Корея',
      value: 'KR',
    },
    {
      name: 'Южный Судан',
      value: 'SS',
    },
    {
      name: 'Ямайка',
      value: 'JM',
    },
    {
      name: 'Япония',
      value: 'JP',
    },
  ],
  depressionScreen: {
    dynamics: 'Динамика результатов',
    level: 'Уровень депрессии',
    newTest: 'Пройти новый опросник',
    phq9Info:
      'PHQ-9 (Опросник по состоянию здоровья-9) представляет собой многоцелевой инструмент для скрининга, диагностики, мониторинга и измерения тяжести депрессии. PHQ-9 продемонстрировал хорошую надежность и валидность. Это простой, быстрый, эффективный и надежный инструмент для скрининга и оценки тяжести депрессии.',
  },
  downgradeDetectedModal: {
    contactTherapist:
      'Если полный доступ был предоставлен Вам через специалиста/поставщика услуг в области психического здоровья, свяжитесь с ним, чтобы восстановить доступ.',
    contactSupport:
      'Если Вы считаете, что произошла ошибка, обратитесь в службу поддержки по адресу:',
    downgrade: 'Ограничить функционал',
    notificationsTurnOff:
      'Некоторые из Ваших уведомлений и напоминаний будут отключены.',
    pay: 'Сохранить функционал',
    text: 'Ваша подписка больше не действительна. Если Вы не подпишетесь снова, платные функции будут отключены. В частности, Вы потеряете доступ к:',
    title: 'Подписка недействительна',
  },
  errorModal: {
    clientErrors: 'Ошибки приложения',
    code: 'Код',
    contact:
      'Попробуйте еще раз или перезагрузите приложение. Если это не решит проблему, свяжитесь с нами по адресу:',
    contactCodeLabel: 'Код для поддержки',
    extraInfo: 'Дополнительная информация',
    graphqlAuthorizationError: 'Сейчас у Вас нет доступа к этому разделу.',
    graphqlErrors: 'Ошибки Graphq',
    graphqlRequestError: 'Не удалось выполнить Ваш запрос.',
    location: 'Где',
    message: `Сообщение`,
    name: 'Название',
    network: 'Сетевая ошибка',
    networkRequestError: 'Ошибка сетевого запроса',
    offlineBody: 'Проверьте соединение и попробуйте ещё раз.', // RU approved by the founder 2026-09-13
    offlineTitle: 'Нет подключения к интернету', // RU approved by the founder 2026-09-13
    path: 'Путь',
    reminderSaveError:
      'Не удалось сохранить напоминание. Пожалуйста, попробуйте ещё раз. Если ошибка повторяется, напишите на support@copingcard.com.',
    title: `Ой! Произошла ошибка.`,
    tokenExpiredTitle: 'Ваша сессия истекла',
    tokenError:
      'Ваш токен недействителен или просрочен. Пожалуйста, войдите в приложение снова.',
    tokenSettings:
      'Вы можете управлять настройками входа в Настройках -> Настройки конфиденциальности',
    unreachableBody:
      'Пожалуйста, попробуйте ещё раз через минуту. Если ошибка повторяется, напишите на support@copingcard.com.', // RU approved by the founder 2026-09-13
    unreachableTitle: 'Не удалось связаться с нашим сервером', // RU approved by the founder 2026-09-13
  },
  confirmModal: {
    cancelButton: 'Отменить',
    confirmButton: 'Подтвердить',
  },
  crisis: {
    crisisText: `Если Вы испытываете психологический кризис и нуждаетесь в немедленной помощи, пожалуйста, свяжитесь с кризисной линией Вашей страны или региона.`,
    courage:
      'Помните, что для того, чтобы обратиться за помощью, требуется мужество, и нет ничего постыдного в том, чтобы искать поддержки для своего психического здоровья. Вы не одиноки, и есть люди и ресурсы, которые помогут Вам в это трудное время.',
    findCrisisLine: 'найти кризисную линию',
    selfHelp: 'Самопомощь',
    mammalianText:
      'Рефлекс ныряния млекопитающих — это физиологическая реакция, возникающая у млекопитающих, в том числе у человека, когда они погружаются в воду. Этот рефлекс вызывает ряд автоматических изменений в организме, в том числе снижение частоты сердечных сокращений и сужение кровеносных сосудов, чтобы сохранить кислород и обеспечить длительные периоды подводной активности. В то время как рефлекс ныряния у млекопитающих обычно ассоциируется с нырянием и плаванием, недавние исследования показывают, что преднамеренное срабатывание этого рефлекса с помощью таких практик, как погружение в холодную воду или задержка дыхания, может помочь облегчить симптомы тревоги и стресса.',
    instructionsLink: 'Читать инструкцию',
    muscleRelaxationTitle: 'Прогрессивная мышечная релаксация по Джекобсону',
    muslceRelaxationText:
      'Прогрессивная мышечная релаксация — это техника релаксации, разработанная врачом Эдмундом Джекобсоном в начале 20 века, которая включает в себя систематическое напряжение и расслабление различных групп мышц тела. Техника предназначена для того, чтобы помочь людям распознать и снять физическое напряжение в теле, что, в свою очередь, может уменьшить чувство тревоги и стресса. Исследования показали, что регулярная практика прогрессивной мышечной релаксации может привести к значительному снижению тревожности и связанных с ней симптомов, а также к улучшению качества сна и общего самочувствия.',

    technique54321Text:
      'Техника 5-4-3-2-1 — это простое упражнение на осознанность, которое можно использовать для уменьшения чувства тревоги и стресса. Техника включает в себя задействование каждого из органов чувств, чтобы «заземлиться» в настоящем моменте и отвлечься от тревожных мыслей. Это делается путем определения и сосредоточения на пяти вещах, которые Вы можете видеть, четырех вещах, которые Вы можете потрогать, трех вещах, которые Вы можете услышать, двух вещах, которые Вы можете обонять, и одной вещи, которую Вы можете попробовать. Сосредоточившись на сенсорных переживаниях в настоящий момент, люди могут переключить свое внимание с тревожных мыслей на настоящий момент, что приводит к уменьшению чувства тревоги и стресса.',
    goToTool: 'Перейти к инструменту',
    meditationsText:
      'Медитация осознанности — это техника, которая включает в себя намеренное сосредоточение внимания на переживаниях настоящего момента, таких как мысли, эмоции и ощущения, без осуждения. Доказано, что регулярная практика медитации осознанности оказывает ряд благотворных эффектов на психическое здоровье, в том числе уменьшает симптомы тревоги и стресса. Считается, что это связано с тем, что медитация осознанности может помочь людям развить большее осознание и принятие своих мыслей и эмоций, что приводит к снижению склонности зацикливаться на негативных моделях мышления и размышлениях. Кроме того, было показано, что медитация осознанности оказывает положительное влияние на функционирование мозга, приводя к усилению эмоциональной регуляции и снижению реакции на стрессоры.',
    goToMediations: 'Перейти к Медитациям',
    entryNote: 'То, что Вы пишете здесь, не отслеживается в реальном времени.',
    entryNoteLink: 'Кризисные линии и техники',
  },

  urgentCrisis: {
    internationlHelp:
      'Если Вы находитесь в другой стране, Вы можете найти список кризисных линий в Вашей стране на сайте',
    internationlHelpOutsideUS: 'За пределами США список кризисных линий для Вашей страны можно найти на сайте',
    internationlHelpName:
      'Международной ассоциации по предотвращению самоубийств',
    ifUS: 'Если Вы находитесь в США, позвоните по номеру:',
    orText: 'или отправьте SMS на номер',
    orChat: 'или пообщайтесь в чате',
    pleaseCall: 'позвоните по номеру:',
    ifBY: 'Если Вы в Беларуси,',
    ifUA: 'Если Вы в Украине,',
    ifRU: 'Если Вы в России,',
    ifKZ: 'Если Вы в Казахстане,',
    ifKG: 'Если Вы в Кыргызстане,',
    ifLV: 'Если Вы в Латвии,',
    ifLT: 'Если Вы в Литве,',
    ifAM: 'Если Вы в Армении, по будням 9:00–18:00,',
    ifEE: 'Если Вы в Эстонии, ежедневно 10:00–24:00,',
    ifEERu: 'В Эстонии, на русском языке, с 19:00 до 7:00,',
    shortNumbersNote: 'Короткие номера работают только с телефона в этой стране.',
    pickerTitle: 'Ваша страна',
    pickerHint:
      'Выберите Вашу страну, и её кризисные линии будут первыми в списке. Эти данные остаются только на этом телефоне и никуда не отправляются.',
    pickerOthers: 'Другие страны',
    pickerSearch: 'Поиск страны',
    pickerNoMatch: 'Подходящих стран не найдено.',
    pickerClose: 'Закрыть',
    helplineIn: 'Ваша страна: {{country}}. Кризисные линии для неё собраны в',
    helplineLink: 'справочнике Find A Helpline',
    findCrisisLine: 'найдите список кризисных линий',
  },
  mammalianReflex: {
    warning:
      '⚠️ Противопоказания! Активация рефлекса ныряльщика замедляет частоту сердечных сокращений. Людям с кардиологическими проблемами (в частности, с брадикардией) следует избегать этой стратегии. Не используйте эту стратегию, если у Вас подобные проблемы, либо если Вы не уверены в том, есть ли они у Вас. Проконсультируйтесь с Вашим врачом перед использованием.',
    instructions: 'Инструкции',
    details: `Когда мы находимся в состоянии крайнего эмоционального возбуждения, наш мозг не функционирует должным образом, чтобы эффективно воспринимать новую информацию и обрабатывать ее. Необходимо «перезагрузить» нервную систему!\n
Как можно помочь себе, если, находясь в эмоциональном возбуждении, Вы осознаете, что нужно успокоиться, но внутренних ресурсов не хватает, а советы "успокоиться" только раздражают?\n
👉 Вариантом решения этой задачи является использование доступного каждому млекопитающему психофизиологического эффекта, который называется "рефлекс ныряльщика".\n
Как активировать рефлекс:
➡️ наполняем миску ледяной водой (10 градусов по Цельсию)
➡️ наклоняемся и задерживаем дыхание
➡️ опускаем лицо в ледяную воду на 30 секунд
➡️ проверьте: область под глазами/над скулами (самая чувствительная часть лица) должна чувствовать ледяную воду\n
Эти элементарные действия заставляют включаться парасимпатическую нервную систему - человек расслабляется и успокаивается😇\n
✅ Лайфхак: прием лучше всего работает, если задержать дыхание и наклониться на 30 секунд.
    `,
  },

  technique54321: {
    title: '5-4-3-2-1 Техника заземления',
    instructions: `Техника 5-4-3-2-1 — это упражнение на «заземление», которое может помочь Вам уменьшить тревогу и почувствовать себя в настоящем моменте. Вот шаги, которые необходимо выполнить:\n
Найдите тихое и удобное место, чтобы комфортно сидеть или стоять.\n
Сделайте пять глубоких вдохов/выдохов. Вдыхая, представляйте, что Вы наполняете легкие спокойствием, а выдыхая, представляйте, что освобождаетесь от любого напряжения или беспокойства.\n
5. Затем оглянитесь вокруг и определите пять вещей, которые можно рассмотреть. Это могут быть предметы в комнате или снаружи, все, что Вы видите вокруг себя. Сосредоточьтесь на каждом предмете и попытайтесь рассмотреть его форму, цвет, текстуру и любые другие детали, которые Вы заметите.\n
4. Затем выберите четыре вещи, которые Вы можете потрогать или почувтсвовать. Это может быть текстура Вашей одежды, ощущение Ваших ног на земле, температура воздуха вокруг Вас или что-то еще, что Вы можете физически ощутить. Обратите внимание на каждое ощущение и постарайтесь описать его себе как можно подробнее.\n
3. Затем выберите три вещи, которые Вы можете услышать. Это может быть шум уличного движения, гул компьютера, шелест листьев на ветру или что-то еще, что Вы можете услышать. Сосредоточьтесь на каждом звуке и постарайтесь различить паттерны, ритмы или тона, которые Вы замечаете.\n
2. Затем выберите два аромата, которые Вы можете почувствовать. Это может быть запах цветов, пищи, духи или что-то еще. Сделайте глубокий вдох и постарайтесь сосредоточиться на запахе.\n
1. Наконец, определите одну вещь, которую Вы можете попробовать на вкус. Это может быть вкус Вашей любимой еды, напитка и т.д. Потратьте немного времени, чтобы насладиться вкусом и сосредоточиться на нем.\n
К концу этого упражнения Вы должны чувствовать себя более «заземленными», сосредоточенными и присутствующими в настоящем моменте. Это отличный способ отдохнуть от негативных мыслей и беспокойства и почувствовать большую связь с окружающим миром.
    `,
  },
  muscleRelaxation: {
    videoTitle: 'Смотреть видео с инструкциями',
    readTitle: 'Читать инструкции',
    videoId: 'y_Y-RrUhJH4',
    phasesAndStepsTitle: 'Фазы и Шаги',
    phasesAndStepsText: `Метод прогрессивной мышечной релаксации по Джекобсону устраняет тревогу в стрессовых ситуациях. Процесс расслабления проходит следующие фазы.\n
1. Попытка к расслаблению.
2. Расслабление.
3. Наблюдение за процессом перехода от напряжения к расслаблению.
4. «Переживание» расслабления.\n\n
Расслабление происходит поэтапно.
Расслабление мышц рук.
Расслабление мышц лица.
Расслабление мышц шеи и спины.
Расслабление мышц нижней части тела.
Каждому шагу расслабления соответствуют специфические упражнения.\n
Овладение этими приемами расслабления поможет в кратчайшие сроки восстановить нервно-психическое равновесие, почувствовать себя отдохнувшими и полными сил.
    `,
    armsTitle: 'Расслабление мышц рук (4-5 минут)',
    armsText: `Устройтесь поудобнее (сидя или лежа).

Расслабьтесь, насколько можете. При полном расслаблении сожмите кулак правой руки, при этом контролируйте степень сжатия, почувствуйте напряжение мышц кисти, предплечья — разожмите кулак и почувствуйте расслабление. Сравните свои ощущения.

Еще раз сожмите кулак как можно сильнее — держите. Разожмите кулак, попытайтесь достичь глубокого расслабления. Срав­ните Ваши ощущения.

Повторите все левой рукой. В это время все тело остается полностью расслабленным.

Сожмите пальцы обеих рук в кулак.

Почувствуйте напряжение пальцев, предплечья.

Разожмите пальцы, расслабьтесь. Сравните Ваши ощущения. Продолжайте расслабление.

Согните правую руку в локте и напрягите бицепс.

Напрягите бицепс как можно сильнее, контролируйте напряже­ние бицепса.

Разогните локоть, расслабьте бицепс и почувствуйте разницу. Попытайтесь максимально почувствовать расслабление бицепса.

Еще раз напрягите бицепс, поддерживайте напряжение, почув­ствуйте степень напряжения.

Расслабьтесь полностью. Сравните Ваши ощущения.

Постоянно сосредоточивайте Ваше внимание на ощущениях при напряжении и расслаблении.

Повторите то же самое левой рукой.

Повторите то же самое одновременно двумя руками.

Меняйте степень и длительность напряжения мышц перед рас­слаблением. Сравните Ваши ощущения. Вытяните руки вперед и почувствуйте напряжение трицепса. Верните руки в исходное положение, расслабьтесь, почувствуйте разницу в ощущениях.

Повторите еще раз. Еще раз сравните Ваши ощущения. Теперь попытайтесь полностью расслабить мышцы рук без пред­варительного напряжения.

Продолжайте расслабляться больше и больше, достигайте более глубокого расслабления.

Отметьте ощущения тепла и тяжести в руках по мере расслабления. Руки расслабленные и тяжелые... расслабленные и тяжелые.
`,
    faceTitle: 'Расслабление мышц лица (4-5 минут)',
    faceText: `Наморщите лоб, поднимите брови.

Наморщите лоб сильнее... и расслабьте.

Сдвиньте брови и отметьте напряжение.

Расслабьте и разгладьте брови.

Сильно зажмурьте глаза, ощущайте напряжение... и расслабьтесь, не открывая глаз.

Почувствуйте расслабление мышц лба, глаз.

Крепко сожмите зубы, напрягите челюсти. Почувствуйте напряжение челюстей.

Расслабьтесь, чуть-чуть приоткройте рот.

Крепко прижмите язык к верхнему небу. Ощущайте напряжение языка...и расслабьте, опустив язык.

Округлите губы, как будто Вы хотите произнести букву “о”, расслабьтесь.

Почувствуйте разницу между напряжением и расслаблением.

Ощутите расслабление всех мышц Вашего лица: лоб, глаза, челюсти, язык расслабляются. Расслабьтесь полностью.

Ощутите тепло и тяжесть во всех мышцах лица.
`,
    neckTitle: 'Расслабление мышц шеи и спины (4-5 минут)',
    neckText: `Сконцентрируйте внимание на мышцах шеи.

Наклоните голову назад как можно сильнее, ощутите напряжение шеи.

Поверните голову налево до отказа. Отметьте напряжение.

Поверните голову направо до отказа, почувствуйте напряжение.

Верните голову в исходное положение.

Расслабьтесь. Сравните Ваши ощущения.

Наклоните голову вперед, коснитесь подбородком груди. Почувствуйте напряжение шеи. Верните голову в исходное положение.

Расслабьтесь, почувствуйте тепло и расслабление.

Поднимите плечи к ушам, сведите лопатки, не напрягая при этом рук. Сделайте круговое движение плечами с максимальной амплитудой.

Верните плечи в исходное положение. Расслабьтесь. Ощутите приятный контраст между напряжением и расслаблением.

Выгните позвоночник дугой и ощутите напряжение вдоль позвоночника.

Вернитесь в исходное положение. Почувствуйте расслабление, оно разливается по всей спине.

Спина тяжелая и теплая. Ощутите приятное тепло...
`,
    legsTitle: 'Расслабление нижней части тела (4-5 минут)',
    legsText: `Сконцентрируйте внимание на нижней части тела.

Напрягите ягодицы и бедра, крепко прижав пятки к опоре.

Расслабьтесь... Отметьте разницу в ощущениях.

Еще раз напрягите ягодицы и бедра.

Сохраняйте их в напряженном состоянии.

Сохраняя напряжение в ягодицах и бедрах, согните ступни, носки — на себя, ощутите напряжение икроножных мышц.

Расслабьтесь. Еще глубже... глубже.

Почувствуйте расслабление всех мышц нижней части Вашего тела.

Отметьте, как Ваши ноги тяжелеют по мере расслабления. Ноги расслабленны и тяжелы.

Ощутите тепло, распространяющееся по Вашим ногам.

Ноги тяжелые и теплые.
    `,
    summary: `Как только Вы закончите всю последовательность, сделайте несколько глубоких вдохов и просканируйте свое тело на наличие оставшихся областей напряжения.

Если Вы обнаружите какие-либо области, которые все еще напряжены, повторите упражнение на расслабление этих мышц.

Закончив, сделайте еще несколько глубоких вдохов и медленно откройте глаза.

Регулярно практикуя прогрессивную мышечную релаксацию, Вы сможете лучше осознавать свое тело и научиться распознавать, когда Вы удерживаете напряжение в мышцах. Эта техника может помочь Вам уменьшить стресс и способствовать расслаблению в Вашей повседневной жизни.
    `,
  },

  fBConsentModal: {
    agreeButton: 'Принять и использовать Facebook',
    cancelButton: 'Отмена',
    text: 'Нам нужно Ваше согласие, чтобы разрешить инициализацию Facebook SDK и ведение журнала событий, чтобы использовать Facebook для регистрации или входа в систему.',
    title: 'Использование Facebook SDK',
  },

  flippingCard: {
    automaticThought: 'Автоматическая мысль',
    cardName: 'Название карточки',
    categoriesSelectText: 'Выберите категории для мысли',
    editEvent: 'Перейти к активирующему событию',
    realisticThoughts: 'Реалистичные мысли',
    supportingThoughts: 'Поддерживающие мысли',
    confirmCardDeleteTitle: 'Удаление карточки',
    confirmCardDeleteText: `Вы уверены, что хотите удалить эту карточку?

  Карточка будет удалена без возможности восстановления вместе с соответствующим анализом мыслей, напоминаниями по времени и геолокационными уведомлениями.
    `,
  },
  gad7: {
    q1: `Вы нервничали, тревожились или испытывали сильный стресс`,
    q2: `Вы были неспособны успокоиться или контролировать свое волнение`,
    q3: `Вы слишком сильно волновались по различным поводам`,
    q4: `Вам было трудно расслабиться`,
    q5: `Вы были настолько суетливы, что Вам было тяжело усидеть на месте`,
    q6: `Вы легко злились или раздражались`,
    q7: `Вы испытывали страх, словно должно произойти нечто ужасное`,
    score: `Оценка GAD-7`,
    severity: `Степень тревожности`,
    title: `ГЕНЕРАЛИЗОВАННОЕ ТРЕВОЖНОЕ РАССТРОЙСТВО-7 (GAD-7)`,
  },
  insights: {
    cardsFlipped: 'Просмотренных копинг-карточек',
    dayRemindersTitle: 'Использование напоминаний по времени',
    emptyStateDescription:
      'Пользуйтесь копинг-карточками и напоминаниями немного дольше, а затем снова откройте Insights, чтобы увидеть здесь динамику активности.',
    emptyStateTitle: 'Пока недостаточно активности',
    locationRemindersTitle: 'Использование геолокационных напоминаний',
    missingCardDescription:
      'Эта карточка больше недоступна, но ее прошлое использование по-прежнему учитывается в истории Insights.',
    missingCardTitle: 'Карточка недоступна',
    mostUsedCards: 'Самые используемые карточки',
    opened: 'Открытые',
    triggered: 'Сработавшие',
    triggeredOpenedRatio: 'Процент открытых из сработавших',
    meditationsTitle: 'Прослушано медитаций',
  },
  inviteTherapistModal: {
    recipientLanguage: 'Язык получателя',
    title: 'Пригласить специалиста в области психического здоровья',
    description:
      'Пригласите Вашего психолога/психотерапевта присоединиться к психотерапевтической платформе CopingCard, чтобы Вы могли поделиться с ним своими данными, чтобы сделать Вашу терапию более эффективной.',
    noName:
      'Похоже, Вы еще не добавили свое имя. Пожалуйста, введите свое имя, чтобы мы могли упомянуть его в электронном письме с приглашением.',
    yourName: 'Ваше имя',
    yourLastName: 'Ваша фамилия',
    therapistInfo: 'Информация о специалисте по психическому здоровью',
    firstName: 'Имя',
    lastName: 'Фамилия',
    therapistEmail: 'Емейл',
    sendInvite: 'Отправить приглашение',
    emailText: 'Текст приглашения, который будет отправлен',

    inviteText: `
Здравствуйте, {{firstName}} {{lastName}}!
{{yourName}} {{yourLastName}} приглашает Вас присоединиться к психотерапевтической платформе CopingCard.

Нажмите на ссылку выше, чтобы принять приглашение и/или создать учетную запись и принять приглашение.

Это позволит эффективно обмениваться информацией и прогрессом во время терапии.

С уважением,
Команда CopingCard, Inc.
`,
    inviteTextHtml: `
    <p>Здравствуйте, {{firstName}} {{lastName}}!</p>
    <p>{{yourName}} {{yourLastName}} приглашает Вас присоединиться к платформе специалистов <b><a href="{{link}}">CopingCard</a></b>.
     <br />
     <p>Нажмите на ссылку выше, чтобы принять приглашение и/или создать учетную запись и принять приглашение.</p>
     <br />
     <p>Это позволит эффективно обмениваться информацией и прогрессом во время терапии.</p>
     <br />
    <p>С уважением,</p>
    <p>Команда CopingCard, Inc.</p>
`,
  },
  labels: {
    email: 'Емейл',
    password: 'Пароль',
  },
  locationReminders: {
    onApproaching: 'Уведомлять при приближении',
    onLeaving: 'Уведомлять при отдалении',
  },
  locationModal: {
    addLocation: 'Добавить местоположение',
    locationName: 'Название местоположения',
    savedLocations: 'Сохранённые местоположения',
    searchPlaceholder: 'Поиск',
    selectSavedLocation: 'Выбрать из сохранённых местоположений',
    waitingForLocation: 'Определение Вашего местоположения\u2026',
  },
  meditations: {
    loading:
      'Загрузка медитаций. Это может занять какое-то время при первой загрузке...',
    voice: {
      label: 'Голос',
      female: 'Женский',
      male: 'Мужской',
      both: 'Оба',
      cardFemale: 'Женский голос',
      cardMale: 'Мужской голос',
    },
  },
  navigation: {
    appBlockModalText:
      'Пользователь заблокировал приложение от получения уведомлений, что делает невозможным получение напоминаний. Разрешите получение в настройках для работы функционала напоминаний.',
    backButtonTitle: 'Назад',
    blockModalTitle: 'Обнаружены ограничения',
    channelBlockModalText:
      'Пользователь заблокировал канал уведомлений, что делает невозможным получение напоминаний. Разрешите получение в настройках для работы функционала напоминаний.',
    channelGroupBlockModalText:
      'Пользователь заблокировал группу каналов уведомлений, что делает невозможным получение напоминаний.',
    toCopingCards: 'Перейти к Копинг-картам',
  },
  notificationPermissionsModal: {
    settingText: 'Открыть настройки уведомлений',
    text: 'Вы отклонили или удалили разрешения на уведомления для CopingCard.',
    text1:
      'Без этих разрешений мы не сможем присылать Вам напоминания о повторениях мыслей.',
    text2:
      'Нажмите кнопку ниже, чтобы открыть настройки уведомлений, затем включите уведомления для CopingCard.',
    title: 'Нет разрешений для уведомлений!',
  },
  notifications: {
    locationReminderBody:
      'Сработало геолокационное напоминание для Вашей мысли',
    locationReminderTitle: 'Геолокационное напоминание',
    testReminderBody: 'Пришло время пройти запланированный опросник',
    testReminderTitle: 'Напоминание о запланированном опроснике',
    timeNotificationBody: 'Пришло время повторить Вашу новую мысль',
    timeNotificationTitle: 'Уведомление по времени',
    fineLocatonPermissionTitle: 'Разрешите получение геолокации',
    fineLocatonPermissionText:
      'Точное местоположение необходимо для отображения Вашего положения на карте.',
  },
  phq9: {
    q1: `Вам не хотелось ничего делать`,
    q2: `У Вас было плохое настроение, Вы были подавлены или испытывали чувство безысходности`,
    q3: `Вам было трудно заснуть, у Вас был прерывистый сон, или Вы слишком много спали`,
    q4: `Вы были утомлены, или у Вас было мало сил`,
    q5: `У Вас был плохой аппетит, или Вы переедали`,
    q6: `Вы плохо о себе думали: считали себя неудачником (неудачницей), или были в себе разочарованы, или считали, что подвели свою семью`,
    q7: `Вам было трудно сосредоточиться (например, на чтении газеты или на просмотре телепередач)`,
    q8: `Вы двигались или говорили настолько медленно, что окружающие это замечали? Или, наоборот, Вы были настолько суетливы или взбудоражены, что двигались гораздо больше обычного`,
    q9: `Вас посещали мысли о том, что Вам лучше было бы умереть, или о том, чтобы причинить себе какой-нибудь вред`,
    score: `Оценка PHQ-9`,
    severity: `Степень депрессии`,
    title: `ОПРОСНИК ПО СОСТОЯНИЮ ЗДОРОВЬЯ-9 (PHQ-9)`,
  },
  privacy: {
    lock: {
      open: 'Блокировка приложения',
      openHint: 'Открывайте CopingCard с помощью Face ID, отпечатка пальца или код-пароля',
      require: {
        faceId: 'Запрашивать Face ID',
        touchId: 'Запрашивать Touch ID',
        fingerprint: 'Запрашивать отпечаток пальца',
        iris: 'Запрашивать сканирование радужки',
        biometric: 'Запрашивать Face ID или отпечаток пальца',
        passcode: 'Запрашивать код-пароль телефона',
      },
      intro: 'Ваш дневник, карточки и планы останутся конфиденциальными, даже если телефон окажется в чужих руках.',
      lockAfter: 'Блокировать через',
      timeouts: {
        immediately: 'Сразу',
        min1: '1 мин',
        min5: '5 мин',
        min15: '15 мин',
      },
      reminders: 'Пока блокировка включена, в напоминаниях показывается только «Напоминание от CopingCard».',
      everything: 'Пока блокировка включена, всё в CopingCard открывается только после разблокировки. Виджет «Настроение» на главном экране по-прежнему сохраняет записи.',
      footer: 'Используются Face ID, отпечаток пальца или код-пароль, уже настроенные на телефоне. У CopingCard нет к ним доступа.',
      noPasscode: 'Сначала настройте код-пароль на телефоне. После этого можно будет включить блокировку приложения.',
      passcodeRemoved: 'На телефоне больше нет код-пароля, поэтому CopingCard открывается без блокировки. Чтобы снова использовать блокировку, установите код-пароль в настройках телефона.',
      prompt: 'Подтвердите, чтобы включить блокировку приложения',
      promptChange: 'Подтвердите, чтобы изменить настройки блокировки',
      checkFailed: 'Проверка не прошла. Попробуйте ещё раз.',
      saveError: 'Не удалось сохранить настройки блокировки. Проверьте подключение и попробуйте ещё раз.',
      off: {
        hint: {
          faceId: 'Подтвердите с помощью Face ID, чтобы отключить блокировку.',
          touchId: 'Подтвердите с помощью Touch ID, чтобы отключить блокировку.',
          fingerprint: 'Подтвердите отпечатком пальца, чтобы отключить блокировку.',
          iris: 'Подтвердите сканированием радужки, чтобы отключить блокировку.',
          biometric: 'Подтвердите с помощью Face ID или отпечатка пальца, чтобы отключить блокировку.',
          passcode: 'Подтвердите код-паролем телефона, чтобы отключить блокировку.',
        },
        prompt: 'Подтвердите, чтобы отключить блокировку приложения',
        error: 'Не удалось отключить блокировку приложения. Проверьте подключение и попробуйте ещё раз.',
      },
    },
    gate: {
      title: 'CopingCard заблокирован',
      hintFaceId: 'Посмотрите на телефон, чтобы разблокировать',
      hint: 'Разблокируйте, чтобы открыть CopingCard',
      unlock: {
        faceId: 'Разблокировать с помощью Face ID',
        touchId: 'Разблокировать с помощью Touch ID',
        fingerprint: 'Разблокировать по отпечатку пальца',
        iris: 'Разблокировать сканированием радужки',
        biometric: 'Разблокировать',
        passcode: 'Разблокировать с помощью код-пароля',
      },
      usePasscode: 'Ввести код-пароль',
      prompt: 'Разблокировать CopingCard',
    },
    reminder: {
      neutral: 'Напоминание от CopingCard',
      emailSubject: 'Напоминание от CopingCard',
      emailBody: 'Напоминание от CopingCard — откройте приложение.',
      emailAction: 'Открыть CopingCard',
    },
    errors: {
      APP_LOCK_TIMEOUT_INVALID: 'Выберите один из предложенных вариантов: сразу, 1, 5 или 15 минут.',
      APP_LOCK_NOT_ENABLED: 'Блокировка приложения уже отключена на этом телефоне.',
    },
  },
  privacySettings: {
    accept: 'Принять',
    agree: 'Принять и сохранить настройки',
    // E50 · запрос на удаление аккаунта в приложении (App Store 5.1.1(v))
    deleteTitle: 'Удалить аккаунт',
    deleteExplain:
      'Попросите нас удалить Ваш аккаунт и всё, что в нём есть: карточки, тесты мыслей, инструменты, напоминания, опросники и данные для входа. Мы удалим их в течение 30 дней.',
    deleteButton: 'Удалить аккаунт',
    deleteConfirmTitle: 'Удалить аккаунт?',
    deleteConfirmText:
      'Мы удалим Ваш аккаунт и все Ваши данные в течение 30 дней. Если Вы работали с терапевтом через CopingCard, его практика сохраняет собственные записи о совместной работе, включая любые формы согласия, подписанные Вашим именем. Это не отменяет подписку, оформленную в App Store или Google Play — отмените её в настройках магазина.',
    deletePending:
      'Вы попросили удалить аккаунт {{requestedAt}}. Мы удалим его до {{dueBy}}. Чтобы отозвать запрос или задать вопрос, напишите на',
    deleteFailed:
      'Не удалось отправить запрос. Проверьте подключение и попробуйте ещё раз.',
    deleteConfirmWord: 'УДАЛИТЬ',
    deleteTypeToConfirm: 'Чтобы подтвердить, введите {{word}} ниже.',
    deleteFinalButton: 'Да, удалить мой аккаунт',
    errorsTracking: 'Сбор информации об ошибках',
    errorsTrackingInfo:
      'Собирайте информацию об ошибках и сбоях, чтобы помочь с исправлениями и облегчить поддержку.',
    iAgree: 'Я согласен с',
    keepSignedIn: 'Не выходить из приложения',
    keepSignedInInfo: 'Я не хочу, чтобы приложение часто выходило из аккаунта.',
    keepSignedInWarning:
      '\n      ВНИМАНИЕ! Если Вы включите эту настройку и кто-то получит несанкционированный доступ к Вашему телефону (например, если его украдут, когда он не защищён паролем и подключён к интернету), это может привести к утечке Ваших личных медицинских данных.\n      Мы настоятельно рекомендуем оставить эту настройку выключенной.\n      ',
    mainTerms:
      'Пожалуйста, прочитайте и примите Политику конфиденциальности и Условия обслуживания, чтобы использовать приложение.',
    optionalSettings: 'Опциональные настройки конфиденциальности',
    productEmailNotify: 'Получать электронные письма об обновлениях',
    productEmailNotifyInfo:
      'Присылайте мне информацию о продуктах, услугах, обновлениях, предложениях или рекомендациях по электронной почте.',
    productPushNotify: 'Получать уведомления об обновлениях в приложении',
    productPushNotifyInfo:
      'Присылайте мне информацию о продуктах, услугах, обновлениях, предложениях или рекомендациях с помощью уведомлений в приложении.',
    restoreSubscription: 'Восстановить подписку',
    usageTracking: 'Отслеживание использования с помощью Google Analytics',
    usageTrackingInfo:
      'Собирайте информацию об экранах, которые я открываю в приложении, с помощью Google Analytics, чтобы помочь улучшить приложение.',
  },
  questionariesShared: {
    actions: `Обычно предлагаемые лечебные мероприятия`,
    actions0: `никаких`,
    actions1: `бдительное ожидание; повторить {{test}} при последующем визите`,
    actions2:
      'План лечения с учётом консультирования, наблюдения и/или фармакотерапии',
    actions3: `Активное лечение с помощью фармакотерапии и/или психотерапии`,
    actions4: `Немедленное начало фармакотерапии и, в случае тяжелых нарушений или плохого ответа на терапию, ускоренное направление к специалисту по психическому здоровью для психотерапии и/или совместного лечения`,
    answer0: `Ни разу`,
    answer1: `Несколько дней`,
    answer2: `Более недели`,
    answer3: `Почти каждый день`,
    backToTests: 'Вернуться к опросникам',
    disclaimer:
      'ОТКАЗ ОТ ОТВЕТСТВЕННОСТИ: Несмотря на то, что {{test}} показывает высокую надежность и достоверность, он не может заменить медицинскую консультацию, диагностику или лечение у специалиста по психическому здоровью. Это приложение не дает медицинских рекомендаций. Оно предназначено только для информационных целей. Никогда не игнорируйте профессиональные медицинские советы при обращении за лечением из-за чего-то, что Вы прочитали в нашем приложении или на веб-сайте. Если Вы считаете, что Вам может потребоваться неотложная медицинская помощь, немедленно позвоните своему врачу или наберите 103 (или Ваш номер службы экстренной помощи).',
    extraQuestion1: `Насколько трудно Вам было работать, заниматься домашними делами или общаться с людьми из-за этих проблем?`,
    extraQuestionAnswer0: `Совсем не трудно`,
    extraQuestionAnswer1: `Немного трудно`,
    extraQuestionAnswer2: `Очень трудно`,
    extraQuestionAnswer3: `Чрезвычайно трудно`,
    intro1: `Как часто за последние 2 недели  Вас беспокоила следующая проблема?`,
    nextQuestion: `Следующий вопрос`,
    score: `Оценка {{test}}`,
    // E06 — запасной текст, когда сервер не прислал читаемого сообщения об отказе.
    saveError:
      'Не удалось сохранить этот опросник. Проверьте подключение и попробуйте ещё раз — если это повторяется, напишите нам на support@copingcard.com.',
    seeResult: 'Результат',
    severity0: 'Отсутствует или минимальная',
    severity1: 'Лёгкая',
    severity2: 'Умеренная',
    severity3: 'Умеренно тяжёлая',
    severity4: 'Тяжёлая',
    severityMinimal0: 'Минимальная',
    testReminder: 'Напоминание о следующем опроснике',
    testResult: 'Результат опросника',
    seeTherapistsText:
      'Вы хотите найти специалистов в области психического здоровья, которые используют CopingCard в процессе лечения?',
    seeTherapists: 'Перейти к поиску терапевтов',
  },
  rnPaperDates: {
    close: 'Закрыть',
    dateIsDisabled: 'День не разрешается',
    mustBeBetween: (startDate: any, endDate: any) =>
      `Должно быть между ${startDate} - ${endDate}`,
    mustBeHigherThan: (date: any) => `Должно быть позже чем ${date}`,
    mustBeLowerThan: (date: any) => `Должно быть раньше чем ${date}`,
    next: 'Следующий',
    notAccordingToDateFormat: (inputFormat: any) =>
      `Формат даты должен быть ${inputFormat}`,
    pickDateFromCalendar: 'Выберите дату в календаре',
    previous: 'Предыдущий',
    save: 'Сохранить',
    selectMultiple: 'Выберите даты',
    selectRange: 'Выберите период',
    selectSingle: 'Выберите дату',
    typeInDate: 'Напечатайте дату',
  },
  screens: {
    assessments: 'Опросники',
    appLock: 'Блокировка приложения',
    safetyPlan: 'План безопасности',
    safetyPlanEdit: 'Редактировать план безопасности',
    abcModel: 'ABC-модель',
    abcModels: 'ABC-модель',
    anxiety: 'Тревожность',
    article: 'Статья',
    articles: 'Статьи',
    audio: 'Аудио',
    behaviorExperiment: 'Поведенческий эксперимент',
    behaviorExperiments: 'Поведенческие эксперименты',
    behaviorExperimentDetail: 'Эксперимент',
    behaviorExperimentObservation: 'Наблюдение',
    behaviorExperimentComplete: 'Завершение эксперимента',
    unfinishedBehaviorExperiments: 'Незавершённые / Черновики',
    cardNotifications: 'Напоминания карточки',
    // E05 · R1 — подборщик расписания напоминания (только в E-эре).
    reminderSchedulePicker: 'Расписание напоминания',
    // E34 · домашние задания на телефоне (блок 1c)
    myHomework: 'Домашние задания',
    checkIn: 'Настроение',
    diaryCard: 'Дневник самонаблюдения',
    diaryCardSetup: 'Мой дневник самонаблюдения',
    diaryCardWeek: 'Моя неделя',
    myCheckIns: 'Моё настроение',
    myPathways: 'Мои программы',
    pathwayProgram: 'Программа',
    courses: 'Программы',
    homeworkAssignment: 'Домашнее задание',
    homeworkSkip: 'Пропустить задание',
    worksheetForm: 'Рабочий лист',
    worksheetOverTime: 'Динамика',
    worksheetEntry: 'Запись рабочего листа',
    homeworkVideo: 'Видео',
    addMyHomework: 'Добавить своё',
    copingCard: 'Копинг-карточка',
    copingCards: 'Копинг-карточки',
    crisis: 'Кризис',
    urgentCrisis: 'Неотложный кризис',
    depression: 'Депрессия',
    downwardArrow: 'Падающая стрела',
    downwardArrows: 'Падающая стрела',
    exposures: 'Экспозиции',
    exposure: 'Экспозиция',
    exposureSituation: 'Ситуация экспозиции',
    gad7: 'GAD-7',
    generalSettings: 'Профиль',
    home: 'Главная',
    info: 'Инфо',
    insights: 'Инсайты',
    // E07 (M7) — заголовки двух новых экранов. RU approved by the founder 2026-09-13.
    joinPractice: 'Присоединение к практике',
    transferRequestPrompt: 'Запрос на перевод',
    learn: 'Обучение',
    mammalianReflex: 'Нырятельный рефлекс млекопитающих',
    muscleRelaxation: 'Мышечная релаксация',
    technique54321: 'Техника 5-4-3-2-1',
    meditations: 'Медитации',
    notificationsSettings: 'Настройки уведомлений',
    passwordReset: 'Смена пароля',
    phq9: 'PHQ-9',
    privacy: 'Политика конфиденциальности',
    privacySettings: 'Настройки конфиденциальности',
    deleteAccount: 'Удаление аккаунта',
    saas: 'Соглашение об услугах для поставщиков медицинских услуг',
    settings: 'Настройки',
    signIn: 'Вход',
    subscription: 'Управление подпиской',
    viciousCycles: 'Поддерживающие циклы',
    viciousCycle: 'Поддерживающий цикл',
    terms: 'Условия использования',
    tests: 'Опросники',
    therapist: 'Специалист по психическому здоровью',
    therapists: 'Найти специалиста по психическому здоровью',
    therapistMessage: 'Связаться со специалистом',
    therapistsSharing: 'Обмен данными с терапевтами',
    thoughtsTesting: 'Тестирование мыслей',
    thoughtsTestingLocation: 'Местоположение события',
    unfinishedThoughtTests: 'Незаконченные тесты мыслей',
    toolKit: 'Набор инструментов',
    tools: 'Инструменты',
    video: 'Видео',
    worryTrees: 'Дерево принятия решений',
    worryTree: 'Дерево принятия решений',
  },
  sendTherapistMessageModal: {
    title: 'Отправить емейл специалисту',
    message: 'Напишите Ваше Сообщение',
  },
  settings: {
    chooseLanguage: 'Выберите язык',
    languageEnglish: 'Английский',
    languageRussian: 'Русский',
    displayName: 'Отображаемое имя',
    displayNameHint:
      'Отображаемое имя получено от поставщика OAuth, который Вы использовали для входа в систему, например Facebook или Google',
    email: 'Емейл адрес',
    firstName: 'Имя',
    lastName: 'Фамилия',
    profileInfo: 'Информация о пользователе',
    reminders: 'Напоминания',
    remindersCount: 'Всего напоминаний',
    remindersEmptyState:
      'Напоминаний о мыслях пока нет. Включите напоминания в карточке совладания или связанном экране мыслей, а затем управляйте ими здесь.',
    loadError:
      'Мы не смогли загрузить Ваши настройки. Пожалуйста, закройте и снова откройте CopingCard, затем попробуйте ещё раз. Если проблема повторится, напишите в support@copingcard.com и укажите код SETTINGS-LOAD-1.',
    saveSettings: 'Сохранить настройки',
    saveError:
      'Мы не смогли сохранить Ваши настройки. Пожалуйста, попробуйте ещё раз. Если проблема повторится, напишите в support@copingcard.com и укажите код SETTINGS-SAVE-1.',
    searchTimezone: 'Найдите страну или часовую зону',
    signOut: 'Выйти',
    userId: 'ID пользователя',
    userIdCopied: 'ID пользователя скопирован в буфер обмена',
  },
  signIn: {
    // подписи для средств доступности у «глаза» в поле пароля (2026-09-07)
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
    authEmailInUse: 'Этот адрес электронной почты уже используется!',
    authEmailInvalid: 'Этот адрес электронной почты недействителен!',
    authFacebookCancel: 'Пользователь отменил процесс входа/регистрации.',
    authNoToken: 'Произошла ошибка при получении токена доступа к {{token}}',
    authAppleSimulatorUnavailable:
      'В симуляторе iOS вход через Apple недоступен. Повторите попытку на реальном устройстве или удалите запись Simulator из списка устройств Apple ID и попробуйте снова.',
    authAppleUnavailable:
      'Вход через Apple не сработал на этом телефоне. Попробуйте ещё раз или войдите через Google или по электронной почте. Если ошибка повторяется, напишите на support@copingcard.com и укажите код AUTH-APPLE-1.',
    authAppleAccountExists:
      'С этим адресом электронной почты уже есть аккаунт CopingCard с другим способом входа. Войдите так же, как раньше, — через Google или по электронной почте и паролю.',
    authAppleFailed:
      'Вход через Apple не завершился. Попробуйте ещё раз. Если ошибка повторяется, напишите на support@copingcard.com и укажите код AUTH-APPLE-3.',
    authProviderConnectedTitle: 'Вход через {{token}} подключен',
    authSignedInAs: 'Вы вошли как {{email}}',
    authProviderCompleted: 'Вход через {{token}} успешно завершен.',
    authUserNotFound: 'Пользователь с данным емейл не найден!',
    // E50: сохранённая сессия аккаунта, который удалён
    accountGoneTitle: 'Этого аккаунта больше нет',
    accountGoneText:
      'Возможно, он был удалён по Вашему запросу. Вы можете войти в другой аккаунт или создать новый в любой момент.',
    authWeakPassword: 'Этот пароль недостаточно надежен!',
    authWrongPassword: 'Пароль недействительный!',
    checkEmailAgain: `Все еще не получили емейл или не уверены, что ввели правильный адрес электронной почты?`,
    checkEmailSpam: `Если Вы не получили от нас письмо в течение нескольких минут, проверьте папку со спамом, чтобы убедиться, что оно не там`,
    websiteOpenInstructions:
      'Если ссылка для подтверждения электронной почты откроется в браузере, а не в нашем мобильном приложении, Вам нужно будет закрыть и снова открыть мобильное приложение, чтобы завершить проверку и залогиниться в приложение.',
    checkEmailTitle: 'Письмо для сброса пароля отправлено',
    confirmEmailTitle: 'Емейл с подтверждением отправлен',
    confirmPassword: 'Подтвердить пароль',
    email: 'Адрес электронной почты',
    appleSignIn: 'Войти с Apple',
    appleSignUp: 'Зарегистрироваться через Apple',
    facebookSignUp: 'Зарегистрироваться через Facebook',
    facebooSignIn: 'Войти с Facebook',
    forgotPassword: 'Забыли пароль?',
    googleSignIn: 'Войти с Google',
    googleSignUp: 'Зарегистрироваться через Google',
    noAccount: 'Еще нет аккаунта?',
    password: 'Пароль',
    passwordEmailHint:
      'Пожалуйста, укажите адрес электронной почты, на который Вы зарегистрированы, чтобы мы могли отправить Вам письмо для сброса пароля. Чтобы продолжить, нажмите ссылку в электронном письме на своем телефоне.',
    passwordHint:
      'Пароль должен состоять не менее чем из 8 символов. Добавление цифр, прописных букв и специальных символов приветствуется, но не требуется.',
    passwordResetFinished:
      'Мы обновили Ваш пароль. Вскоре Вы будете автоматически перенаправлены на экран входа в систему.',
    reset: 'Изменить',
    resetTitle: 'Поменять пароль',
    newPasswordTitle: 'Установить новый пароль',
    newPassword: 'Новый пароль',
    confirmNewPassword: 'Подтвердить новый пароль',
    newPasswordSubmit: 'Установить пароль',
    signIn: 'Войти',
    signUp: 'Зарегистрироваться',
    title: 'CopingCard приветствует Вас',
    tryAnother: 'Всё ещё нет емейла?',
    tryAnotherButton: 'Вернуться на экран логина',
  },
  states: [
    'Алабама',
    'Аляска',
    'Аризона',
    'Арканзас',
    'Калифорния',
    'Колорадо',
    'Коннектикут',
    'Делавэр',
    'Флорида',
    'Грузия',
    'Гавайи',
    'Айдахо',
    'Иллинойс',
    'Индиана',
    'Айова',
    'Канзас',
    'Кентукки',
    'Луизиана',
    'Мэн',
    'Мэриленд',
    'Массачусетс',
    'Мичиган',
    'Миннесота',
    'Миссисипи',
    'Миссури',
    'Монтана',
    'Небраска',
    'Невада',
    'Нью-Гемпшир',
    'Нью-Джерси',
    'Нью-Мексико',
    'Нью-Йорк',
    'Северная Каролина',
    'Северная Дакота',
    'Огайо',
    'Оклахома',
    'Орегон',
    'Пенсильвания',
    'Пуэрто-Рико',
    'Род-Айленд',
    'Южная Каролина',
    'Южная Дакота',
    'Теннесси',
    'Техас',
    'Юта',
    'Вермонт',
    'Вирджиния',
    'Вашингтон',
    'Вашингтон, округ Колумбия',
    'Западная Виргиния',
    'Висконсин',
    'Вайоминг',
  ],
  subscription: {
    feature1: 'Неограниченным напоминаниям',
    feature2: 'Неограниченным деревьям принятия решений',
    feature3: 'Неограниченным геолокационным уведомлениям',
    feature4:
      'Неограниченным опросникам депрессии (PHQ-9) и тревожности (GAD-7)',
    feature5: 'Неограниченному прослушиванию медитаций',
    feature6: 'Неограниченному созданию поведенческих экспериментов',
    feature7:
      'Неограниченной длительности истории в разделе инсайты/статистика',
    feature8: 'Неограниченные использование инструмента "падающая стрела"',
    feature9: 'Неограниченному созданию экспозиций',
    feature10: 'Неограниченному созданию изображений с помощью ИИ',
    featureDescription1:
      'Бесплатным аккаунтам доступно только 9 активных напоминаний',
    featureDescription2:
      'Бесплатным аккаунтам доступна возможность создать только 1 дерево принятия решений в день',
    featureDescription3:
      'Бесплатным аккаунтам доступно только 2 геолокационных уведомления',
    featureDescription4:
      'Бесплатные аккаунты могут проходить тесты PHQ-9 и GAD-7 только раз в 2 недели',
    featureDescription5:
      'Бесплатные аккаунты могут слушать медитацию только раз в 3 дня',
    featureDescription6:
      'Бесплатные аккаунты могут создавать поведенческие эксперименты только раз в 3 дня',
    featureDescription7:
      'Бесплатным аккаунтам доступен только 1 месяц истории/статистики',
    featureDescription8:
      'Бесплатным аккаунтам доступна возможоност создать использовать инструмент "падающая стрела" только 2 раза в день',
    featureDescription9:
      'Бесплатным аккаунтам доступна возможоность создать только 1 экспозицию раз в 3 дня',
    featureDescription10:
      'Бесплатным аккаунтам доступна возможоность создать только 3 изображения с помощью ИИ в день',
    month_four: 'месяца',
    month_one: 'месяц',
    month_other: 'месяцев',
    month_three: 'месяца',
    month_two: 'месяца',
    noSubscriptionText:
      'Мы не получили никаких покупок для восстановления из магазина приложений. Если Вы считаете, что это ошибка, свяжитесь с нами по адресу support@copingcard.com.',
    noSubscriptionTitle: 'Нет покупок для восстановления',
    notNow: 'Позже',
    restoreUnavailableText:
      'Не удалось связаться с магазином, чтобы восстановить покупки. Повторите попытку чуть позже. Если проблема повторится, напишите нам на support@copingcard.com.',
    restoreSubscription: 'Восстановить подписку',
    paymentInfo1:
      'Цены будут автоматически переведены в Вашу местную валюту. Оплата будет снята с учетной записи {{store}} при подтверждении покупки.',
    paymentInfo2:
      'Подписка автоматически продлевается, если она не будет отменена по крайней мере за 24 часа до окончания действия текущего периода.',
    paymentInfo3:
      'Плата за продление будет взиматься с Вашей учетной записи в течение 24 часов до окончания текущего периода.',
    paymentInfo4:
      'Вы можете управлять своими подписками и отменять их, перейдя в настройки своей учетной записи в {{store}} после покупки.',
    paymentInfo5:
      'Вы можете отключить автоматическое продление в любое время в настройках своей учетной записи {{store}}, но средств за неиспользованную часть срока не подлежат возврату.',
    paymentInfo6:
      'Любая неиспользованная часть бесплатного пробного периода, если она предлагается, будет аннулирована, когда пользователь приобретет подписку, где это применимо.',
    paymentMotivation:
      'Платная подписка позволяет нам покрывать наши расходы и добавлять функционал.',
    paywall_downgrade:
      'Пожалуйста, выберите подписку, чтобы Ваши платные функции и уведомления оставались включенными. После подписки Вы сохраните доступ к:',
    paywall_geo_notifications:
      'Много функционала, который мы предоставляем Вам, например, геолокационные напоминания, требует от нас оплаты другим компаниям и поставщикам. Пожалуйста, приобретите платную подписку, чтобы получить доступ к:',
    paywall_settings:
      'Много функционала, который мы предоставляем Вам, требует от нас оплаты другим компаниям и поставщикам. Пожалуйста, приобретите платную подписку, чтобы получить доступ к:',
    paywall_stats:
      'Много функционала, который мы предоставляем Вам, например, неограниченный доступ к статистике, требует от нас оплаты другим компаниям(например, хостинг провайдерам). Пожалуйста, приобретите платную подписку, чтобы получить доступ к:',
    paywall_tests_phq_9:
      'Много функционала, который мы предоставляем Вам, требует от нас оплаты другим компаниям и поставщикам. Пожалуйста, приобретите платную подписку, чтобы получить доступ к:',
    paywall_tests_gad_7:
      'Много функционала, который мы предоставляем Вам, требует от нас оплаты другим компаниям и поставщикам. Пожалуйста, приобретите платную подписку, чтобы получить доступ к:',
    paywall_time_notifications:
      'Много функционала, который мы предоставляем Вам, например, напоминания по времени, требует от нас оплаты другим компаниям и поставщикам. Пожалуйста, приобретите платную подписку, чтобы получить доступ к:',
    paywall_meditations:
      'Бесплатные аккаунты могут слушать медитацию только раз в 3 дня. Купите платную подписку, чтобы получить неограниченный доступ к медитациям и другим премиум-функциям.',
    paywall_worry_trees:
      'Бесплатные аккаунты могут создавать только 1 дерево принятия решений в день. Купите платную подписку, чтобы получить неограниченный доступ к деревьям принятия решений и другим премиум-функциям.',
    paywall_downward_arrows:
      'Бесплатные аккаунты могут создавать только 2 падающие стрелы в день. Купите платную подписку, чтобы получить неограниченный доступ к инструменту "падающая стрела" и другим премиум-функциям.',
    paywall_behavior_experiments:
      'Бесплатные аккаунты могут создавать поведенческие эксперименты только раз в 3 дня. Купите платную подписку, чтобы получить неограниченный доступ к поведенческим экспериментам и другим премиум-функциям.',
    paywall_exposures:
      'Бесплатные аккаунты могут создавать экспозицию только раз в 3 дня. Купите платную подписку, чтобы иметь возможность создавать неограниченное количество экспозиций и другие премиум-функции.',
    paywall_ai_image_generation:
      'Бесплатные аккаунты могут создавать только 3 изображения, сгенерированные ИИ, в день. Обновите сейчас, чтобы иметь возможность создавать неограниченное количество изображений, сгенерированных искусственным интеллектом, и другие премиум-функции.',
    save: 'экономия',
    subscriptionFoundText:
      'Нам удалось найти для Вас действующую подписку. Ваш Премиум-доступ восстановлен.',
    subscriptionFoundTitle: 'Найдена действующая подписка',
    title: 'Разблокируйте дополнительный функционал',
    titlePremium: 'У Вас премиальный доступ',
    premiumIntro: 'Это предоставляет Вам полный доступ к:',
    year_four: 'года',
    year_one: 'год',
    year_other: 'лет',
    year_three: 'года',
    year_two: 'года',
    goBack: 'Вернуться',
  },
  therapist: {
    call: 'Позвонить',
    sendMessage: 'Отправить емейл',
    about: 'Обо мне',
    aceptingClients: 'Принимаю клиентов',
    mentalHealthRole: 'Роль в психическом здоровье',
    phone: 'Телефон',
    extension: 'Добавочный номер',
    therapyFormats: 'Форматы терапии',
    licensedInStates: 'Лицензии в штатах',
    licenseNumber: 'Номер лицензии',
    yearsOfPractice: 'Лет практики',
    education: 'Образование',
    languages: 'Языки',
    therapyApproaches: 'Терапевтические подходы',
    finances: 'Оплата',
    contPerSessionFrom: 'Стоимость сессии от',
    to: 'до',
    currency: 'Валюта',
    freeInitialConsulatation: 'Бесплатная первая консультация',
    slidingScale: 'Скользящая шкала',
    clients: 'Клиенты',
    modality: 'Модальность',
    age: 'Возраст',
    issues: 'Проблемы',
    linkToWebsite: 'Ссылка на профиль на другом ресурсе',
    acceptedInsurances: 'Принимаемые страховые компании',
    visitProfile: 'Перейти к профилю на другом ресурсе',
    messageSentSuccess: 'Сообщение успешно отправлено',
  },
  therapistsSearch: {
    info: 'Укажите свое местоположение, чтобы найти терапевтов.',
    country: 'Ваша страна',
    state: 'Ваш штат',
    learnMoreAndContact: 'Узнать больше и связаться',
    providerInvitationText:
      'Вы специалист по психическому здоровью и хотите, чтобы Вас отображали здесь? Пожалуйста, создайте бесплатную учетную запись провайдера по адресу:',
    noResults:
      'По Вашему запросу ничего не найдено. Пожалуйста, попробуйте позже.',
  },
  testsShared: {
    intervalYear: 'ГОД',
    intervalSixMonths: '6М',
    intervalThreeMonths: '3М',
    intervalMonth: '1М',
    intervalWeek: '1Н',
  },
  // E07 · «Присоединиться к практике» (M7, 2026-09-13) — RU approved by the founder 2026-09-13.
  join: {
    title: 'Присоединение к практике',
    joining: 'Подключаем Вас к практике…',
    joined:
      'Вы присоединились к своей практике. Практика назначит Вам терапевта, и Вас попросят подтвердить назначение.',
    joinedNamed:
      'Вы присоединились к практике «{{practice}}». Практика назначит Вам терапевта, и Вас попросят подтвердить назначение.',
    joinedNext:
      'Вы не делитесь данными с терапевтом, пока не дадите согласие. Запрос придёт в приложении и по электронной почте.',
    continue: 'Готово',
    refused: 'Эта ссылка больше не действует.',
    refusedHelp:
      'Возможно, практика заменила её после того, как отправила приглашение. Попросите новую ссылку или введите код приглашения, который Вам дали.',
    enterCodeInstead: 'Ввести код приглашения',
  },
  // E07 · запрос на перевод клиента (M7, 2026-09-13) — RU approved by the founder 2026-09-13.
  sharing: {
    transferPrompt: {
      title: 'Запрос на перевод',
      body: 'Практика «{{practice}}» спрашивает, может ли {{name}} продолжить работу с Вами.',
      whatStays:
        'Что бы Вы ни решили, Ваши карточки, тесты мышления и результаты опросников остаются Вашими и никуда не денутся.',
      approve: 'Согласиться на перевод',
      approveHint:
        '{{name}} сможет работать с Вами — с теми настройками доступа, которые выберете Вы.',
      decline: 'Не сейчас',
      declineHint:
        'Ничего не изменится и ничего не будет записано. Вы сможете ответить позже, если передумаете.',
      approvedConfirmation: 'Согласие получено. Теперь {{name}} может продолжить работу с Вами.',
      declinedConfirmation:
        'Ничего не изменилось. Вы можете вернуться к этому вопросу в любой момент.',
      nothingPending: 'Сейчас нет запросов на перевод, ожидающих Вашего ответа.',
      failed:
        'Не удалось отправить Ваш ответ. Проверьте подключение к интернету и попробуйте снова.',
      review: 'Посмотреть запрос',
      done: 'Готово',
      colleague: 'другой специалист',
      yourPractice: 'Ваша практика',
    },
  },
  therapistsSharing: {
    title: 'Обмен данными с специалистами по психическому здоровью',
    inviteLinkOrToken:
      'У Вас есть ссылка или код приглашения от специалиста по психическому здоровью?',
    enterLinkOrToken: 'Ввести ссылку или код приглашения',
    dataYouCanShare:
      'Вы можете делиться со своими специалистами по психическому здоровью всем, что записываете в приложении: копинг-карточками, работой в инструментах, результатами опросников и статистикой использования. Настройки ниже действуют для всех этих данных.',
    adminDataYouCanShare: `
Это позволит администраторам данной практики терапевта ПРОСМАТРИВАТЬ те же данные, которыми Вы делитесь со своим терапевтом.

Некоторые из ситуаций, когда это может быть полезно:
- Ваш терапевт в отпуске, и Вам нужно поделиться своими данными с другим терапевтом в данной практике
- Вы хотите, чтобы Ваш терапевт мог получить помощь/второе мнение от других терапевтов в данной практике
- с Вами работают несколько терапевтов в данной практике
- переход от одного терапевта к другому в данной практике
`,
    currentTherapists: 'Сейчас Вы делитесь данными с',
    viewSharing: 'Разрешить просмотр моих данных',
    editSharing: 'Разрешить редактировать мои данные',
    adminViewSharing: 'Разрешить просмотр моих данных администраторам практики',
    adminEditSharing:
      'Разрешить редактировать мои данные администраторам практики',
    professional: 'Специалист по психическому здоровью',
    inviteTherapist: 'Пригласить своего психотерапевта',
    enterInviteModalTitle: 'Введите ссылку или код приглашения',
    // P022 (E07 finding 50, 2026-09-19) — RU approved by the founder 2026-09-19.
    enterInviteFromLooking: 'Проверяем, кто отправил это приглашение…',
    enterInviteFrom: 'Приглашение от {{name}}',
    enterInviteFromPractice: 'Приглашение от {{name}} · {{practice}}',
    enterInviteFromUnknown: 'Приглашение с таким кодом не найдено. Проверьте код и попробуйте ещё раз.',
    enterInviteModaLabel: 'Ссылка или код приглашения',
    editingTip:
      '\nСначала необходимо разрешить просмотр.\n\nРазрешить терапевту редактировать данные особенно полезно на первых этапах терапии, в том числе во время онлайн-сессий.\n\nСпециалист по психическому здоровью сможет редактировать Ваши записи в приложении, чтобы помочь Вам быстрее освоить инструменты.\n\nВы сможете отозвать доступ в любой момент.\n      ',

    adminEditingTip: `
Это позволит администраторам данной практики терапевта РЕДАКТИРОВАТЬ те же данные, которые Вы разрешаете редактировать своему терапевту.
Для этого разрешения требуется разрешение на просмотр.

Некоторые из ситуаций, когда это может быть полезно:
- Ваш терапевт в отпуске, и Вам нужно поделиться своими данными с другим терапевтом в данной практике
- Вы хотите, чтобы Ваш терапевт мог получить помощь/второе мнение от других терапевтов в данной практике
- с Вами работают несколько терапевтов в данной практике
- переход от одного терапевта к другому в данной практике
`,
    acceptInvite: 'Принять приглашение',
    pendingInvites: 'Приглашения в ожидании',
    expiresAt: 'Истекает',
    inviteFrom: 'Приглашение от',
    confirmRevoke: 'Подтвердите отмену доступа',
    editRevoke: `
Если Вы отмените доступ на редактирование своих данных, Ваш специалист по психическому здоровью больше не сможет быстро редактировать Ваши копинг-карточки или тесты дисфункциональных мыслей.
    `,
    viewRevoke: `
Если Вы отмените доступ на просмотр своих данных, Ваш специалист по психическому здоровью больше не сможет видеть, как Вы используете наше приложение и какой контент Вы создаете, что может затруднить оказание Вам помощи в терапии.

Это также отменит доступ на редкатирование.
    `,
    noTherapists:
      'Вы еще не предоставили доступ к своим данным ни одному специалисту в области психического здоровья.',
    noTokenTitle: 'Код не найден',
    noTokenText: `
Мы не нашли этот токен в нашей базе данных.

Возможно, срок его действия истек, или он был неверным.

Пожалуйста, попробуйте еще раз или свяжитесь со своим специалистом по психическому здоровью для получения нового кода/приглашения.
`,
    accessGranted: 'Вы успешно предоставили доступ к своим данным',
    accessUpdated: 'Вы успешно обновили доступ к своим данным',
    inviteSent: 'Ваше приглашение отправлено',
    inviteFailed:
      'Мы не смогли отправить это приглашение. Пожалуйста, попробуйте еще раз. Если проблема повторится, напишите в support@copingcard.com и укажите код THERAPIST-INVITE-1.',
    alreadyAdded:
      'Вы уже предоставляете доступ к своим данным этому специалисту в области психического здоровья.',

    congratsOnPremium: 'Вы получили Премиум доступ!',
    congratsOnPremiumText: `
Поздравляем!

Ваш психолог/психотерапевт предоставил Вам полный доступ к премиум-функциям нашего приложения.

Мы надеемся, что это поможет Вам на Вашем пути к счастью и здоровью.
    `,
  },
  thoughtChoiceModal: {
    title: 'Создание карточки',
    text: 'Выберите, хотите ли Вы создать карточку с помощью инструмента тестирования автоматических мыслей, или просто быстро создать карточку.',
    goToTesting: 'Перейти к тестированию мыслей',
    quickEdit: 'Быстро добавить карточку',
  },
  // E01 — тестирование мыслей на Event Sourcing (префикс контекста `thoughtTesting.<cmd>.*`)
  // сосуществование ES (plan 07 §3 правило 5 / plan 04 §2.2): обе стороны проверяет сервер
  es: {
    modeMismatch:
      'Ваш аккаунт только что обновился. Пожалуйста, попробуйте ещё раз через мгновение.',
    resendAsEs:
      'Ваш аккаунт только что обновился. Пожалуйста, попробуйте ещё раз через мгновение.',
    editNotPorted:
      'Эту часть карточки пока нельзя изменить в обновлённой версии. Попробуйте после следующего обновления.',
  },
  behaviorExperimentApp: {
    myReflections: 'Мои размышления',
    myReflectionsPlaceholder: 'Запишите, что Вы заметили',
  },
  // E10 — Downward Arrow on Event Sourcing (context prefix `downwardArrow.<cmd>.*`, plan 03 §3).
  // Отличается от `shared.downwardArrow.*` — это копия экрана.
  conceptualization: {
    upsert: {
      rejected:
        'Не удалось сохранить эту концептуализацию случая — проверьте записи и попробуйте ещё раз.',
      conflictRetry:
        'Эта концептуализация только что была изменена в другом месте. Загружаем актуальную версию…',
    },
  },
  // E17 · UpsertSession (portal) — RU pending the founder's approval, as the other E-lane refusals.
  sessions: {
    upsert: {
      rejected:
        'Не удалось сохранить эту сессию — проверьте записи и попробуйте ещё раз.',
      limitReached:
        'Новую сессию нельзя записать при текущей подписке практики — обновите подписку или освободите место и попробуйте ещё раз.',
      conflictRetry:
        'Эта сессия только что была изменена в другом месте. Загружаем актуальную версию…',
    },
  },
  // E04 · сеанс просмотра данных (the review session — the therapist's explicit RTM bracket);
  // «просмотр данных» is the founder's pick (variant C, 2026-09-21).
  reviewSessions: {
    alreadyActive:
      'У Вас уже идёт просмотр данных этого клиента — завершите его, прежде чем начинать новый.',
    noneActive: 'Сейчас просмотр данных этого клиента не ведётся.',
    conflictRetry:
      'Этот сеанс просмотра данных только что был изменён в другом месте. Загружаем актуальное состояние…',
  },
  // E23 · сообщение терапевту через журнал — RU pending the founder's approval.
  messaging: {
    send: {
      rejected: 'Не удалось отправить это сообщение — проверьте его и попробуйте ещё раз.',
      conflictRetry: 'Это сообщение только что было отправлено. Обновляем…',
    },
    read: {
      rejected: 'Не удалось отметить это сообщение как прочитанное — обновите страницу и попробуйте ещё раз.',
    },
  },
  // E24 · практика, её первый адрес и профиль специалиста через журнал (portal) — RU pending the
  // founder's approval.
  practice: {
    create: {
      rejected:
        'Не удалось создать практику — проверьте введённые данные и попробуйте ещё раз.',
    },
    update: {
      rejected:
        'Не удалось сохранить информацию о практике — проверьте введённые данные и попробуйте ещё раз.',
    },
    profile: {
      rejected:
        'Не удалось сохранить Ваш профиль — проверьте введённые данные и попробуйте ещё раз.',
    },
    conflictRetry: 'Данные только что были изменены в другом месте. Загружаем последнюю версию…',
  },
  // E18 · заметка о прогрессе через журнал (portal; the portal's own term, portalRu
  // `Заметки о прогрессе`) — RU pending the founder's approval.
  progressNotes: {
    upsert: {
      rejected:
        'Не удалось сохранить эту заметку о прогрессе — проверьте записи и попробуйте ещё раз.',
      conflictRetry:
        'Эта заметка о прогрессе только что была изменена в другом месте. Загружаем актуальную версию…',
    },
  },
  worryTree: {
    create: {
      rejected:
        'Не удалось сохранить это дерево тревоги — проверьте записи и попробуйте ещё раз.',
      conflictRetry:
        'Это дерево тревоги только что было сохранено на другом устройстве. Загружаем актуальную версию…',
    },
  },
  abcModel: {
    upsert: {
      rejected:
        'Не удалось сохранить эту ABC-модель — проверьте записи и попробуйте ещё раз.',
      conflictRetry:
        'Эта ABC-модель только что была изменена на другом устройстве. Загружаем актуальную версию…',
    },
    // коды отказов решателя (packages/domain/src/abcModel/errors.ts) — по одному ключу на код,
    // на обоих языках; тест error-codes-i18n падает, если ключа нет
    errors: {
      SUBJECT_REQUIRED:
        'Войдите в аккаунт ещё раз, прежде чем сохранить ABC-модель.',
    },
  },
  // ── E06 · Опросники (PHQ-9 / GAD-7) ───────────────────────────────────────────────────────────
  // Коды отказов решателя (packages/domain/src/assessments/errors.ts) — по одному ключу на код,
  // на обоих языках; тест error-codes-i18n падает, если ключа нет.
  // E13 / E14 / E15 — Wellness (медитации, кризис, «Изучайте»). Два отказа транспорта и текст,
  // который показывает пакетная мутация. Остальные восемь решателей ничего не отклоняют.
  wellness: {
    submit: {
      rejected:
        'Не удалось сохранить это занятие. Приложение отправит его снова, как только появится сеть.',
      invalid:
        'Часть этого занятия не удалось записать. Обновите приложение и попробуйте ещё раз.',
    },
    errors: {
      WELLNESS_UNKNOWN_EVENT_TYPE:
        'Эта версия приложения пока не умеет записывать такое занятие. Обновите приложение.',
      WELLNESS_INVALID_PROGRESS:
        'Не удалось записать, до какого места Вы дошли, поэтому занятие не сохранено.',
    },
  },
  assessments: {
    purpose: {
      phq9: 'Депрессия',
      gad7: 'Тревога',
      dass21: 'Депрессия, тревога и стресс',
      pcl5: 'Посттравматический стресс',
      gds15: 'Депрессия у людей старшего возраста',
      urica: 'Готовность к изменениям',
    },
    create: {
      rejected:
        'Не удалось сохранить этот опросник. Пожалуйста, пройдите его ещё раз — ответы не были сохранены.',
      conflictRetry:
        'Этот опросник только что был сохранён на другом устройстве. Загружаем актуальный результат…',
    },
    errors: {
      ASSESSMENT_SCORE_MISMATCH:
        'Не удалось сохранить опросник: результат не сошёлся с ответами. Обновите приложение и пройдите опросник ещё раз.',
      ASSESSMENT_ANSWERS_INCOMPLETE:
        'Часть ответов отсутствует, поэтому подсчитать результат не получится. Вернитесь назад и ответьте на все вопросы.',
      ASSESSMENT_TYPE_UNKNOWN:
        'Этот опросник недоступен в Вашей версии приложения. Обновите приложение и попробуйте ещё раз.',
      ASSESSMENT_NOT_CONVERTED:
        'Этот опросник ещё готовится. Пожалуйста, попробуйте через минуту.',
      ASSESSMENT_ANSWERS_COUNT: 'Количество ответов не совпадает с этим опросником. Проверьте, чтобы у каждого вопроса был ответ, и попробуйте ещё раз.',
      ASSESSMENT_ANSWER_RANGE: 'Один из ответов не предусмотрен в этом опроснике. Проверьте ответы и попробуйте ещё раз.',
      ASSESSMENT_DATE_IN_FUTURE: 'Дата прохождения опросника не может быть в будущем. Выберите сегодня или более раннюю дату.',
      ASSESSMENT_SCORE_RANGE: 'Балл должен быть от 0 до максимального значения для этого опросника. Проверьте балл и попробуйте ещё раз.',
      HOMEWORK_NOT_YOUR_CLIENT: 'Записывать результаты можно только для клиентов, которые делятся с Вами данными. Попросите клиента включить обмен данными с Вами и попробуйте ещё раз.',
      INSTRUMENT_UNCHANGED: 'С момента последней публикации этого опросника ничего не изменилось, поэтому сохранять нечего.',
      INSTRUMENT_ITEMS_MISMATCH: 'В шкале указан вопрос, которого нет в этом опроснике. Сверьте номера вопросов с их общим количеством.',
      INSTRUMENT_BANDS_GAP: 'Диапазоны баллов содержат пропуск или пересекаются. Каждый диапазон должен начинаться на один балл выше окончания предыдущего.',
      INSTRUMENT_UNKNOWN: 'Этот опросник пока недоступен. Новые опросники появляются при обновлении приложения.',
    },
    catalog: {
      title: 'Другие опросники',
      body: 'Короткие опросники, которые можно пройти сейчас или которые задал Ваш терапевт.',
      empty: 'Сейчас нет других доступных опросников.',
      questions: 'Вопросов: {{count}}',
      assignedBy: 'Задал терапевт: {{name}}',
      assigned: 'Задал Ваш терапевт',
      due: 'Срок: {{date}}',
      last: 'Последний результат: {{score}} · {{band}}',
      lastScoreOnly: 'Последний результат: {{score}}',
      notTaken: 'Ещё не пройден',
    },
    intro: {
      questions: 'Вопросов: {{count}}',
      answers: 'На каждый вопрос выберите один ответ: {{choices}}.',
      start: 'Начать',
      source: 'Источник: {{citation}}',
      assignedBy: 'Задал терапевт: {{name}}',
      assigned: 'Задал Ваш терапевт',
      due: 'Срок: {{date}}',
      loadError: 'Не удалось открыть этот опросник. Вернитесь назад и попробуйте ещё раз.',
    },
    take: {
      progress: 'Вопрос {{current}} из {{total}}',
      next: 'Далее',
      back: 'Назад',
      seeResult: 'Посмотреть результат',
      saving: 'Сохранение…',
      error: 'Не удалось сохранить Ваши ответы. Проверьте подключение и попробуйте ещё раз.',
    },
    result: {
      title: 'Ваш результат',
      total: 'Общий балл',
      scales: 'По шкалам',
      range: 'Диапазон',
      changeUp: 'На {{count}} выше, чем в прошлый раз',
      changeDown: 'На {{count}} ниже, чем в прошлый раз',
      changeSame: 'Так же, как в прошлый раз',
      bandsLine: 'Диапазоны баллов взяты из оригинальной методики; это не диагноз.',
      loading: 'Загружаем Ваш результат…',
      loadError: 'Ваши ответы сохранены, но показать результат не удалось. Откройте его из списка опросников.',
      history: 'История',
      backToTests: 'Назад к опросникам',
    },
    history: {
      title: 'История',
      empty: 'Вы ещё не проходили этот опросник.',
    },
    support: {
      title: 'Ваш план и телефоны доверия',
      bodyPlan: 'Ваш план безопасности и телефоны доверия доступны при любом результате, каким бы ни был балл.',
      bodyNoPlan: 'Создайте план безопасности или откройте телефоны доверия. Эта карточка есть на экране каждого результата, каким бы ни был балл.',
      openPlan: 'Открыть мой план безопасности',
    },
    band: {
      dass21: {
        normal: 'Норма',
        mild: 'Лёгкая',
        moderate: 'Умеренная',
        severe: 'Тяжёлая',
        extremelySevere: 'Крайне тяжёлая',
      },
      pcl5: {
        belowCutoff: 'Ниже порогового значения',
        atOrAboveCutoff: 'На уровне порогового значения или выше (31–33)',
      },
      gds15: {
        belowCutoff: 'Ниже порогового значения',
        suggestsDepression: 'Указывает на возможную депрессию; рекомендуется консультация со специалистом',
        almostAlwaysDepression: 'Почти наверняка указывает на депрессию',
      },
    },
    subscale: {
      dass21: {
        depression: 'Депрессия',
        anxiety: 'Тревога',
        stress: 'Стресс',
      },
      pcl5: {
        intrusion: 'Вторжение',
        avoidance: 'Избегание',
        cognitionMood: 'Мысли и настроение',
        arousal: 'Возбуждение и реакции',
      },
      urica: {
        precontemplation: 'Пока не думаю об изменениях',
        contemplation: 'Размышляю об изменениях',
        action: 'Вношу изменения',
        maintenance: 'Поддерживаю изменения',
      },
    },
    note: {
      dass21: 'Эти категории сравнивают Ваши баллы со средними показателями среди людей в целом. Они не определяют расстройство.',
      pcl5: 'Балл на уровне порогового значения или выше указывает на вероятное ПТСР; подтвердить его может только клиническая беседа со специалистом.',
      urica: 'Показатель готовности составляет от −2 до 14: согласие с тем, чтобы размышлять об изменениях, вносить и поддерживать их, за вычетом согласия с тем, чтобы о них не думать. Он описывает то, где Вы находитесь сегодня, а не то, какой Вы человек.',
    },
    dass21: {
      about: 'Как часто за последнюю неделю Вы чувствовали подавленность, тревогу или напряжение.',
      instruction:
        'Пожалуйста, прочитайте каждое утверждение и выберите ответ в зависимости от того, насколько оно соответствовало Вашему самочувствию на прошлой неделе. Помните, что здесь нет правильных или неправильных ответов. Также не следует тратить слишком много времени на их обдумывание.',
      answer0: 'Вообще не относилось ко мне',
      answer1: 'Относилось ко мне в какой-то степени или некоторое время',
      answer2: 'Относилось ко мне в значительной степени или большую часть времени',
      answer3: 'Относилось ко мне в крайней степени или практически всё время',
      items: {
        q1: 'Мне было трудно успокоиться',
        q2: 'У меня возникало ощущение сухости во рту',
        q3: 'Мне казалось, что я совсем не могу испытать положительных эмоций',
        q4: 'Мне было тяжело дышать (напр., возникало учащённое дыхание, одышка в отсутствие физических нагрузок)',
        q5: 'Мне было сложно заставить себя сделать что-либо',
        q6: 'Я был(а) склонен(на) слишком бурно на всё реагировать',
        q7: 'Я ощущал(а) дрожь (напр., в руках)',
        q8: 'Я чувствовал(а), что трачу много душевных сил',
        q9: 'Я опасался(лась) ситуаций, в которых я мог(ла) запаниковать и оказаться в глупом положении',
        q10: 'Я чувствовал(а), что мне нечего ждать от жизни',
        q11: 'Я замечал(а), что начинал(а) сильно нервничать',
        q12: 'Мне было трудно расслабиться',
        q13: 'Я чувствовал(а) себя разбитым(ой) и унылым(ой)',
        q14: 'Меня раздражало всё, что отвлекало меня от дел',
        q15: 'Я чувствовал(а), что был(а) близок(ка) к панике',
        q16: 'Я был(а) не в состоянии чем-то увлечься',
        q17: 'Я чувствовал(а), что не представляю ценности как личность',
        q18: 'Я чувствовал(а) себя достаточно ранимым(ой)',
        q19: 'Я ощущал(а) сердцебиение в отсутствие физических нагрузок (напр., возникало учащённое сердцебиение, замирание сердца)',
        q20: 'Я испытывал(а) страх без какой-либо веской причины',
        q21: 'Я чувствовал(а), что моя жизнь не имеет смысла',
      },
    },
    pcl5: {
      stem: 'Как часто Вас беспокоили за последний месяц:',
      answer0: 'Никогда',
      answer1: 'Редко',
      answer2: 'Умеренно',
      answer3: 'Часто',
      answer4: 'Очень часто',
      items: {
        q1: 'Повторяющиеся, тревожные и нежелательные воспоминания о пережитом стрессе?',
        q2: 'Повторяющиеся, тревожные сны о пережитом стрессе?',
        q3: 'Резкое чувство или поведение такое, как, если бы пережитый стресс произошел снова (если бы Вы действительно',
        q4: 'Чувство сильного расстройства, при напоминании о пережитом стрессе?',
        q5: 'Сильные физические реакции при напоминании о пережитом стрессе? (например, учащенное сердцебиение, затрудненное',
        q6: 'Избегание воспоминаний, мыслей или чувств, связанных с пережитым стрессом?',
        q7: 'Избегание внешних напоминаний о пережитом стрессе (например, людей, мест, диалогов, действий, предметов или',
        q8: 'Трудности, связанные с восстановлением в памяти важных компонентов пережитого стресса?',
        q9: 'Сильные отрицательные убеждения о себе, других людях или мире (например, наличие таких мыслей как: я плохой, со мной',
        q10: 'Обвинение себя или других в пережитом стрессе или в том, что произошло после?',
        q11: 'Наличие сильных отрицательных чувств, таких, как, например, страх, ужас, гнев, вина или стыд?',
        q12: 'Потеря интереса к работе, которой Вы наслаждались?',
        q13: 'Чувство отстраненности от других людей?',
        q14: 'Трудности, связанные с переживанием положительных чувств (например, неспособность чувствовать радость или любовь к близким людям)?',
        q15: 'Раздражительное поведение, вспышки гнева или агрессивные действия?',
        q16: 'Принятие на себя слишком больших рисков или выполнение действий, которые могут принести Вам вред?',
        q17: 'Состояние "супер бдительности" или настороженности или повышенной бдительности?',
        q18: 'Чувство нервозности или страха?',
        q19: 'Проблемы с концентрацией?',
        q20: 'Проблемы с засыпанием или сном?',
      },
      about: 'Насколько сильно за последний месяц Вас беспокоили трудности, которые могут возникнуть после пережитого тяжёлого стресса.',
      instruction: 'Ниже приведён список трудностей, с которыми люди иногда сталкиваются после пережитого тяжёлого стресса. Пожалуйста, внимательно прочитайте каждый пункт и выберите, насколько сильно это беспокоило Вас за последний месяц.',
      notValidated: 'Эта русскоязычная версия не валидирована.',
    },
    gds15: {
      about: 'Короткий опросник настроения для людей старшего возраста. Оценивает состояние за последнюю неделю.',
      instruction: 'Выберите ответ, который лучше всего описывает Ваше самочувствие за последнюю неделю.',
      answer0: 'Нет',
      answer1: 'Да',
      items: {
        q1: 'В целом, удовлетворены ли Вы своей жизнью?',
        q2: 'Вы забросили большую часть своих занятий и интересов?',
        q3: 'Вы чувствуете, что Ваша жизнь пуста?',
        q4: 'Вам часто становится скучно?',
        q5: 'У Вас хорошее настроение большую часть времени?',
        q6: 'Вы опасаетесь, что с Вами случится что-то плохое?',
        q7: 'Вы чувствуете себя счастливым(ой) большую часть времени?',
        q8: 'Вы чувствуете себя беспомощным(ой)?',
        q9: 'Вы предпочитаете остаться дома, нежели выйти на улицу и заняться чем-нибудь новым?',
        q10: 'Считаете ли Вы, что Ваша память хуже, чем у других?',
        q11: 'Считаете ли Вы, что жить — это прекрасно?',
        q12: 'Чувствуете ли Вы себя сейчас бесполезным(ой)?',
        q13: 'Чувствуете ли Вы себя полным(ой) энергией и жизненной силой?',
        q14: 'Ощущаете ли Вы безнадежность той ситуации, в которой находитесь в настоящее время?',
        q15: 'Считаете ли Вы, что окружающие Вас люди живут более полноценной жизнью в сравнении с Вами?',
      },
    },
    urica: {
      about: 'Насколько Вы готовы что-то изменить — 32 утверждения о том, на каком этапе Вы находитесь прямо сейчас.',
      instruction: 'Каждое утверждение описывает, как человек может себя чувствовать в начале терапии или приступая к решению проблемы в своей жизни. Там, где написано «моя проблема», думайте об изменении, которое Вы имеете в виду; «здесь» и «это место» означают Вашу терапию или это приложение. Выберите, насколько Вы согласны с утверждением прямо сейчас — а не то, как Вы чувствовали себя в прошлом или хотели бы чувствовать.',
      answer1: 'Полностью не согласен(на)',
      answer2: 'Не согласен(на)',
      answer3: 'Не уверен(а)',
      answer4: 'Согласен(на)',
      answer5: 'Полностью согласен(на)',
      readiness: 'Готовность к изменениям',
      stageLine: 'Ближайшая стадия изменений: {{stage}}',
      items: {
        q1: 'Что касается меня, у меня нет никаких проблем, требующих изменений.',
        q2: 'Думаю, я готов(а) к работе над собой.',
        q3: 'Я что-то делаю с проблемами, которые меня беспокоили.',
        q4: 'Возможно, стоит поработать над моей проблемой.',
        q5: 'Дело не во мне. Для меня нет особого смысла находиться здесь.',
        q6: 'Меня беспокоит, что я могу вернуться к проблеме, которую уже удалось решить, поэтому я обращаюсь за помощью.',
        q7: 'Наконец-то я действительно работаю над своей проблемой.',
        q8: 'Я подумываю о том, что хотел(а) бы что-то изменить в себе.',
        q9: 'Я успешно справлялся(лась) со своей проблемой, но не уверен(а), что смогу поддерживать эти усилия в одиночку.',
        q10: 'Временами с моей проблемой непросто, но я работаю над ней.',
        q11: 'Находиться здесь для меня пустая трата времени: эта проблема не имеет ко мне отношения.',
        q12: 'Надеюсь, это место поможет мне лучше понять себя.',
        q13: 'Наверное, у меня есть недостатки, но ничего такого, что мне действительно нужно менять.',
        q14: 'Я действительно усердно работаю над тем, чтобы измениться.',
        q15: 'У меня есть проблема, и я действительно считаю, что мне стоит над ней поработать.',
        q16: 'Мне не удаётся удерживать достигнутые изменения так хорошо, как хотелось бы, поэтому я здесь — чтобы предотвратить возврат к проблеме.',
        q17: 'Даже если мне не всегда удаётся меняться, я по крайней мере работаю над своей проблемой.',
        q18: 'Я думал(а), что, решив проблему один раз, избавлюсь от неё, но иногда мне всё ещё приходится с ней бороться.',
        q19: 'Хотелось бы мне иметь больше идей о том, как решить эту проблему.',
        q20: 'Я начал(а) работать над своими проблемами, но мне не помешала бы помощь.',
        q21: 'Возможно, здесь мне смогут помочь.',
        q22: 'Возможно, прямо сейчас мне нужна поддержка, чтобы сохранить уже достигнутые изменения.',
        q23: 'Возможно, я тоже причастен(на) к проблеме, но на самом деле я так не думаю.',
        q24: 'Надеюсь, здесь мне дадут хороший совет.',
        q25: 'Рассуждать о переменах может каждый; я же действительно что-то делаю.',
        q26: 'Все эти разговоры о психологии наводят скуку. Почему люди не могут просто забыть о своих проблемах?',
        q27: 'Я здесь для того, чтобы предотвратить возврат к прежней проблеме.',
        q28: 'Это огорчает, но, похоже, ко мне возвращается проблема, которую я считал(а) решённой.',
        q29: 'У меня есть тревоги, но они есть у каждого. Зачем тратить время на мысли о них?',
        q30: 'Я активно работаю над своей проблемой.',
        q31: 'Мне проще мириться со своими недостатками, чем пытаться их изменить.',
        q32: 'После всего, что я сделал(а) для решения проблемы, время от времени она всё равно возвращается и не даёт мне покоя.',
      },
    },
  },
  exposure: {
    upsert: {
      rejected:
        'Не удалось сохранить эту экспозицию — проверьте записи и попробуйте ещё раз.',
      conflictRetry:
        'Эта экспозиция только что была изменена на другом устройстве. Загружаем актуальную версию…',
    },
    // коды отказов решателя (packages/domain/src/exposure/errors.ts) — по одному ключу на код,
    // на обоих языках; тест error-codes-i18n падает, если ключа нет
    errors: {
      EXPOSURE_NOT_FOUND:
        'Эта экспозиция больше недоступна. Вернитесь назад и откройте её снова.',
      EXPOSURE_STIMULUS_NOT_FOUND:
        'Этой ситуации больше нет в иерархии — возможно, она удалена на другом устройстве.',
      EXPOSITION_NOT_FOUND:
        'Этот сеанс экспозиции больше недоступен. Закройте таймер и начните новый сеанс.',
      EXPOSITION_REACTION_NOT_FOUND:
        'Этой реакции больше нет в сеансе. Закройте сеанс и откройте его снова, чтобы увидеть актуальные реакции.',
      EXPOSITION_EDIT_NOT_PORTED:
        'Прошлые сеансы пока нельзя изменить или удалить. Начните новый сеанс или откройте этот и добавьте реакцию.',
      EXPOSURE_NOT_CONVERTED:
        'Эта экспозиция ещё готовится. Пожалуйста, попробуйте через минуту.',
      EXPOSITION_LIKELIHOOD_RANGE: 'Вероятность должна быть целым числом от 0 до 100. Передвиньте ползунок на значение из этого диапазона или оставьте вопрос без ответа.',
      USER_NOT_AUTHORIZED:
        'У Вас нет доступа к этой экспозиции. Если это ошибка, напишите в support@copingcard.com и укажите код EXPOSURE-AUTH-1.',
      PAYWALL_EXPOSURES:
        'Вы достигли бесплатного лимита новых экспозиций. Оформите подписку, чтобы создавать новые, или продолжайте работу с уже созданными.',
      IMAGE_PROMPT_REQUIRED:
        'Опишите изображение, которое нужно сгенерировать, и попробуйте снова.',
      IMAGE_REQUEST_ALREADY_ANSWERED:
        'Это изображение уже сгенерировано. Нажмите «Сгенерировать» ещё раз, чтобы получить новое.',
      PAYWALL_AI_IMAGE_GENERATION:
        'Вы использовали все бесплатные ИИ-изображения на сегодня. Оформите подписку или попробуйте завтра.',
      LADDER_PROMPT_REQUIRED:
        'Укажите страх или навязчивость, к которым относится экспозиция, и создайте иерархию.',
      LADDER_REQUEST_ALREADY_ANSWERED:
        'Иерархия для этого запроса уже создана. Нажмите «Создать иерархию» ещё раз, чтобы получить новую.',
    },
  },
  // E34 · Домашние задания и программы (блок 1a, 2026-09-28) — коды отказов решателей
  // (packages/domain/src/homework/errors.ts): по одному ключу на код, на обоих языках; тест домена
  // error-codes-i18n падает, если ключа нет. RU — на утверждение основателю.
  homework: {
    errors: {
      HOMEWORK_NOT_YOUR_CLIENT:
        'Этот клиент не связан с Вами в Вашей практике — он не Ваш клиент здесь или отключил обмен данными с Вами, поэтому назначить или изменить домашнее задание нельзя. Проверьте список клиентов или попросите клиента снова включить обмен данными с Вами в приложении.',
      HOMEWORK_DUE_IN_PAST:
        'Этот срок уже прошёл. Выберите дату и время в будущем.',
      HOMEWORK_ONE_DEADLINE_SHAPE:
        'Выберите что-то одно: срок выполнения или расписание повторов.',
      HOMEWORK_TARGET_REQUIRED:
        'Перед назначением выберите содержание задания: инструмент, опросник, рабочий лист, статью, видео или ссылку.',
      HOMEWORK_TITLE_REQUIRED: 'Укажите название домашнего задания перед тем, как его назначить.',
      WORKSHEET_TEMPLATE_RETIRED:
        'Этот рабочий лист больше не используется, и назначить его нельзя. Выберите другой рабочий лист.',
      HOMEWORK_SELF_WORKSHEET_NOT_JOURNAL:
        'В свои задания можно добавлять только дневники CopingCard. Выберите дневник из списка.',
      HOMEWORK_SESSION_NEEDS_THERAPIST:
        'Шаг для сессии может назначить только Ваш терапевт. Выберите вместо него задачу или инструмент.',
      HOMEWORK_NOT_OPEN:
        'Это задание уже выполнено, пропущено или отменено — изменить его нельзя. Обновите список, чтобы увидеть текущий статус.',
      HOMEWORK_ALREADY_CANCELLED:
        'Это задание уже отменено. Обновите список, чтобы увидеть текущий статус.',
      HOMEWORK_ALREADY_OPEN:
        'Это задание всё ещё открыто — открывать заново нечего.',
      HOMEWORK_ALREADY_ACKNOWLEDGED: 'Это задание уже открыто.',
      HOMEWORK_ALREADY_DONE:
        'Это задание уже выполнено или пропущено — пока больше нечего отмечать.',
      HOMEWORK_CANCELLED:
        'Ваш терапевт отменил это задание, поэтому выполнить его больше нельзя. Потяните экран вниз, чтобы обновить список.',
      HOMEWORK_NEEDS_EVIDENCE:
        'Это задание отмечается выполненным автоматически, когда Вы делаете его в приложении — откройте его и завершите там. Если Ваш терапевт разрешил сделать его на бумаге, прикрепите фото бланка.',
      HOMEWORK_PAPER_NOT_ALLOWED: 'Это задание нельзя сделать на бумаге. Откройте его в приложении, чтобы завершить.',
      paperNotAllowed: 'Это задание нельзя сделать на бумаге. Откройте его в приложении, чтобы завершить.',
      HOMEWORK_REMINDED_TODAY:
        'Напоминание об этом задании сегодня уже отправлялось. Следующее можно будет отправить завтра.',
      HOMEWORK_NOT_FOUND:
        'Это задание больше недоступно. Обновите список и попробуйте ещё раз.',
      HOMEWORK_BAD_CURSOR: 'Не удалось загрузить следующую страницу. Потяните экран вниз, чтобы обновить список, и попробуйте ещё раз.',
      HOMEWORK_COMMENT_NOT_ALLOWED: 'Вы не можете комментировать это задание. Писать здесь могут только клиент и терапевты его практики — и только пока клиент делится данными с Вами. Проверьте список клиентов.',
      HOMEWORK_COMMENT_TEXT: 'В комментарии должен быть текст — до 2 000 символов. Напишите пару слов и отправьте снова.',
      // блок 1d — защита уведомителя от повтора (эту команду отправляет только система)
      HOMEWORK_ALREADY_NOTIFIED:
        'Клиент уже получил уведомление об этом задании. Отправлять повторно нечего.',
      // блок 1e — просмотр фото с бумаги (ответ основателя Q-b1b-2 A); RU — на генерацию и утверждение
      HOMEWORK_PHOTO_UNAVAILABLE:
        'Это фото больше недоступно — возможно, клиент удалил его. Попросите клиента прикрепить фото снова.',
      WORKSHEET_TEMPLATE_EMPTY: 'Этот рабочий лист пуст. Добавьте инструкции, видео или вопрос перед сохранением.',
      WORKSHEET_DUPLICATE_FIELD: 'У двух вопросов в этом рабочем листе одинаковый ID. Удалите один из них и сохраните снова.',
      WORKSHEET_SCORING_FIELD: 'Подсчёт баллов возможен только для вопросов с числом и шкалой. Выберите только эти вопросы в настройках подсчёта.',
      WORKSHEET_SIGNED_JOURNAL: 'Дневник заполняется многократно, поэтому требовать подпись нельзя. Отключите «Повторяющийся» или «Требуется подпись».',
      WORKSHEET_NOT_OWNER:
        'Здесь можно изменять только рабочие листы, созданные Вашей практикой. Нажмите «Использовать этот шаблон», чтобы сделать свою копию.',
      WORKSHEET_RIGHTS_NOT_CONFIRMED: 'Сначала отметьте «У меня есть право использовать этот контент», затем попробуйте ещё раз. Ваша практика несёт ответственность за контент, который импортирует или создаёт.',
      WORKSHEET_REQUIRED_MISSING: 'Некоторые обязательные вопросы остались без ответа. Ответьте на них, затем отправьте форму.',
      WORKSHEET_UNKNOWN_FIELD: 'Форма изменилась с момента открытия. Закройте её, откройте снова и отправьте ответы.',
      WORKSHEET_ALREADY_SUBMITTED: 'Эта форма уже отправлена. Терапевт может открыть её заново, если она снова понадобится.',
      WORKSHEET_NO_SIGNATURE: 'Для этой формы подпись не требуется — она считается завершённой сразу после отправки.',
      WORKSHEET_CONSENT_REQUIRED: 'Отметьте «Я соглашаюсь» перед подписанием.',
      WORKSHEET_ALREADY_SIGNED: 'Эта форма уже подписана. Больше ничего делать не нужно.',
      WORKSHEET_SIGNER_NOT_SUBJECT: 'Эту форму может подписать только клиент в своём приложении CopingCard.',
      WORKSHEET_TEMPLATE_NOT_FOUND: 'Этот рабочий лист больше недоступен. Обновите список и выберите его снова.',
      WORKSHEET_ANSWER_INVALID: 'Один из ответов не подходит к вопросу — например, число выходит за границы шкалы. Проверьте ответы и отправьте снова.',
      WORKSHEET_SUBMISSION_SUPERSEDED: 'Уже отправлена более новая копия этой формы. Подпишите последнюю версию.',
      PATHWAY_EMPTY: 'В этой программе пока нет шагов. Добавьте хотя бы один шаг перед сохранением.',
      PATHWAY_FIRST_STEP_RULE: 'Первый шаг не может зависеть от предыдущего. Настройте его запуск при записи клиента, в конкретный день или когда Вы откроете доступ.',
      PATHWAY_STEP_TARGET_REQUIRED: 'В одном из шагов не указано содержание — выберите инструмент, опросник, рабочий лист, статью, видео или ссылку.',
      PATHWAY_SESSION_STEP_PUBLIC:
        'Шаг, который выполняется на сессии, не может входить в публичную программу. Сделайте программу приватной или удалите этот шаг.',
      PATHWAY_PUBLISH_NOT_ALLOWED:
        'Ваша практика пока не может публиковать программы, поэтому эта программа может быть только приватной. Выберите видимость «Практика» или свяжитесь с CopingCard по поводу публикации программ.',
      PATHWAY_CUSTOMISE_NOT_ALLOWED:
        'Ваш тариф не включает изменение программ CopingCard. Вы по-прежнему можете назначать клиентам программу в исходном виде.',
      PATHWAY_RETIRED:
        'Эта программа больше не используется, поэтому её нельзя изменить или назначить новым клиентам. Дублируйте её, чтобы создать новую.',
      PATHWAY_NOT_OWNER:
        'Здесь можно изменять только программы, созданные Вашей практикой. Продублируйте программу или используйте её как шаблон, чтобы сделать свою копию.',
      PATHWAY_ALREADY_RETIRED:
        'Эта программа больше не используется. Обновите страницу, чтобы увидеть текущий статус.',
      PATHWAY_ALREADY_ENROLLED: 'Этот клиент уже проходит эту программу. Откройте его прогресс, чтобы посмотреть, на каком он шаге.',
      PATHWAY_PRESCRIBE_NOT_ALLOWED:
        'Эта платная программа не входит в Ваш тариф. Смените тариф в разделе «Оплата», чтобы назначать программы — Ваш клиент никогда не платит за то, что Вы назначаете.',
      PATHWAY_PURCHASE_REQUIRED: 'Эта программа оплачивается единоразово. Сначала приобретите её, а затем начинайте.',
      PATHWAY_PLAN_ONLY: 'Эта программа доступна только через практику терапевта. Спросите о ней у Вашего терапевта.',
      PATHWAY_NOT_SELF_ENROLABLE:
        'Эту программу нельзя начать самостоятельно. Выберите программу из списка.',
      PATHWAY_STEP_ALREADY_RELEASED: 'Доступ к этому шагу уже открыт. Обновите страницу, чтобы увидеть прогресс клиента.',
      PATHWAY_ENROLLMENT_CLOSED: 'Эта программа уже завершена — её прошли или отменили. Обновите страницу, чтобы увидеть текущий статус.',
      PATHWAY_STEP_UNKNOWN: 'Этого шага нет в версии, которую проходит этот клиент. Обновите прогресс и попробуйте ещё раз.',
      PATHWAY_STEPS_OPEN: 'Некоторые шаги этой программы всё ещё открыты, поэтому она пока не завершена.',
      PATHWAY_NOT_FOUND: 'Эта программа больше недоступна. Обновите список и попробуйте ещё раз.',
      PATHWAY_ENROLLMENT_NOT_FOUND: 'Эта программа больше недоступна. Обновите список и попробуйте ещё раз.',
      PATHWAY_LEAVE_ASK_THERAPIST: 'Ваш терапевт начал эту программу вместе с Вами. Поговорите с ним, если хотите её прекратить.',
      PATHWAY_ACCESS_NOT_LIBRARY:
        'Правила доступа настраиваются только для программ из библиотеки CopingCard. У собственных программ практики их нет — выберите программу из библиотеки.',
      PATHWAY_ACCESS_PRODUCT_REQUIRED:
        'Для платной программы нужен связанный продукт в магазине. Введите ID продукта, настроенный в App Store и Google Play, затем сохраните снова.',
      PATHWAY_ACCESS_PLACEMENT_REQUIRED:
        'Для платной программы требуется размещение в Adapty. Введите placement ID экрана оплаты программы в Adapty, затем сохраните снова.',
      PRACTICE_CAPABILITY_UNKNOWN:
        'Такой возможности не существует. Выберите «назначать программы», «изменять программы» или «публиковать программы».',
      PRACTICE_CAPABILITY_UNCHANGED: 'Нечего менять — переключатель уже в этом положении. Обновите страницу, чтобы увидеть текущее состояние.',
      PATHWAY_NOT_IN_REVIEW:
        'Эта версия больше не ожидает проверки — по ней принято решение, её заменили более новой версией, сделали приватной или перестали использовать. Обновите очередь.',
      PATHWAY_REVIEW_REASON_REQUIRED: 'Напишите причину, которую прочитает практика, затем отклоните снова.',
      HOMEWORK_NOT_A_VIDEO: 'Это задание — не видео, поэтому ничего не сохранилось. Вернитесь в список домашних заданий и откройте его оттуда.',
      HOMEWORK_INVALID_PROGRESS: 'Не удалось сохранить прогресс просмотра видео. Откройте видео снова из списка домашних заданий и запустите его.',
    },
    // ── блок 1c (2026-09-28): сторона клиента на телефоне ──
    saveError:
      'Не удалось сохранить. Проверьте подключение и попробуйте ещё раз.',
    toolkitEntry: {
      title: 'Домашние задания',
      summaryOpen: 'к выполнению: {{count}}',
      summaryOverdue: 'просрочено: {{count}}',
      summaryNone: 'Сейчас заданий нет — добавьте своё',
      badgeLabel: 'заданий к выполнению: {{count}}',
    },
    kind: {
      tool: 'инструмент',
      assessment: 'опросник',
      worksheet: 'рабочий лист',
      reading: 'чтение',
      task: 'задача',
      link: 'ссылка',
      session: 'сессия',
      video: 'видео',
    },
    status: {
      open: 'открыто',
      overdue: 'просрочено',
      done: 'выполнено',
      skipped: 'пропущено',
      cancelled: 'отменено',
    },
    list: {
      openSection: 'К выполнению',
      closedSection: 'Выполнено · пропущено · отменено',
      loadingMore: 'Загрузка более ранних заданий…',
      empty:
        'Пока нет домашних заданий. То, что назначит Ваш терапевт, появится здесь — а ещё Вы можете добавить своё.',
      add: '+ Добавить своё',
      you: 'Вы',
      yourTherapist: 'Ваш терапевт',
      due: 'срок: {{date}}',
      nextDue: 'следующее: {{date}}',
      doneOn: 'выполнено {{date}}',
      lastOutcome: {
        day: 'на сегодня: {{outcome}}',
        week: 'на эту неделю: {{outcome}}',
        month: 'на этот месяц: {{outcome}}',
        other: '{{date}}: {{outcome}}',
      },
      noDue: 'без срока',
      scheduleEnded: 'дат больше нет',
      video: 'Отметится выполненным после просмотра до конца',
      rowLabel: '{{title}}, {{status}}',
    },
    detail: {
      from: 'От: {{name}}',
      fromYou: 'Добавлено Вами',
      photoConvertFailed:
        'Не удалось подготовить это фото. Попробуйте сделать его ещё раз.',
      instructions: 'Инструкции',
      reminderFrom: 'Напоминание от: {{name}}',
      whatToDo: 'Что нужно сделать',
      open: 'Открыть',
      occurrenceLine: '{{label}} · {{date}}',
      occurrenceAnswered: '{{label}}: {{outcome}}',
      occurrence: {
        day: 'На сегодня',
        week: 'На эту неделю',
        month: 'На этот месяц',
        next: 'Следующее',
        overdue: 'Просрочено',
      },
      note: 'Заметка (необязательно)',
      notePlaceholder: 'Всё, что Вы хотите запомнить или рассказать терапевту',
      markDone: 'Отметить как выполненное',
      markDoneWithPhoto: 'Отметить как выполненное с этим фото',
      skip: 'Пропустить это задание…',
      outcome: {
        done: 'Выполнено',
        skipped: 'Пропущено',
        doneOccurrence: 'Выполнено за {{date}}. Следующий срок: {{next}}.',
        skippedOccurrence: 'Пропущено за {{date}}. Следующий срок: {{next}}.',
      },
      toolHint:
        'Откройте инструмент и завершите его в приложении — задание отметится выполненным автоматически.',
      evidenceOnly:
        'Здесь нет кнопки «Отметить как выполненное» — откройте и завершите его; задание отметится выполненным автоматически, когда сохранится запись.',
      worksheetHint: 'Откройте форму, заполните её и отправьте — задание отметится выполненным автоматически. Если для формы требуется подпись, задание завершится, когда Вы её подпишете.',
      session:
        'Выполняется на сессии с терапевтом: {{name}} — задание отметится выполненным, когда Ваш терапевт сделает отметку.',
      video:
        'Оно отметится выполненным автоматически, когда Вы досмотрите его до конца.',
      // блок 1d — инструмент у этого человека пока пишет мимо журнала домашних заданий (Q-b1d-1)
      targetTool: '{{name}} (Набор инструментов)',
      targetArticle: 'Обучение · {{title}}',
      targetLink: 'Ссылка · {{url}}',
      targetAssessment: '{{name}}',
      targetNone:
        'Здесь нечего открывать — выполните удобным для Вас способом, затем отметьте как выполненное.',
      targetVideo: 'Видео · {{player}} · воспроизводится в приложении',
      targetLearnVideo: 'Обучающее видео · {{title}}',
      notFound:
        'Этого задания нет в Вашем списке. Вернитесь назад, чтобы посмотреть остальные.',
      withdrawn: 'Ваш терапевт отменил это задание, поэтому сейчас делать ничего не нужно. Вы по-прежнему можете читать его и комментарии к нему.',
      paper: {
        prompt: 'Сделали на бумаге? Прикрепите фото',
        optionalPhoto: 'Прикрепить фото (необязательно)',
        hint:
          'Прикрепите фото бланка и отметьте как выполненное — Ваш терапевт увидит фото.',
        takePhoto: 'Сделать фото',
        choosePhoto: 'Выбрать фото',
        openSettings: 'Открыть настройки',
        remove: 'Удалить фото',
        sending: 'Отправка фото…',
        unavailable:
          'Чтобы прикрепить фото, нужна последняя версия CopingCard. Обновите приложение в магазине и попробуйте ещё раз.',
        denied:
          'У CopingCard нет доступа к камере. Разрешите доступ в настройках телефона или выберите готовое фото.',
        failed:
          'Не удалось отправить фото. Проверьте подключение и попробуйте ещё раз.',
        noSession:
          'Не удалось подтвердить вход. Выйдите из аккаунта и войдите снова, затем прикрепите фото ещё раз.',
      },
    },
    video: {
      source: 'Воспроизводится в приложении — собственный плеер {{player}}. Этой ссылкой поделился Ваш терапевт; CopingCard не хранит видео.',
      target: 'Видео · {{link}}',
      ruleTitle: 'Посмотрите до конца',
      rule: 'Этот шаг отметится выполненным автоматически, когда Вы досмотрите видео до конца. Если закрыть его раньше, шаг останется открытым — Вы сможете вернуться.',
      close: 'Закрыть',
      unavailable: 'Это видео нельзя воспроизвести здесь — возможно, его удалили или автор разрешил показ только на других сайтах. Попросите Вашего терапевта отправить новую ссылку.',
      offline: 'Нет подключения? Просмотр сохранён на этом телефоне и отправится, когда Вы снова будете в сети.',
    },
    skip: {
      reasonLabel: 'Почему Вы хотите пропустить?',
      reasons: {
        notTime: 'Нет времени',
        notRelevant: 'Неактуально',
        tooHard: 'Слишком сложно',
        other: 'Другое',
      },
      lineLabel: 'Причина (необязательно)',
      linePlaceholder: 'Пару слов, если хотите',
      therapistSees:
        'Ваш терапевт увидит пропуск и причину. Он сможет вернуть задание в Ваш список.',
      submit: 'Пропустить',
    },
    addMine: {
      searchJournals: 'Поиск дневников',
      noJournalMatch: 'По запросу «{{query}}» дневников не найдено.',
    },
    self: {
      kindLabel: 'Тип',
      kinds: {
        task: 'задача',
        tool: 'инструмент',
        reading: 'чтение',
        link: 'ссылка',
        journal: 'дневник',
      },
      journalLabel: 'Дневник',
      journalNone: 'В библиотеке пока нет дневников.',
      titleLabel: 'Название',
      titlePlaceholder: 'Прогулка 20 минут перед работой',
      instructionsLabel: 'Инструкции (необязательно)',
      toolLabel: 'Инструмент',
      articleLabel: 'Статья',
      linkLabel: 'Ссылка',
      linkPlaceholder: 'https://',
      whenLabel: 'Когда',
      when: {
        none: 'Без даты',
        due: 'Срок выполнения',
        repeat: 'Повтор',
      },
      dueLabel: 'Срок',
      repeat: {
        daily: 'Каждый день',
        weekly: 'Каждую неделю',
        monthly: 'Каждый месяц',
      },
      timeLabel: 'Время',
      activityToggle: 'Добавить цель по активности',
      activityHint:
        'Если Вы откроете доступ к данным об активности на телефоне, оно сможет отмечаться автоматически.',
      activityTypes: {
        walking: 'Ходьба',
        running: 'Бег',
        cycling: 'Велосипед',
      },
      minutesEach: 'Минут за раз',
      timesPerWeek: 'Раз в неделю',
      submit: 'Добавить в мои задания',
      visibleToTherapists:
        'Терапевты, с которыми Вы делитесь данными, видят Ваши личные задания, но не могут их изменять.',
      problems: {
        titleRequired: 'Укажите название.',
        toolRequired: 'Выберите инструмент.',
        articleRequired: 'Выберите статью.',
        journalRequired: 'Выберите дневник.',
        linkInvalid: 'Введите веб-адрес, начинающийся с https://',
        activityInvalid: 'Укажите количество минут и сколько раз в неделю.',
        weekdayRequired: 'Выберите хотя бы один день недели.',
        dueInPast: 'Выберите срок и время в будущем.',
      },
    },
    remind: {
      title: 'Напомнить мне',
      none: 'На этом телефоне напоминаний пока нет.',
      add: 'Напомнить мне',
      addAnother: 'Добавить ещё напоминание',
      nextLine: 'Следующее: {{date}}',
      therapistNudges:
        'Напоминания о сроке от Вашего терапевта всё равно придут — это Ваше собственное дополнительное напоминание.',
      notificationTitle: 'Напоминание о домашнем задании',
      notificationBody:
        'Вас ждёт домашнее задание — откройте его, когда появится время.',
    },
    comments: {
      title: 'Комментарии',
      hint: 'Спросите о чём-нибудь терапевта или расскажите, как всё прошло. Он увидит это в CopingCard.',
      hintSelf:
        'Заметки к этому заданию. Терапевт, с которым Вы делитесь данными в CopingCard, сможет прочитать их и ответить.',
      empty: 'Комментариев пока нет.',
      you: 'Вы',
      add: 'Комментировать',
      placeholder: 'Напишите комментарий',
      send: 'Отправить',
      tooLong: 'Комментарий может содержать до 2 000 символов.',
      loadFailed: 'Не удалось загрузить комментарии. Проверьте подключение и попробуйте ещё раз.',
      retry: 'Попробовать ещё раз',
      cancelled: 'Это задание отменено, поэтому новые комментарии больше не принимаются.',
    },
    calendar: {
      add: 'Добавить в календарь',
      hint: 'Добавляет задание в Ваш календарь. Последующие изменения в CopingCard туда не копируются.',
      eventTitle: '{{title}} — CopingCard',
      eventNotes: 'Открыть в CopingCard: {{link}}',
      failed: 'Не удалось открыть календарь. Попробуйте ещё раз или добавьте событие вручную.',
    },
    homeCard: {
      title: 'Следующее задание',
      open: 'Открыть',
      all: 'Все задания',
      counts: 'к выполнению: {{open}} · просрочено: {{overdue}}',
      countsOpen: 'к выполнению: {{open}}',
    },
    conflictRetry:
      'Это задание только что изменили в другом месте. Обновите и попробуйте ещё раз.',
  },
  pathways: {
    mine: {
      entryTitle: 'Мои программы',
      entrySummary:
        'Программы от Вашего терапевта и программы, которые Вы начали сами',
      prescribed: 'Назначено: {{name}}',
      prescribedUnnamed: 'Назначено Вашим терапевтом',
      selfStarted: 'Вы начали эту программу',
      progress: '{{percent}}% · пройдено шагов: {{done}} из {{total}}',
      nextOn: 'Дальше: «{{title}}» · откроется {{date}}',
      nextAfterPrevious: 'Дальше: «{{title}}» · откроется после предыдущего шага',
      nextManual: 'Дальше: «{{title}}» · откроет Ваш терапевт',
      nextReady: 'Дальше: «{{title}}» · уже открывается',
      allReleased: 'Все шаги уже открыты',
      completed: 'Пройдено — отличная работа',
      empty:
        'Вы пока не проходите ни одной программы. Её может назначить Ваш терапевт, или Вы можете начать бесплатную программу сами.',
      courses: 'Программы',
      coursesHint:
        'Программы для самостоятельного прохождения, которые Вы можете начать сами',
      rowLabel: '{{name}}, пройдено {{percent}}%',
    },
    program: {
      prescribed: 'Эту программу назначил Ваш терапевт. Она входит в тариф практики, поэтому платить ничего не нужно. Чтобы прекратить её, обратитесь к терапевту.',
      selfStarted: 'Вы начали эту программу самостоятельно.',
      progress: '{{percent}}% · пройдено шагов: {{done}} из {{total}}',
      completed: 'Пройдено — отличная работа.',
      state: {
        locked: 'Закрыто',
        released: 'Доступно',
        done: 'Выполнено',
        skipped: 'Пропущено',
        withdrawn: 'Отменено Вашим терапевтом',
      },
      unlocks: 'Откроется {{date}}',
      unlocksNow: 'Уже открывается',
      unlocksAfterPrevious: 'Откроется после предыдущего шага',
      unlocksManual: 'Откроет Ваш терапевт',
      releasedOn: 'Открыто {{date}}',
      doneOn: 'Выполнено {{date}}',
      skippedOn: 'Пропущено {{date}}',
      stepLabel: '{{title}}, {{state}}',
      notFound: 'Эта программа больше недоступна. Вернитесь в раздел «Мои программы» и попробуйте ещё раз.',
    },
    courses: {
      empty:
        'Скоро здесь появятся новые программы: короткие и структурированные, для прохождения в удобном для Вас темпе. А пока Вы можете читать статьи и смотреть видео в разделе «Обучение».',
      by: 'Автор: {{name}}',
      steps: 'Шагов: {{count}}',
      access: {
        free: 'Бесплатно',
        purchase: 'Программа · разовая покупка',
        owned: 'Куплено',
      },
      start: 'Начать',
      open: 'Открыть',
      onIt: 'Вы проходите эту программу',
      startTitle: 'Начать «{{name}}»?',
      startBody:
        'Первый шаг появится в Ваших домашних заданиях в течение минуты. Вы сможете выйти из программы в любой момент.',
      startConfirm: 'Начать программу',
      startCancel: 'Не сейчас',
      buy: 'Купить',
      buyPrice: 'Купить · {{price}}',
      unlocking: 'Открытие доступа…',
      unlockSlow:
        'Магазин подтвердил покупку, но открытие доступа занимает больше времени, чем обычно. Потяните вниз через минуту, чтобы обновить. Если по-прежнему написано «Купить», напишите в support@copingcard.com.',
      buyCancelled: 'Покупка отменена. Ничего не изменилось.',
      buyPending:
        'Магазин всё ещё обрабатывает покупку — например, ожидает подтверждения. Доступ к программе откроется здесь, как только платёж пройдёт.',
      buyUnavailable:
        'Сейчас эту программу нельзя купить на этом телефоне. Убедитесь, что Вы вошли в App Store или Google Play, и попробуйте позже.',
      buyFailed: 'Магазину не удалось завершить покупку. Проверьте подключение и платёжные данные, затем попробуйте ещё раз.',
      restore:
        'Купили с этого аккаунта на другом телефоне? Здесь он тоже Ваш — потяните вниз, чтобы обновить.',
      startError:
        'Не удалось начать программу. Проверьте подключение и попробуйте ещё раз.',
      refusal: {
        PATHWAY_ALREADY_ENROLLED:
          'Вы уже проходите эту программу. Откройте её в разделе «Мои программы».',
        PATHWAY_RETIRED:
          'Эта программа больше недоступна. Обновите список и выберите другую.',
      },
    },
    leave: {
      button: 'Выйти из программы',
      title: 'Выйти из «{{name}}»?',
      body: 'Шаги, которые Вы не завершили, будут отменены в Ваших домашних заданиях. Всё, что Вы выполнили, останется в истории.',
      reasonLabel: 'Причина (необязательно)',
      reasonPlaceholder: 'Например: сейчас мне это не подходит',
      confirm: 'Выйти',
      keep: 'Продолжить',
      error: 'Не удалось выйти из программы. Проверьте подключение и попробуйте ещё раз.',
    },
  },
  worksheets: {
    importAgreeLabel: 'Я прочитал(а) и соглашаюсь',
    importFailed: 'Не удалось импортировать форму. Попробуйте ещё раз через минуту.',
    category: {
      sessions: 'Сессии и прогресс',
      problems: 'Проблемы и решения',
      selfEsteem: 'Самооценка и самосострадание',
      emotions: 'Эмоции и трудные моменты',
      relationships: 'Отношения и общение',
      homework: 'Домашнее задание',
      journal: 'Дневник',
      intake: 'Первичная анкета',
      consent: 'Форма согласия',
      lesson: 'Урок',
    },
    language: {
      en: 'Английский',
      ru: 'Русский',
    },
    fieldType: {
      text: 'Короткий ответ',
      longText: 'Развёрнутый ответ',
      number: 'Число',
      scale: 'Шкала',
      singleChoice: 'Один вариант',
      multiChoice: 'Несколько вариантов',
      date: 'Дата',
      checkbox: 'Флажок',
    },
    form: {
      progress: 'Раздел {{current}} из {{total}}',
      requiredLegend: '* Обязательно',
      answerPlaceholder: 'Ваш ответ',
      numberPlaceholder: 'Число',
      chooseDate: 'Выберите дату',
      clearDate: 'Очистить',
      next: 'Далее',
      back: 'Назад',
      submit: 'Отправить',
      doneReading: 'Прочитано',
      video: 'Видео — просмотр необязателен и нигде не фиксируется.',
      videoUnavailable: 'Это видео нельзя воспроизвести здесь.',
      notFound: 'Эта форма недоступна. Вернитесь к домашним заданиям и попробуйте ещё раз.',
      cancelled: 'Ваш терапевт отменил эту форму, поэтому её больше нельзя отправить.',
      sent:
        'Отправлено. Спасибо — теперь Ваш терапевт может увидеть Ваши ответы.',
      sentOn: 'Отправлено {{date}}.',
      paperPrompt: 'Предпочитаете бумагу? Сделайте фото заполненного бланка вместо того, чтобы заполнять форму здесь.',
      paperMarkDone: 'Отметить как выполненное с этим фото',
      signedOn: 'Отправлено и подписано {{date}}.',
      journalLast: 'Последняя запись отправлена {{date}}. Можно добавить ещё одну.',
      backToHomework: 'К домашним заданиям',
      draftKept: 'Ваши ответы сохраняются на этом телефоне, пока Вы их не отправите.',
    },
    sign: {
      title: 'Подпишите для завершения',
      intro: 'Ваши ответы отправлены. Форма будет завершена, когда Вы её подпишете: введите свои имя и фамилию и отметьте «Я соглашаюсь».',
      nameLabel: 'Ваши имя и фамилия',
      namePlaceholder: 'Имя и фамилия',
      agree: 'Я соглашаюсь',
      submit: 'Подписать',
      nameRequired: 'Введите свои имя и фамилию, чтобы подписать.',
      record: 'Ваше имя сохраняется вместе с датой, временем и устройством, с которого Вы подписываете форму.',
    },
    overTime: {
      entry: 'Динамика',
      title: '{{name}} — динамика',
      back: 'Назад к рабочим листам',
      chart: 'График',
      table: 'Таблица',
      summary_one: '{{count}} запись · {{from}} — {{to}}',
      summary_few: '{{count}} записи · {{from}} — {{to}}',
      summary_many: '{{count}} записей · {{from}} — {{to}}',
      summary_other: '{{count}} записи · {{from}} — {{to}}',
      legend_one: '{{label}}: последнее значение {{latest}} · {{count}} запись',
      legend_few: '{{label}}: последнее значение {{latest}} · {{count}} записи',
      legend_many: '{{label}}: последнее значение {{latest}} · {{count}} записей',
      legend_other: '{{label}}: последнее значение {{latest}} · {{count}} записи',
      score: 'Балл',
      entryColumn: 'Запись',
      open: 'Открыть',
      empty: 'Пока нет данных для графика',
      emptyHint: 'Числа появятся здесь после первой отправки.',
      emptySent: 'Отправлено {{date}}. Числа появятся здесь после первой отправки.',
      eyebrow: 'Карточка клиента · {{name}} · Рабочие листы и документы',
      eyebrowAnon: 'Карточка клиента · Рабочие листы и документы',
      note: 'Только числовые поля (число · шкала). Текстовые ответы остаются в каждой записи — откройте её, чтобы прочитать. Это собственные показатели клиента: баллы здесь не оцениваются и не вызывают оповещений.',
      loadFailed: 'Не удалось загрузить этот рабочий лист. Попробуйте ещё раз через минуту.',
      notAvailable: 'Этот рабочий лист недоступен.',
      chartLabel: 'Линейный график динамики: {{name}}',
      entries: 'Записи',
      pointLabel: '{{label}}, {{date}}: {{value}}',
    },
  },
  reminders: {
    // E05 · ядро напоминаний на RRULE. Коды отказов решателя
    // (packages/domain/src/reminders/errors.ts) — по одному ключу на код, на обоих языках;
    // тест error-codes-i18n падает, если ключа нет.
    errors: {
      REMINDER_NOT_FOUND:
        'Это напоминание больше недоступно. Вернитесь назад и откройте список напоминаний снова.',
      REMINDER_ALREADY_ENDED:
        'Это напоминание уже выключено. Включите его снова, чтобы изменить расписание.',
      REMINDER_RULE_NOT_SUPPORTED:
        'Такой вариант повтора пока не поддерживается. Выберите ежедневно, еженедельно, ежемесячно или одну дату.',
      REMINDER_DTSTART_MISMATCH:
        'Дата начала не совпадает с выбранным повтором. Укажите дату, на которую напоминание действительно может выпасть.',
      REMINDER_TIMEZONE_INVALID:
        'Для напоминания нужен распознаваемый часовой пояс. Проверьте настройку часового пояса на устройстве и попробуйте ещё раз.',
      REMINDER_ZONE_REQUIRED_ON_BEHALF:
        'Напоминание, которое Вы создаёте для клиента, должно указывать часовой пояс клиента — тогда оно придёт к нему в выбранное Вами время.',
      REMINDER_SUBJECT_ZONE_UNKNOWN:
        'Часовой пояс этого клиента пока неизвестен, поэтому напоминание может прийти не в то время суток. Попросите клиента один раз открыть приложение, затем создайте напоминание.',
      REMINDER_TARGET_NOT_SUPPORTED:
        'Для этого типа записи напоминания пока недоступны.',
      REMINDER_CHANNEL_NOT_SUPPORTED:
        'Такой способ доставки напоминания недоступен. Выберите уведомление на устройстве.',
      REMINDER_OCCURRENCE_NOT_FOUND:
        'В эту дату напоминание не срабатывает, поэтому пропускать было нечего.',
      REMINDER_TARGET_IMMUTABLE:
        'Напоминание нельзя перенести на другую карточку. Создайте напоминание там.',
      REMINDER_NOT_CONVERTED:
        'Это напоминание ещё готовится. Пожалуйста, попробуйте через минуту.',
      // Три отказа массовых действий. Каждый — идемпотентный no-op на уровне резолвера (сигнал о
      // понижении тарифа пришёл дважды, возврат подписки у того, кого не урезали, карточка без
      // напоминаний), поэтому пользователь их видеть не должен. Ключи есть потому, что доменный
      // код — закон, а код без текста не проходит тест error-codes-i18n.
      REMINDER_NOTHING_TO_TRIM:
        'Ваши напоминания и так укладываются в бесплатный тариф — ничего не выключено.',
      REMINDER_NOTHING_TO_RESTORE:
        'Возвращать нечего. Напоминания, которые Вы выключили сами, остаются выключенными.',
      REMINDER_NO_SCHEDULES_FOR_TARGET:
        'У этой карточки нет напоминаний — выключать было нечего.',
      REMINDER_NOT_STOPPED:
        'Это напоминание ещё включено. Выключите его или измените время в самом напоминании.',
      USER_NOT_AUTHORIZED:
        'У Вас нет доступа к этому напоминанию. Если это ошибка, напишите в support@copingcard.com и укажите код REMINDER-AUTH-1.',
    },
    // Два ответа слоя резолверов, когда ошибка — не именованный код решателя: отказ без
    // собственного текста и проигранная гонка DCB (два сохранения одного расписания).
    command: {
      rejected: 'Не удалось сохранить это напоминание. Попробуйте ещё раз.',
      conflictRetry:
        'Это напоминание только что изменили в другом месте. Откройте его заново и повторите изменение.',
    },
    // Краткое описание правила для строки списка и для скринридера. Домен возвращает ключ и
    // значения (packages/domain/src/reminders/rrule/describe.ts); сама фраза живёт здесь, чтобы
    // согласование по падежам и числам оставалось на виду у переводчика.
    summary: {
      daily: 'Каждый день в {{time}}',
      everyNDays: 'Каждые {{interval}} дн. в {{time}}',
      weekly: 'Каждую неделю: {{days}}, в {{time}}',
      everyNWeeks: 'Каждые {{interval}} нед.: {{days}}, в {{time}}',
      monthlyOnDay: 'Каждый месяц, {{day}}-го числа, в {{time}}',
      monthlyOnNthWeekday: 'Каждый месяц, {{nth}} {{day}}, в {{time}}',
      everyNMonths: 'Каждые {{interval}} мес. в {{time}}',
      yearly: 'Каждый год, {{date}}, в {{time}}',
      everyNYears: 'Каждые {{interval}} г. — {{date}}, в {{time}}',
      oneTime: 'Один раз, {{date}}, в {{time}}',
      unsupported:
        'В этом напоминании используется расписание, которое эта версия не может показать. Обновите приложение.',
      boundNever: 'Повторяется бессрочно',
      boundCount: 'Повторится {{count}} раз(а)',
      boundUntil: 'Повторяется до {{date}}',
      skipped_one: 'Пропущен {{count}} раз',
      skipped_few: 'Пропущено {{count}} раза',
      skipped_many: 'Пропущено {{count}} раз',
      skipped_other: 'Пропущено {{count}} раз',
    },
  },
  // ── E05 · R1 (2026-09-05) — E-ЭРА: экран напоминаний карточки ─────────────────────────────
  // Список расписаний вместо трёх фиксированных слотов: краткое описание правила, ближайшее
  // срабатывание, добавление через подборщик, пропуск одного дня и раздел выключенных.
  reminderSchedules: {
    title: 'Напоминания для карточки',
    intro:
      'У каждого напоминания своё расписание. Добавьте столько, сколько нужно, пропустите один день или выключите напоминание, не теряя выбранное время.',
    addSchedule: 'Добавить напоминание',
    empty: 'Напоминаний пока нет. Добавьте, чтобы вспоминать об этой карточке.',
    ruleSummary: 'Напоминание: {{summary}}',
    nextOccurrence: 'Ближайшее: {{when}}',
    noNextOccurrence: 'Ближайших срабатываний нет',
    skipNext: 'Пропустить ближайшее',
    skipNextDone: 'Ближайшее срабатывание пропущено.',
    editSchedule: 'Изменить',
    stoppedTitle: 'Выключенные',
    stoppedHint:
      'Они помнят выбранное время. Включите — и напоминание снова заработает.',
    changeTime: 'Изменить время',
    removeSchedule: 'Удалить',
    removeConfirmTitle: 'Удалить это напоминание?',
    removeConfirmText:
      'Напоминание остановится и исчезнет из карточки. Новое можно добавить в любой момент.',
    toggleOn: 'Включить это напоминание',
    toggleOff: 'Выключить это напоминание',
  },
  // Подборщик расписания — он собирает только разрешённые правила v1; произвольный ввод не
  // предусмотрен, потому что правило вне набора — это уведомление во время, которое никто не выбирал.
  reminderSchedulePicker: {
    titleNew: 'Новое напоминание',
    titleEdit: 'Изменить напоминание',
    freqLabel: 'Как часто',
    freq: {
      daily: 'Каждый день',
      weekly: 'Каждую неделю',
      monthly: 'Каждый месяц',
      oneTime: 'Один раз',
    },
    intervalLabel: 'Повторять каждые',
    intervalUnit_daily_one: 'день',
    intervalUnit_daily_few: 'дня',
    intervalUnit_daily_many: 'дней',
    intervalUnit_daily_other: 'дней',
    intervalUnit_weekly_one: 'неделю',
    intervalUnit_weekly_few: 'недели',
    intervalUnit_weekly_many: 'недель',
    intervalUnit_weekly_other: 'недель',
    intervalUnit_monthly_one: 'месяц',
    intervalUnit_monthly_few: 'месяца',
    intervalUnit_monthly_many: 'месяцев',
    intervalUnit_monthly_other: 'месяцев',
    daysLabel: 'В эти дни',
    monthDayLabel: 'День месяца',
    timeLabel: 'Во сколько',
    startsLabel: 'Начиная с',
    endLabel: 'Заканчивается',
    endNever: 'Никогда',
    endAfter: 'После определённого числа раз',
    endOn: 'В указанную дату',
    endCountLabel: 'Сколько раз',
    endUntilLabel: 'Последний день',
    dstNote:
      'Время с 2:00 до 3:00 пропускается в ночь перевода часов вперёд — в этот день напоминание не придёт.',
    invalidRule:
      'Такое сочетание нельзя запланировать. Измените правило повтора или день начала.',
    endBeforeStart:
      'Последний день раньше первого напоминания. Выберите более поздний последний день или более ранний день начала.',
    weekdayRequired: 'Выберите хотя бы один день недели.',
    save: 'Сохранить напоминание',
    weekday: {
      MO: 'Пн',
      TU: 'Вт',
      WE: 'Ср',
      TH: 'Чт',
      FR: 'Пт',
      SA: 'Сб',
      SU: 'Вс',
    },
  },
  downwardArrow: {
    upsert: {
      rejected:
        'Не удалось сохранить эту нисходящую стрелу — проверьте записи и попробуйте ещё раз.',
      conflictRetry:
        'Эта нисходящая стрела только что была изменена на другом устройстве. Загружаем актуальную версию…',
    },
    // коды отказов решателя (packages/domain/src/downwardArrow/errors.ts) — по одному ключу на код,
    // на обоих языках; тест error-codes-i18n падает, если ключа нет
    errors: {
      BELIEFS_REQUIRED:
        'Напишите хотя бы одно убеждение, прежде чем сохранить нисходящую стрелу.',
      BELIEF_EMPTY: 'Заполните каждый шаг цепочки или удалите его.',
    },
  },
  thoughtTesting: {
    submit: {
      invalid:
        'Не удалось прочитать некоторые шаги этого теста мысли. Проверьте записи и попробуйте снова.',
      rejected:
        'Не удалось сохранить этот шаг — проверьте запись и попробуйте снова.',
      conflictRetry:
        'Этот тест мысли только что обновился на другом устройстве. Загружаем последние шаги…',
    },
    // коды отказа решателя (packages/domain/src/thoughtTesting/errors.ts) — по ключу на код, на обоих языках
    errors: {
      DESCRIPTION_REQUIRED:
        'Пожалуйста, опишите событие, прежде чем продолжить.',
      UNKNOWN_THOUGHT_TEST_EVENT_TYPE:
        'Этот шаг создан более новой версией приложения. Обновите CopingCard, чтобы продолжить.',
      AUTOMATIC_THOUGHT_REQUIRED:
        'Пожалуйста, напишите автоматическую мысль для лицевой стороны карточки.',
      ALTERNATIVE_THOUGHT_REQUIRED:
        'Пожалуйста, напишите хотя бы одну реалистичную мысль для обратной стороны карточки.',
      THOUGHT_TEST_NOT_FOUND:
        'Не удалось найти эту карточку. Обновите список и попробуйте снова.',
      THOUGHT_TEST_DELETED:
        'Эта карточка удалена. Обновите список, чтобы увидеть актуальные карточки.',
      EVIDENCE_FOR_REQUIRED:
        'Пожалуйста, добавьте хотя бы один факт, подтверждающий мысль.',
      EVIDENCE_AGAINST_REQUIRED:
        'Пожалуйста, добавьте хотя бы один факт, опровергающий мысль.',
      RESULT_OUT_OF_RANGE:
        'Пожалуйста, оцените, насколько Вы верите мысли, от 0 до 100.',
      LOCATION_REQUIRED: 'Пожалуйста, выберите место для этого напоминания.',
      LOCATION_RELATION_UNSUPPORTED:
        'Это напоминание нельзя привязать к этому месту. Выберите другое.',
      REMINDER_PRESET_UNKNOWN:
        'Этот вариант напоминания доступен в новой версии приложения. Пожалуйста, обновите CopingCard.',
      SITUATION_NOT_FOUND:
        'Не удалось найти эту ситуацию. Обновите список и попробуйте снова.',
      SITUATION_HOLDS_CARDS:
        'К этой ситуации ещё привязаны карточки. Сначала удалите карточки — ситуация останется здесь как черновик.',
      SITUATION_ALREADY_DELETED:
        'Эта ситуация уже удалена. Обновите список, чтобы увидеть актуальные записи.',
    },
    // навигация мастера E-эры (решение основателя Q12, 2026-09-05)
    wizard: {
      thoughtChip: 'Мысль {{index}} из {{count}}',
      oneThoughtTitle: 'Ваша автоматическая мысль',
      exit: 'Сохранить и выйти',
      summaryTitle: 'Эта мысль проверена',
      summaryBody:
        'Карточка готова. Можно разобрать ещё одну мысль об этой же ситуации или закончить — всё сохранено в любом случае.',
      testAnotherThought: 'Проверить ещё одну мысль об этой ситуации',
      done: 'Готово',
      resumeTitle: 'Продолжите с того места, где остановились',
      resumeSubtitle:
        'Эти тесты мыслей ещё не закончены. Нажмите на любой, чтобы вернуться к нужному шагу.',
      resumeEmpty:
        'Незаконченных тестов нет — всё, что Вы начинали, завершено.',
      resumeStart: 'Начать новый тест мысли',
      resumeDraft: 'Ещё не начата',
      resumeStepLabel: 'Следующий шаг: {{step}}',
      situationThoughtCount: 'мыслей: {{count}}',
      deleteSituation: 'Удалить ситуацию',
      deleteSituationConfirmTitle: 'Удалить эту ситуацию?',
      deleteSituationConfirmBody:
        'К ней не осталось ни одной карточки, так что ничего созданного Вами не пропадёт. Отменить это будет нельзя.',
      deleteSituationConfirm: 'Удалить',
      deleteSituationCancel: 'Оставить',
      stepNames: {
        activatingEvent: 'событие',
        behaviors: 'что Вы сделали',
        automaticThought: 'автоматическая мысль',
        evidenceFor: 'подтверждающие факты',
        evidenceAgainst: 'опровергающие факты',
        cognitiveDistortions: 'когнитивные искажения',
        alternativeThought: 'реалистичные мысли',
        outcome: 'результат',
      },
    },
  },
  thoughtsTesting: {
    addEvidenceAgainst: 'Добавить опровергающий факт',
    addEvidenceFor: 'Добавить факт',
    automaticThought: 'Автоматическая мысль',
    automaticThoughtAdd: 'Добавить мысль',
    automaticThoughtBelief: 'Убеждённость',
    automaticThoughtDefinition:
      'Идея или зрительный образ, оценка события или себя в нем, которые появились у Вас вместе или незадолго до ухудшения состояния.',
    automaticThoughtName: 'Название',
    autoThoughtsTitle: 'Перечислите автоматические мысли',
    buttonNextText: 'Далее',
    chooseEmotions: 'Выберите эмоции',
    chooseFeelings: 'Выберите ощущения',
    cognitiveDistortions: 'Когнитивные искажения',
    cognitiveDistortionsDefinition:
      'Когнитивное искажение — это преувеличенный или иррациональный паттерн мышления.',

    cognitiveDistortionsPlaceholder: 'Выберите когнитивные искажения',
    congrats: 'Поздравляем!',
    congratsCardCreated: `В результате была создана новая Копинг-карта`,
    congratsCardsCreatedEnd: `новых Копинг-карт было создано в результате`,
    congratsCardsCreatedStart: ``,
    congratsIntro: `Вы закончили тестирование Ваших автоматических мыслей!`,
    congratsTextPlural: `Вы можете найти Копинг-карты для этих мыслей в разделе Копинг-карты нашего приложения.`,
    congratsTextSingle: `Вы можете найти Копинг-карту для этой мысли в разделе Копинг-карты нашего приложения.`,
    dateAndDuration: 'Дата и продолжительность события',
    day: 'Дневное напоминание',
    emotionDefinition:
      'ЭМОЦИИ — психический процесс, отражающий в форме непосредственного переживания (удовлетворения, радости, страха и т. д.) значимость действующих на человека явлений и ситуаций. Частью переживания эмоций являются телесные ощущения.',
    emotionsTitle: 'Укажите свои эмоции',
    evening: 'Вечернее напоминание',
    eventInfo: 'Событие, на фоне которого Ваше состояние заметно ухудшилось.',
    eventLabel: 'Опишите активирующее событие',
    eventLasted: 'продолжалось',
    eventStarted: 'началось',
    eventTitle: 'Активирующее событие',
    evidenceAgainst: 'Факт, опровергающий мысль',
    evidenceFor: 'Факт, поддерживающий негативную мысль',
    withEvidenceFor: 'Фактом в поддержку',
    withEvidenceAgainst: 'Фактом(ами) опровергающим(и) автоматическую мысль',
    alternativeThought: 'Альтернативное объяснение',
    alternativeThoughtInfo:
      'Приведите возможное альтернативное объяснение для фактов в поддержку автоматической мысли, если они есть.',
    alternativeThoughtTitle:
      'Каким ещё может быть объяснение этого факта, кроме Вашей изначальной мысли?',
    feelingsDefinition:
      'ОЩУЩЕНИЕ (англ. sensation ) — процесс чувственного познания отдельных свойств явлений и предметов объективного мира, т. е. процесс отражения прямого воздействия стимулов на органы чувств (рецепторы).',
    feelingsInBody: 'Ощущения в теле',
    feelingsTitle: 'Укажите общие ощущения',
    forThought: 'Для автоматической негативной мысли',
    with: 'С',
    having: 'Который может иметь',
    location: 'Место',
    locationReminders: 'Геолокационные напоминания',
    locationRemindersDisclosure:
      'Copingcard требуется сбор данных о точном местоположении, даже когда приложение закрыто или не используется, чтобы иметь возможность напоминать Вам о Ваших карточках, используя геолокацию.',
    locationRemindersDeferred:
      'Напоминания по геолокации будут подключены в отдельной миграции этого функционала. Сейчас Вы можете продолжить и завершить тест мыслей.',
    locationRemindersWhy:
      'Геолокационные напоминания могут помочь Вам вспомнить реалистичные мысли, когда Вы приближаетесь к (200м) и/или покидаете какое-то место. ',
    morning: 'Утреннее напоминание',
    optionalData: 'Дополнительные сведения',
    participants: 'Участники',
    photos: 'Фото или изображение',
    photosDialogueTitle: 'Выберите источник изображения',
    rateEmotions: 'Оцените силу эмоций',
    realisticThought: 'Реалистичная мысль или идея',
    realisticThoughtsDefinition:
      'Суждения о событии или себе , которые вытекают из приведённых Вами фактов или (в случае невозможности проверить изначальную мысль фактами) помогают Вам чувствовать себя лучше.',
    realisticThoughtsTitle: 'Реалистичные и полезные мнения',
    reminderLabel: 'Выберите время напоминания',
    reminders: 'Напоминания',
    remindersWhy:
      'Прочтение автоматической и реалистичной мысли несколько раз в день значительно снижает эффект автоматических негативных мыслей. Мы создали 3 напоминания, чтобы помочь Вам прочитать эти мысли. Здесь Вы можете настроить время на более удобное для Вас.',
    resultBelief: 'Насколько Вы верите в свои первоначальные негативные мысли?',
    resultEmotionStrength:
      'Насколько сильна основная первоначальная негативная эмоция?',
    resultsTitle: 'Результат',
    saveError:
      'Не удалось сохранить этот тест мыслей. Попробуйте еще раз. Если ошибка повторится, напишите в support@copingcard.com.',
    selectEnd: 'Выберите время завершения события',
    selectStart: 'Выберите время начала события',
    thoughtForForThought: 'для мысли',
    thoughtsAgainstDefinition:
      'Преимущественно доступные чувственному восприятию и проверке конкретные явления действительности (факты), которые опровергают проверяемую мысль.',
    thoughtsAgainstTitle: 'Факты, опровергающие негативную мысль',
    thoughtsForDefinition:
      'Преимущественно доступные чувственному восприятию и проверке конкретные явления действительности (факты), которые свидетельствуют о том, что эта мысль является верной.',
    thoughtsForTitle: 'Факты, доказывающие негативную мысль',
    timeReminders: 'Напоминания по времени',
    validationErrors:
      'Похоже, есть некоторые ошибки. Пожалуйста, исправьте их, прежде чем продолжить, или обратитесь в службу поддержки, если  не понятно, как их исправить.',
  },
  validators: {
    email: 'должен быть действительным адресом электронной почты',
    regex: 'должно соответствовать следующему: {{regex}}',
    required: 'является обязательным полем',
    retypePassword: 'пароли должны совпадать',
    stringMax: 'должно быть не более {{max}} символов',
    stringMin: 'должно быть не менее {{min}} символов',
    url: 'Пожалуйста, введите корректный URL',
  },
  viciousCycles: {
    title: 'Поддерживающие циклы',
    info: 'Поддерживающие циклы',
    definition: `В когнитивно-поведенческой терапии поддерживающие циклы относятся к паттернам негативных мыслей, эмоций и поведения, которые поддерживают или усугубляют определенную проблему. Эти циклы включают в себя самовоспроизводящуюся петлю, в которой негативные убеждения и эмоции приводят к неадекватному поведению, которое, в свою очередь, усиливает негативные убеждения и эмоции. Результатом является ухудшение проблемы, а также увеличение интенсивности негативных мыслей, эмоций и поведения, связанных с ней. Цель когнитивно-поведенческой терапии состоит в том, чтобы выявить и разорвать эти порочные круги, помогая клиентам разработать более адаптивные убеждения и стратегиии преодоления трудностей, которые в конечном итоге могут привести к позитивным изменениям и улучшению самочувствия.`,
    edit: 'Редактировать цикл',
    totalCount: 'Всего: {{count}}',
    create: 'Создать поддерживающий цикл',
    advancedWarning1: `Это продвинутая техника когнитивно-поведенческой терапии. Если Вы не знаете, как ее использовать, может быть лучше `,
    advancedWarning2: ` использовать нашу Платформу или `,
    advancedWarning3: ` того, кто уже использует ее в терапии.`,
    inviteTherapist: `пригласить Вашего терапевта`,
    deleteSuccess: 'Поддерживающий цикл успешно удален',
    deleteConfirmTitle: 'Удалить поддерживающий цикл?',
    deleteConfirmText:
      'Этот поддерживающий цикл будет удалён без возможности восстановления.',
    therapistFind: 'найти',
  },
  viciousCycle: {
    title: 'Поддерживающий цикл',
    selectTemplate: 'Выберите шаблон (опционально)',
    cycleName: 'Название',
    thoughts: 'Мысли, действия или факты',
    relations: 'Приводит к',
    influences: 'Влияет на:',
    tempalteLabel: 'Использовать шаблон (опционально)',
    saveSuccess: 'Поддерживающий цикл успешно сохранен',
    saveError:
      'Не удалось сохранить этот поддерживающий цикл. Пожалуйста, попробуйте еще раз. Если проблема повторится, напишите в support@copingcard.com.',
    addField: 'Добавить мысль, действие или факт',
    // E12 (ES-era) — command outcomes and the decider's rejection codes
    command: {
      rejected:
        'Не удалось сохранить поддерживающий цикл — проверьте записи и попробуйте ещё раз.',
      conflictRetry:
        'Этот поддерживающий цикл только что обновили на другом устройстве. Загружаем последнюю версию…',
    },
    errors: {
      VICIOUS_CYCLE_NOT_FOUND:
        'Этого поддерживающего цикла больше нет. Вернитесь к списку и попробуйте ещё раз.',
      VICIOUS_CYCLE_ALREADY_EXISTS:
        'Этот поддерживающий цикл уже создан. Обновите страницу и продолжите редактирование.',
      USER_NOT_AUTHORIZED:
        'У Вас нет доступа к этому поддерживающему циклу. Если это ошибка, напишите в support@copingcard.com и укажите код CYCLE-AUTH-1.',
      INDEX_OUT_OF_RANGE:
        'Эта часть круга изменилась. Обновите страницу и попробуйте ещё раз.',
    },
  },
  shared: {
    genderOptions: ['Мужской', 'Женский', 'Другой'],
    preferredPronounsOptions: ['Он/Его', 'Она/Её', 'Они/Их'],
    abcModel: {
      title: 'ABC-модель',
      saveSuccess: 'ABC-модель успешно сохранена',
      saveError:
        'Не удалось сохранить эту ABC-модель. Пожалуйста, попробуйте еще раз. Если проблема повторится, напишите в support@copingcard.com.',
      loadError:
        'Не удалось загрузить эту ABC-модель. Пожалуйста, откройте ее еще раз или попробуйте немного позже. Если проблема повторится, напишите в support@copingcard.com.',
      description: `ABC-модель техника Когнитивно-поведенческой терапии (КПТ) - это инструмент, который помогает людям понять связь между их мыслями, эмоциями и поведением. Модель основана на предположении, что источником эмоционального дискомфорта являются не сами события, а наше восприятие этих событий. Модель ABC состоит из трех основных компонентов: 

      A - Активирующее событие: ситуация или триггер, вызывающий мысль или эмоцию. 
      
      B - Когнитивная оценка: мысли или трактовки, которые мы делаем об активирующем событии. 
      
      C - Реакция: эмоциональные, физиологические и поведенческие реакции, возникающие из-за наших когниций. 
      
      Цель ABC-модели состоит в том, чтобы помочь людям определить и противостоять своим иррациональным или дисфункциональным убеждениям и заменить их более здоровыми и адаптивными мыслями, что способствует более позитивным эмоциональным и поведенческим результатам.
      `,
      a: 'A - Активирующее событие',
      aPlaceholder: 'Что произошло?',
      b: 'B - Когнитивная оценка',
      bPlaceholder: 'Что Вы подумали?',
      c: 'C - Реакция',
      behaviors: 'Поведение',
      behaviorsPlaceholder: 'Как Вы себя повели?',
      emotions: 'Эмоции',
      emotionsPlaceholder: 'Какие эмоции Вы испытали?',
      sensations: 'Физические ощущения',
      sensationsPlaceholder: 'Какие физические ощущения Вы испытали?',
    },
    abcModels: {
      title: 'ABC-модель',
      create: 'Создать ABC-модель',
      edit: 'Редактировать ABC-модель',
      loadError:
        'Не удалось загрузить Ваши ABC-модели. Пожалуйста, обновите экран или попробуйте немного позже. Если проблема повторится, напишите в support@copingcard.com.',
      spec: {
        a: 'Я опоздал на 15 минут на совещание',
        b: 'Я неорганизованный',
        cBehavior: 'Я решил вообще пропустить совещание',
      },
    },
    behaviorExperiment: {
      spec: {
        hypothesisA: `Я застыну и поставлю себя в неловкое положение, если попытаюсь выступить публично.`,
        hypothesisAStrength: '90',
        hypothesisAConfirmationCriteria:
          'Клиент становится молчаливым и растерянным во время выступления',
        hypothesisB:
          'Я смогу успешно выступить публично, и мое выступление будет положительно воспринято',
        hypothesisBStrength: '30',
        hypothesisBConfirmationCriteria:
          'Клиент демонстрирует уверенность, проводит выступление без серьезных проблем',
        settings: {
          experiment: 'Публичное выступление перед группой людей',
          time: 'Вечер',
          place: 'Комната для тренировочного выступления или аудитория',
          people: '5-10 зрителей, предпочтительно знакомых',
          resources: 'Микрофон, проектор',
        },
        safetyBehaviors: 'Передышка, замедление речи, использование заметок',
        helpfulCopingStrategies:
          'Техники дыхания, самоутверждение, визуализация успеха',
        prediction: {
          behaviors: 'Нервозность, потеря мысли, заготовленные фразы',
          emotions: ['безнадежность', 'тревога'],
          feelings: ['озноб', 'изменение сердцебиения'],
          otherPredictions: 'Благожелательность аудитории, аплодисменты',
        },
        followUpExperimentsIdeas:
          'Выступление перед большей аудиторией, выступление без заметок',
      },
      title: 'Поведенческий эксперимент',
      description: `Поведенческий эксперимент — это метод, обычно используемый в когнитивно-поведенческой терапии (КПТ) для проверки достоверности убеждений и предположений клиента. Цель эксперимента — собрать эмпирические данные, которые бросают вызов дисфункциональным мыслям и поведению пациента и заменяют их более реалистичными и адаптивными.

В поведенческом эксперименте терапевт и пациент совместно разрабатывают эксперимент, чтобы проверить предположения или убеждения пациента. Например, если пациент боится публичных выступлений, эксперимент может включать в себя короткое выступление перед небольшой группой доверенных лиц. Терапевт и пациент наблюдают и оценивают переживания пациента, включая любые физиологические или эмоциональные реакции и любую полученную обратную связь.

Проведя эксперимент и проанализировав результаты, пациент может получить новое представление о своих мыслях и поведении и разработать более адаптивные стратегии преодоления. Поведенческие эксперименты часто используются в сочетании с другими методами когнитивно-поведенческой терапии, такими как когнитивная реструктуризация, чтобы помочь пациентам бросить вызов своим дисфункциональным моделям мышления и изменить их.
      `,
      purpose: 'Цель эксперимента',
      purposeRequired: 'Цель эксперимента обязательна',
      purposePlaceholder: 'Что Вы хотите протестировать?',
      purposes: [
        'Выработка формулирования/концептуализации',
        'Проверка негативных когниций',
        'Создание и проверка новых точек зрения',
      ],
      purposesTip: `Выработка формулирования/концептуализации: эти эксперименты помогают сформулировать роблемы пациента, особенно в начале терапии, когда понимание еще только развивается. Эти эксперименты дают терапевтам и клиентам возможность наблюдать за тонкими аспектами поведения и мышления пациента, которые могут быть недоступны только через словесные отчеты, основанные на памяти.
       Проверка негативных когниций: проверка негативных когниций, снижение доверия к устаревшим и бесполезным негативным автоматическим мыслям, дисфункциональным предположениям и глубинным убеждениям. Эти эксперименты позволяют пациентам увидеть обоснованность новых, более адаптивных точек зрения через непосредственный личный опыт.
       Создание и проверка новых точек зрения: создание и укрепление новых, более реалистичных и более полезных мыслей, предположений и убеждений.
      `,
      design: 'Структура эксперимента',
      designRequired: 'Структура эксперимента обязательна',
      designs: [
        'Эксперимент, проверяющий гипотезу(ы)',
        'Поисковый эксперимент',
      ],
      designsTip: `Эксперименты по проверке гипотез пытаются найти ответы на вопросы, похожие на «Правда ли, что…?».
      Поисковые эксперименты — это более открытые, исследовательские, ориентированные на открытия вопросы, подобные «Что произойдет, если…». . . ?`,
      hypotheses: 'Гипотезы',
      hypothesisType: 'Количество гипотез',
      hypothesisTypeVariants: [
        'Проверка гипотезы А',
        'Сравнение гипотез А и Б',
        'Проверка гипотезы Б',
      ],
      hypothesisTypeVariantsTip: `
      Тестирование гипотезы А: проверяет достоверность текущей негативной мысли или убеждения (гипотеза А).
      Сравнение гипотез А и Б: проверяет достоверность текущей негативной мысли (гипотеза А) и новой, возможно полезной или обоснованной мысли (гипотеза Б).
      Тестирование гипотезы Б: проверяет достоверность новой, возможно полезной мысли (гипотеза Б).
      `,
      type: 'Тип эксперимента',
      typeVariants: ['Активный эксперимент', 'Наблюдательный эксперимент'],
      activeSubtype: 'Подтип активного эксперимента',
      activeSubtypes: [
        'В реальных ситуациях',
        'В смоделированных ситуациях (ролевая игра)',
      ],
      observationalSubtype: 'Подтип наблюдательного эксперимента',
      observationalSubtypes: [
        'Прямое наблюдение (моделирование)',
        'Опрос',
        'Информация, полученная из других источников',
      ],
      settings: 'Условия',
      timeAndPlace: 'Время и место',
      time: 'Дата и время',
      place: 'Место',
      people: 'Люди',
      peoplePlaceholder: 'Кто будет участвовать в эксперименте?',
      resources: 'Ресурсы и инструменты',
      resourcesPlaceholder: 'Какие ресурсы Вам понадобятся?',
      survey: 'Опрос',
      surveyPlaceholder:
        'Информация об опросе, который Вы могли бы использовать.',
      safetyBehaviors: 'Охранительное(избегающее) поведение',
      safetyBehaviorsPlaceholder:
        'Какое охранительное(избегающее) поведение Вы попробуете не использовать?',
      safetyBehaviorsTip: `Охранительное поведение — это действия, предпринимаемые для уменьшения негативных эмоций в ситуациях, в которых они возникают. Подавление такого поведения имеет решающее значение в поведенческих экспериментах, чтобы предотвратить их влияние на эксперимент и процесс терапии.
       Если охранительное поведение сохраняется, оно может укрепить убеждение человека в том, что стимул или ситуация опасны, и что помогает именно безопасное поведение, тем самым поддерживая или даже усиливая негативные эмоции.
        `,
      safetyAndCoping: 'Безопасное поведение и копинг-стратегии',
      selectOrType: 'Выберите или введите',

      helpfulCopingStrategies: 'Полезные копинг-стратегии',
      helpfulCopingStrategiesPlaceholder:
        'Какие копинг-стратегии Вы можете использовать, чтобы справиться с ситуацией?',
      hypothesisA: 'Гипотеза А',
      hypothesisAPlaceholder:
        'Какую мысль или убеждение Вы хотели бы проверить?',
      hypothesisAStrength: 'Как сильно Вы верите в гипотезу А?',
      hypothesisATip:
        'Гипотеза А — это текущая дисфункциональная мысль или убеждение, которую Вы хотите проверить.',
      hypothesisAConfirmationCriteria:
        'Критерии/признаки подтверждения Гипотезы А',
      hypothesisB: 'Гипотеза Б',
      hypothesisBPlaceholder:
        'Какую правдоподобную и полезную альтернативную мысль или убеждение Вы хотели бы проверить?',
      hypothesisBStrength: 'Как сильно Вы верите в гипотезу Б?',
      hypothesisBTip:
        'Гипотеза Б — это новая, возможно полезная мысль или убеждение, которую Вы хотите проверить.',
      hypothesisBConfirmationCriteria:
        'Критерии/признаки подтверждения Гипотезы Б',
      experiment: 'Эксперимент',
      expremientPlaceholder: 'Как Вы планируете проверить гипотезу?',
      prediction: 'Прогноз',
      expectedEmotions: 'Ожидаемые эмоции',
      expectedEmotionsPlaceholder:
        'Какие эмоции Вы ожидаете испытать во время эксперимента?',
      predictionPlaceholder: 'Что, по Вашему мнению, должно произойти?',
      expectedFeelings: 'Ожидаемые физические ощущения',
      behaviors: 'Ожидаемая реакция среды/людей',
      behaviorsPlaceholder:
        'Как отреагировало окружение, другие люди и Вы сами?',
      physicalReactions: 'Физические реакции',
      physicalReactionsPlaceholder:
        'Как Вы думаете, как отреагирует Ваше тело?',
      otherPredictions: 'Другие прогнозы',
      otherPredictionsPlaceholder: 'Что ещё Вы можете предположить?',
      outcome: 'Результат',
      outcomePlaceholder: 'Что произошло?',
      actualBehavior: 'Фактическая реакция среды/людей',
      actualBehaviorPlaceholder: 'Как Вы действительно повели себя?',
      actualEmotions: 'Фактические эмоции',
      actualFeelings: 'Фактические физические ощущения',
      newThought: 'Новая мысль или убеждение',
      newThoughtPlaceholder:
        'На основе результатов эксперимента, какая у Вас новая мысль?',
      evaluation: 'Оценка',
      newLearnings: 'Новые знания и понимания',
      newLearningsPlaceholder: 'Что Вы узнали в результате эксперимента?',
      meaningForOriginalBelief: 'Как это влияет на первоначальное убеждение?',
      meaningForOriginalBeliefPlaceholder:
        'Что это означает для Вашего первоначального убеждения или предсказания?',
      oldThoughtStrength:
        'Насколько сильно Вы верите в свою старую мысль или убеждение после эксперимента?',
      newThoughtStrength:
        'Насколько сильно Вы верите в свою новую мысль или убеждение?',
      generateGptSuggestions: 'Сгенерировать идеи с помощью ИИ',
      generateGptSuggestionsMore: 'Сгенерировать другой вариант',
      generateGptSuggestionsTip: ``,
      generating:
        'Генерация идей с помощью ИИ. Это может занять некоторое время...',
      generationError: 'Ошибка при генерации идей',
      patientReflections: 'Наблюдения пациента',
      patientReflectionsPlaceholder: 'Введите наблюдения пациента',
      therapistReflections: 'Наблюдения терапевта',
      therapistReflectionsPlaceholder: 'Введите наблюдения терапевта',
      followUp: 'Последующие эксперименты',
      followUpExperimentsIdeas: 'Идеи последующих экспериментов',
      followUpExperimentsIdeasPlaceholder:
        'Введите идеи последующих экспериментов',
      generatedWarning: `Предупреждение!
      
      Некоторый контент ниже был сгенерирован ИИ.
      
      Вы, как специалист в области психического здоровья, ответственны за просмотр и редактирование контента перед его использованием с Вашими клиентами.`,
      generatedVariant: 'Сгенерированный вариант',
      saveSuccess: 'Эксперимент успешно сохранен',
      saveError:
        'Мы не смогли сохранить этот поведенческий эксперимент. Пожалуйста, попробуйте еще раз. Если проблема повторится, напишите в support@copingcard.com и укажите код BEHAVIOR-EXPERIMENT-SAVE-1.',
      loadError:
        'Мы не смогли загрузить этот поведенческий эксперимент. Пожалуйста, вернитесь назад и попробуйте снова. Если проблема повторится, напишите в support@copingcard.com и укажите код BEHAVIOR-EXPERIMENT-LOAD-1.',
      purposeSelectText: 'Выберите цель эксперимента',
      designSelectText: 'Выберите структуру эксперимента',
      hypothesisTypeSelectText: 'Выберите количество гипотез',
      typeSelectText: 'Выберите тип эксперимента',
      activeSubtypeSelectText: 'Выберите подтип активного эксперимента',
      observationalSubtypeSelectText:
        'Выберите подтип наблюдательного эксперимента',
      jumpToOutcome: 'Перейти к результату',
      // E02 (ES-era) mobile — the per-step design wizard, observations and completion screens
      stepTitles: [
        'Настройка',
        'Гипотезы',
        'План',
        'Прогноз',
        'Проверка и активация',
      ],
      setupLocked:
        'Цель, структура, количество гипотез и тип фиксируются после запуска эксперимента.',
      saveAndExit: 'Сохранить и выйти',
      designSummary: 'Сводка дизайна',
      activate: 'Активировать эксперимент',
      activateHint:
        'После активации эксперимент можно проводить — записывайте, что произошло при каждом прохождении.',
      activateIncomplete:
        'Заполните шаги «Гипотезы», «План» и «Прогноз», чтобы активировать эксперимент.',
      alreadyActive: 'Этот эксперимент уже активен.',
      backToExperiment: 'К эксперименту',
      recordObservation: 'Записать наблюдение',
      editObservation: 'Редактировать наблюдение',
      runNumber: 'Прохождение №{{n}}',
      amendRun: 'Изменить прохождение №{{n}}',
      whatHappened: 'Что произошло?',
      whatHappenedPlaceholder: 'Опишите это прохождение',
      whichHypothesisHeld: 'Какая гипотеза подтвердилась?',
      hypothesisHeldOptions: ['A', 'B', 'Смешанно'],
      hypothesisHeldShort: ['Гипотеза A', 'Гипотеза B', 'Смешанно'],
      rating: 'Вера в исходную мысль сейчас',
      learnings: 'Выводы',
      learningsPlaceholder: 'Что Вы узнали?',
      saveObservation: 'Сохранить наблюдение',
      saveChanges: 'Сохранить изменения',
      addObservation: '+ Добавить наблюдение',
      completeExperiment: 'Завершить',
      reviewCompletion: 'Итоги эксперимента',
      markCompleted: 'Отметить завершённым',
      completeTitle: 'Завершение эксперимента',
      observationsTitle: 'Наблюдения ({{count}})',
      observationsEmpty:
        'Наблюдений пока нет. Добавляйте их после каждого прохождения эксперимента.',
      observationsLabel: 'Наблюдения',
      // переключатель порядка наблюдений в шапке списка на экране эксперимента (решение основателя
      // 2026-09-02, handoff §13): по умолчанию сначала старые, как они были записаны; выбор только
      // меняет порядок на экране и нигде не сохраняется
      observationsOrder: 'Порядок наблюдений',
      observationsOldestFirst: 'Сначала старые',
      observationsNewestFirst: 'Сначала новые',
      runsCount: '{{count}} прохождений',
      durationLabel: 'Длительность',
      durationDays: '{{count}} дней',
      statusDraft: 'Черновик',
      statusActive: 'Активен',
      statusCompleted: 'Завершён',
      activateFirst:
        'Сначала активируйте дизайн — после этого можно записывать наблюдения.',
      continueDesign: 'Продолжить дизайн',
      editDesign: 'Изменить дизайн',
      legacyOutcome: 'Результат (записан до появления наблюдений)',
      // the DERIVED first observation of a converted row (founder ruling 2026-09-02): read-only
      legacyObservationNote: 'Записано в предыдущей версии',
      untitled: 'Эксперимент без названия',
      newThoughtBelief: 'Вера в новую мысль',
      oldThoughtBelief: 'Вера в старую мысль',
      // E02 (ES-era) — command outcomes and the decider's rejection codes
      command: {
        rejected:
          'Не удалось сохранить поведенческий эксперимент — проверьте записи и попробуйте ещё раз.',
        conflictRetry:
          'Этот поведенческий эксперимент только что обновили на другом устройстве. Загружаем последнюю версию…',
      },
      errors: {
        BEHAVIOR_EXPERIMENT_NOT_FOUND:
          'Этого поведенческого эксперимента больше нет. Вернитесь к списку и попробуйте ещё раз.',
        BEHAVIOR_EXPERIMENT_ALREADY_EXISTS:
          'Этот поведенческий эксперимент уже начат. Обновите страницу и продолжите работу с ним.',
        USER_NOT_AUTHORIZED:
          'У Вас нет доступа к этому поведенческому эксперименту. Если это ошибка, напишите в support@copingcard.com и укажите код BEHAVIOR-EXPERIMENT-AUTH-1.',
        SETUP_INCOMPLETE:
          'Сначала выберите цель эксперимента, структуру, количество гипотез и тип.',
        SETUP_IMMUTABLE:
          'Цель, структура, количество гипотез и тип фиксируются при запуске эксперимента. Чтобы изменить их, начните новый эксперимент.',
        DESIGN_INCOMPLETE:
          'Перед активацией эксперимента заполните шаги «Гипотезы», «План» и «Прогноз».',
        NOT_ACTIVATED:
          'Сначала активируйте дизайн эксперимента — после этого можно записывать наблюдения и завершать его.',
        EXPERIMENT_COMPLETED:
          'Этот эксперимент завершён. Вы можете редактировать его наблюдения, но не добавлять новые.',
        OBSERVATION_NOT_FOUND:
          'Этого наблюдения больше нет в эксперименте. Вернитесь назад и попробуйте ещё раз.',
        LEGACY_OBSERVATION_READ_ONLY:
          'Это наблюдение записано в предыдущей версии, и здесь его нельзя изменить. Добавьте новое наблюдение.',
        CONTENT_REQUIRED:
          'Сначала опишите эксперимент, чтобы ИИ было от чего отталкиваться.',
        SUGGESTIONS_REQUEST_NOT_PENDING:
          'Эти идеи уже сгенерированы. Запросите новый вариант.',
      },
    },
    behaviorExperiments: {
      title: 'Поведенческие эксперименты',
      initialThoughtOrBelief: 'Начальная мысль или убеждение',
      edit: 'Редактировать эксперимент',
      create: 'Создать эксперимент',
      // E02 (ES-era) mobile list — status badges, default-hidden completed, Drafts / Resume
      showCompleted: 'Показать завершённые ({{count}})',
      hideCompleted: 'Скрыть завершённые',
      drafts: 'Черновики / Продолжить',
      empty: 'Экспериментов пока нет. Создайте первый.',
      unfinishedTitle: 'Незавершённые / Черновики',
      unfinishedSubtitle: 'Продолжите незаконченный дизайн',
      unfinishedEmpty: 'Незавершённых дизайнов нет.',
      resume: 'Продолжить',
      resumeAt: 'Продолжить с шага: {{step}}',
      observationsShort: '{{count}} набл.',
      noObservations: '—',
    },
    components: {
    },
    exposure: {
      types: [
        {
          name: 'Градуированная экспозиция',
          description:
            'Градуированная экспозиция — метод КПТ для преодоления страхов и тревоги: Вы идёте навстречу тому, чего избегали, по заранее намеченным шагам — начиная с трудного, но посильного. Перед каждым шагом запишите, чего Вы ожидаете и насколько вероятным это кажется; после — что произошло на самом деле и чему Вы научились. Цель — не сохранять спокойствие и не ждать, пока страх утихнет, а проверить свой прогноз, поэтому откажитесь от охранительного поведения и меняйте время и место тренировок. Прежний страх не стирается: по мере повторений рядом с ним растёт новый опыт. С сильными страхами, паникой или травмой лучше работать вместе с терапевтом.',
        },
        {
          name: 'Экспозиция с предотвращением реакции',
          description:
            'Экспозиция с предотвращением реакции (ЭПР) — основной метод КПТ при обсессивно-компульсивном расстройстве (ОКР); его также применяют при похожих проблемах, которые поддерживаются проверками, поиском заверений или ритуалами. Вы соприкасаетесь с мыслями, образами или ситуациями, запускающими обсессию, и одновременно удерживаетесь от компульсии или охранительного поведения, которые обычно за этим следуют. Так Вы на опыте убеждаетесь, что тревогу и позыв можно выдержать и они проходят без ритуала, а пугающий исход куда менее вероятен, чем внушает обсессия. Шаги планируют заранее, повторяют и фиксируют в записях: чего Вы ожидали и чему научились. Начинать лучше всего вместе с терапевтом.',
        },
      ],
      avoidances: [
        'Никогда не избегаю',
        'Избегаю иногда',
        'Избегаю в половине случаев',
        'Избегаю часто',
        'Избегаю всегда',
      ],
      title: 'Экспозиция',
      titlePlural: 'Экспозиции',
      sessionsPlural: 'Сеансы экспозиции',
      chooseExpositionType: 'Выберите тип экспозиции',
      type: 'Тип экспозиции',
      typeRequired: 'Тип экспозиции - обязателено поле',
      fear: 'Страх или тревога',
      fearPlaceholder: 'О чем Вы беспокоитесь или чего боитесь?',
      obsession: 'Обсессия',
      obsessionPlaceholder: 'ОБСЕССИЯ: Чего Вы боитесь или о чём беспокоитесь?',
      compulsion: 'Компульсия',
      compulsionPlaceholder:
        'КОМПУЛЬСИЯ: Что Вы обычно делаете, чтобы уменьшить тревогу?',
      compulsionTip:
        'Какого охранительного(избегающего) поведение поведения Вы обычно придерживаетесь и хотите уменьшить/прекратить?',
      situationsOrStimuliHierarchy: 'Иерархия ситуаций или стимулов',
      generateHierarchy: 'Создать иерархию с помощью ИИ',
      situationOrStimulus: `Ситуация или стимул`,
      situationOrStimulusTitle: 'Название ситуации или стимула',
      situationOrStimulusTitlePlaceholder: 'Какова ситуация или стимул?',
      situationOrStimulusDescription: 'Описание',
      situationOrStimulusDescriptionPlaceholder: 'Опишите ситуацию или стимул',
      imagePrompt: 'Подсказка для генерации изображения с помощью ИИ',
      imagePromptTip:
        'Подсказка для ИИ, которую Вы можете использовать для создания изображений для ситуации или стимула',
      imagePromptPlaceholder:
        'Введите подсказку для генерации изображения с помощью ИИ',
      imageDeleteWarning: 'Вы уверены, что хотите удалить это изображение?',
      addSituationOrStimuli: 'Добавить ситуацию или стимул',
      sud: 'Уровень напряжения и тревоги (SUD)',
      sudTip: 'Насколько неприятна ситуация или стимул? (0-100)',
      expectedOutcome: 'Чего Вы опасаетесь?',
      expectedOutcomePlaceholder: 'Опишите, что может пойти не так. Это поле можно пропустить.',
      expectedLikelihood: 'Насколько это вероятно?',
      outcomeOccurred: 'Это произошло?',
      outcomeYes: 'Да',
      outcomePartly: 'Частично',
      outcomeNo: 'Нет',
      likelihoodAfter: 'Насколько вероятным это кажется сейчас?',
      learned: 'Что Вы узнали?',
      learnedPlaceholder: 'Запишите, что Вы заметили или узнали во время экспозиции. Это поле можно пропустить.',
      likelihoodNotSet: 'Не указано — передвиньте ползунок, чтобы ответить',
      likelihoodClear: 'Очистить ответ',
      expectedColumn: 'Ожидание (вероятность до → после)',
      happenedColumn: 'Произошло',
      learnedColumn: 'Выводы',
      noAnswersRecorded: 'Нет записанных ответов',
      // E43 — health data: the heart rate during an exposition (generated — gen-ru-gemini.mjs)
      heartRate: {
        column: 'Пульс',
        values: 'Пульс {{min}}–{{max}} уд/мин, средний {{mean}} · {{readings}}',
        readings_one: '{{count}} измерение',
        readings_few: '{{count}} измерения',
        readings_many: '{{count}} измерений',
        readings_other: '{{count}} измерения',
        none: 'Во время этой экспозиции пульс не записывался.',
        notShared: 'не передаётся',
      },
      saveSuccess: 'Экспозиция успешно сохранена',
      saveError:
        'Мы не смогли сохранить эту экспозицию. Пожалуйста, попробуйте еще раз. Если проблема повторится, напишите в support@copingcard.com и укажите код EXPOSURE-SAVE-1.',
      loadError:
        'Мы не смогли загрузить эту экспозицию. Пожалуйста, вернитесь назад и попробуйте снова. Если проблема повторится, напишите в support@copingcard.com и укажите код EXPOSURE-LOAD-1.',
      deleteError:
        'Мы не смогли удалить эту ситуацию или стимул. Пожалуйста, попробуйте еще раз. Если проблема повторится, напишите в support@copingcard.com и укажите код EXPOSURE-DELETE-1.',
      situationOrStimulusSaveSuccess: 'Ситуация или стимул успешно сохранены',
      noSituationsYet: 'Ситуаций или стимулов пока нет',
      saveBeforeSituation:
        'Сначала сохраните эту экспозицию, а затем добавьте ситуацию или стимул.',
      generatingInProgress: 'Идёт генерация — это займёт немного времени.',
      hierarchyAlreadyBuilt:
        'У этой экспозиции уже есть иерархия. Удалите шаги, чтобы создать новую.',
      rank: 'Ранг',
      editTitleAndDescription: 'Редактировать название и описание',
      doYouAvoid: 'Вы избегаете эту ситуацию или стимул?',
      worstThingThatCouldHappen: 'Худшее, что может произойти',
      avoiding: 'Избегание',
      situationOrStimuliImages: 'Изображения ситуации или стимула',
      generateImageUsingAI: 'Сгенерировать изображение с помощью ИИ',
      generateImageUsingAIMobile: 'Сгенерировать изображение',
      generatingImage: 'Создание изображения...',
      deleteAvailable120Minutes:
        'Удаление доступно для терапевтов только в течение 2 часов после создания, чтобы предотвратить удаление контента, созданного клиентом.',
      startExposure: 'Начать новый сеанс экспозиции',
      newExposure: 'Новый сеанс экспозиции',
      anticipated: 'Ожидаемые',
      reactionNotes: 'Заметки',
      addReaction: 'Добавить реакцию',
      exposureGraph: 'График сеансов экспозиции',
      expositionDuration: 'Длительность экспозиции',
      highestSud: 'Максимальный SUD',
      endSud: 'Конечный SUD',
      duration: 'Длительность',
      recordSudPoint: 'Записать текущий SUD',
      imageGenerationError: 'Ошибка при генерации изображения',
      contentFilter:
        'Не удалось сгенерировать это изображение. Оно заблокировано фильтрами безопасности контента. Пожалуйста, попробуйте ещё раз с более нейтральным описанием.',

      safetyBehaviorsToAvoid:
        'Охранительные поведения (компульсии), которые нужно не испльзовать',

      edit: 'Редактировать экспозицию',

      create: 'Создать экспозицию',
      upsertExposureLoading: 'Сохранение экспозиции...',
      stimuludDeleteWarning:
        'Вы уверены, что хотите удалить ситуацию или стимул? Вся связанная с ним информация будет удалена.',
      editDetails: 'Редактировать детали',
      editReactionTime: 'Изменить время реакции',
      // «Прошло» — длительность с начала экспозиции, а не время суток
      elapsed: 'Прошло',
      editElapsedTime: 'Изменить, сколько времени прошло',
      elapsedSinceStart: 'Сколько времени прошло с начала экспозиции',
      minutes: 'Минуты',
      seconds: 'Секунды',
      noExposuresYet: 'Пока нет записанных сеансов',
      newestFirst: 'Сначала новые',
      oldestFirst: 'Сначала старые',
      // E20 WP4 — раннер экспозиции в E-эре: запуск, каждая реакция и завершение сохраняются как
      // отдельные факты в момент, когда происходят.
      //
      // СРЕЗ ИСПРАВЛЕНИЯ переписал две строки (решение основателя `amend-a-recorded-reaction`,
      // 2026-09-04). Раньше здесь было сказано, что записанную реакцию изменить нельзя — для WP4
      // это было правдой, теперь нет: реакцию можно ИСПРАВИТЬ, и исправление записывается отдельным
      // фактом рядом с оригиналом, а не вместо него.
      es: {
        runLiveNotice:
          'Эта экспозиция записывается в реальном времени — каждая реакция сохраняется сразу же. Сначала выберите уровень, затем нажмите «Добавить реакцию»; если реакция получилась неверной, её можно исправить — сохранятся и оригинал, и исправление.',
        runRecordedNotice:
          'Эта экспозиция записана. Нажмите «Продолжить сеанс экспозиции», чтобы добавить ещё реакции и завершить её заново с новыми заметками, или исправьте неверную реакцию — оригинал останется в записи.',
        finishRun: 'Завершить сеанс экспозиции',
        resumeRun: 'Продолжить сеанс экспозиции',
        viewRun: 'Смотреть сеанс экспозиции',
        runRecorded: 'Сеанс экспозиции записан',
        saveRungBeforeRun:
          'Сначала сохраните ситуацию или стимул — экспозиция записывается к ним по ходу дела.',
        // ИСПРАВЛЕНИЕ одной записанной реакции (решение основателя 2026-09-04). Именно
        // «исправлено», а не «изменено»: оригинальная реакция остаётся фактом, а исправление
        // замещает её только при показе.
        amendPoint: 'Исправить эту реакцию',
        amendTitle: 'Исправить записанную реакцию',
        amendSaved: 'Реакция исправлена',
        amendedTag: 'исправлено',
        amendedOriginal: 'Изначально {{sud}} в {{time}}',
      },
    },
    downwardArrows: {
      downwardArrows: 'Падающая стрела',
      initialThought: 'Начальная мысль',
      totalCount: 'Всего: {{count}}',
      edit: 'Редактировать падающую стрелу',
      create: 'Создать падающую стрелу',
      loadError:
        'Не удалось загрузить падающие стрелы. Обновите экран или перезапустите приложение и попробуйте снова.',
    },
    downwardArrow: {
      spec: {
        thoughts: [
          `На вечеринке мне казалось, что все меня осуждают, и мне там не место.`,
          `Другие думают, что я глупый или скучный.`,
          `Я не интересен и не симпатичен.`,
          `Я неудачник, и я никому никогда не понравлюсь.`,
        ],
      },
      title: 'Падающая стрела',

      saveSuccess: 'Падающая стрела успешно сохранена',
      loadError:
        'Не удалось загрузить эту падающую стрелу. Вернитесь назад и попробуйте снова.',
      saveError:
        'Не удалось сохранить падающую стрелу. Попробуйте снова. Если ошибка повторится, напишите на support@copingcard.com.',
      thought: 'Мысль или убеждение',
      question:
        'Если бы это было правдой, меня бы это беспокоило, потому что это означало бы...',
      description: `Техника «Падающая стрела» используется для перехода от поверхностных уровней мыслей (негативных автоматических мыслей) к более глубоким уровням (промежуточным или глубинным убеждениям), лежащим в основе дистресса или проблемного поведения человека.

Она включает в себя постановку ряда вопросов, направленных на выявление основных предположений, убеждений или страхов, которые управляют негативными мыслями человека.

Техника получила свое название от визуальной метафоры «копать глубже» в убеждения человека, начиная с поверхностной мысли и используя серию вопросов, чтобы добраться до первопричины негативной мысли.

Сократический диалог — ключевой компонент техники «Падающая стрела». В нем терапевт задает вопросы в непредвзятой, любознательной и исследовательской манере, побуждая пациента более внимательно исследовать свои мысли и убеждения.

Терапевт просит пациента определить свои негативные автоматические мысли, например: «Я неудачник». Затем терапевт задает ряд вопросов, чтобы копнуть глубже, например: «Что для Вас значит быть неудачником?» и «Почему это важно для Вас?» Продолжая задавать такие вопросы, терапевт может помочь пациенту раскрыть основные убеждения и предположения, которые подпитывают его негативные мысли.
      `,
    },
    worryTrees: {
      worryAbout: 'Беспокойство',
      isReal: 'Реально?',
      notSolvable: 'Не решаемо',
      options: 'Варианты решения',
      immediateAction: 'Немедленное действие',
      plan: 'План действий',
      refocusActivity: 'Активность переключения',

      definition:
        'Инструмент «Дерево принятия решений» в когнитивно-поведенческой терапии представляет собой систематический подход к осмыслению и лечению генерализованного тревожного расстройства (ГТР) путем разбиения сложных, вызывающих тревогу ситуаций на более мелкие, более управляемые части. Этот инструмент помогает клиентам с ГТР избежать «аналитического паралича» и принять меры, различая тип беспокойства, с которым они сталкиваются, и определяя соответствующие ответы. Используя этот инструмент, клиентам предлагается рассматривать свои проблемы как проблемы, которые можно преодолеть с помощью навыков решения проблем, а не зацикливаться на беспокойстве и тревожности. Инструмент «Дерево принятия решений» направлен на то, чтобы сообщить клиентам, что есть лучшая альтернатива беспокойству и что они могут улучшить свои навыки решения проблем, чтобы эффективно справляться со своей тревогой.',
      deleteSuccess: 'Дерево принятия решений успешно удалено',
      view: 'Просмотреть дерево',
      create: 'Создать дерево принятия решений',
    },
    worryTree: {
      spec: {
        worryAbout: 'Я могу провалить мой новый проект на работе',
        options: `1. Я могу попросить разъяснений по любым аспектам проекта, в которых я не уверен.
2. Я могу создать подробный план проекта с вехами для контроля прогресса.
3. Я могу искать поддержку у коллег или наставника.
4. Я могу изучить похожие прошлые проекты, чтобы понять потенциальные проблемы.
5. Я могу выделить дополнительное время на исследования и подготовку к проекту.`,
        immediateAction: `Я начну с того, что напишу все задачи, которые нужно выполнить,
и расставлю их по приоритетам.
Затем я запланирую встречу с моим руководителем,
чтобы обсудить объем проекта и ожидания.`,
      },
      worryTree: 'Дерево принятия решений',
      worryTrees: 'Дерево принятия решений',
      worryTreesTitle: 'Дерево принятия решений',
      title: 'Дерево принятия решений',
      worryAbout: 'О чем я беспокоюсь?',
      isReal: 'Это реальная проблема?',
      isDoable: 'Могу я что-нибудь сделать, чтобы решить эту проблему?',
      isDoableNow: 'Могу я что-нибудь сделать прямо сейчас?',
      listOptions: 'Перечислите варианты решения проблемы.',
      developPlan:
        'Спланируйте, что Вы можете сделать и когда Вы это сделаете.',
      decision: 'Решение',
      selectedActivity: 'Выбранная активность',
      refocusTitle:
        'Отпустите тревожную мысль. Измените фокус Вашего внимания.',
      doneTitle: 'Отпустите тревожную мысль. Сделайте выбранное действие.',
      immediateAction: 'Назовите то, что Вы собираетесь сделать прямо сейчас.',
      saveSuccess: 'Дерево принятия решений успешно сохранено',
      saveError:
        'Не удалось сохранить дерево принятия решений. Попробуйте ещё раз. Если проблема сохраняется, обратитесь на support@copingcard.com.',
      loadError:
        'Не удалось загрузить дерево принятия решений. Вернитесь назад и попробуйте ещё раз.',
      savedForReference:
        'Ваше дерево принятия решений было сохранено для дальнейшего использования.',
      refocusIdeas: [
        {
          title: 'Практиковать глубокое дыхание',
          info: 'Делайте медленные, глубокие вдохи и выдохи, чтобы снизить частоту сердечных сокращений и успокоить разум.',
        },
        {
          title: 'Заняться физической активностью',
          info: 'Занимайтесь спортом или прогуляйтесь, чтобы помочь высвободить эндорфины и уменьшить стресс.',
        },
        {
          title: 'Практиковать осознанность',
          info: 'Сосредоточьтесь на настоящем моменте, обращая внимание на свои мысли, чувства и ощущения без осуждения.',
          mobileExtraInfo:
            'Вы можете перейти в раздел «Медитации», следуя по ссылке ниже.',
          link: 'screens.meditations',
        },
        {
          title: 'Заняться творческой деятельностью',
          info: 'Займитесь делом, требующим полного внимания, например рисованием или игрой на музыкальном инструменте.',
        },
        {
          title: 'Послушать музыку',
          info: 'Послушайте успокаивающую музыку или любимые песни, чтобы отвлечься.',
        },
        {
          title: 'Практиковать визуализацию',
          info: 'Визуализируйте мирную сцену или ситуацию, которая помогает Вам чувствовать себя спокойно и расслабленно.',
        },
        {
          title: 'Сделать запись в дневнике',
          info: 'Запишите свои мысли и чувства, чтобы упорядочить их и обрести ясность.',
        },
        {
          title: 'Решите головоломку',
          info: 'Решите сложную головоломку или игру, чтобы переключить внимание.',
        },
        {
          title: 'Практиковать благодарность',
          info: 'Сосредоточьтесь на вещах в своей жизни, за которые Вы благодарны, и выразите благодарность за них.',
        },
        {
          title: 'Обратиться за профессиональной помощью',
          info: 'Если Ваше беспокойство непрекращается и мешает Вашей повседневной жизни, подумайте о том, чтобы обратиться за помощью к специалисту в области психического здоровья.',
          mobileExtraInfo:
            'Вы можете перейти в раздел «Поиск терапевтов», следуя по ссылке ниже.',
          link: 'screens.therapists',
          root: 'screens.tests',
        },
        {
          title: 'Практикуйте прогрессирующую мышечную релаксацию',
          info: '',
          mobileExtraInfo:
            'Вы можете найти видео и инструкции о том, как сделать это, следуя по ссылке ниже.',
          link: 'screens.muscleRelaxation',
          root: 'screens.crisis',
        },
      ],
    },
  },
  learn: {
    articles: {
      minRead: '{{minutes}} мин чтения',
      researchTitle: 'Библиотека исследований',
      researchHint: 'Исследования по КПТ на нашем сайте.',
    },
    article: {
      watchVideo: 'Смотреть видео',
      openTool: 'Открыть «{{tool}}»',
      readFull: 'Читать статью полностью',
      safetyLine: 'Если этот материал вызывает тяжёлые переживания, Вы не должны справляться с этим в одиночку. Поговорите с Вашим терапевтом или откройте вкладку «Кризис».',
      openCrisis: 'Открыть «Кризис»',
    },
    videos: {
      readArticle: 'Читать статью',
    },
    retired: {
      movedBody: 'Эта статья теперь находится на нашем сайте вместе с другими исследованиями.',
      movedButton: 'Читать на сайте',
      goneBody: 'Эта статья больше недоступна.',
      back: 'Назад к статьям',
    },
    tools: {
      AbcModels: 'ABC-модель',
      CopingCards: 'Копинг-карточки',
      ThoughtsTesting: 'Тестирование мыслей',
      DownwardArrows: 'Падающая стрела',
      WorryTrees: 'Дерево принятия решений',
      BehaviorExperiments: 'Поведенческие эксперименты',
      Exposures: 'Экспозиции',
      ViciousCycles: 'Поддерживающие циклы',
      Meditations: 'Медитации',
      ActivateHome: 'Поведенческая активация',
      ValuesProfile: 'Ценности',
      MyCheckIns: 'Моё настроение',
      SafetyPlan: 'Мой план безопасности',
      Tests: 'Опросники',
      FaHome: 'Функциональный анализ',
      MiChanges: 'Мотивационное интервьюирование',
      ModesHome: 'Режимы схем',
      SleepMorning: 'Дневник сна',
    },
  },
  audios: [
    {
      url: 'meditation-1-1-ru-v2.m4a',
      title: 'Дышащее тело',
      duration: 374,
    },
    {
      url: 'meditation-4-ru-v2.m4a',
      title: 'Безопасное место',
      duration: 345,
    },
    {
      url: 'meditation-2-ru-v2.m4a',
      title: 'Песочные часы',
      duration: 478,
    },
    {
      url: 'meditation-3-ru-v2.m4a',
      title: 'Звуки и мысли',
      duration: 403,
    },
    {
      url: 'meditation-5-ru-v2.m4a',
      title: 'Триангуляция',
      duration: 429,
    },
    {
      url: 'meditation-6-ru-v2.m4a',
      title: 'Тренировка "наблюдающего Я"',
      duration: 567,
    },
  ],
  learnVideoDiagnostics: {
    playerLoadFailure: 'Ошибка загрузки видео Learn на Android',
  },
  cognitiveDistorions: {
    10: 'Дихотомическое мышление (черно-белое, поляризованное мышление)',
    20: 'Катастрофизация',
    30: 'Сверхгенерализация (сверхобобщение)',
    40: 'Преуменьшение позитивного (обесценивание)/преувеличение негатива',
    50: 'Долженствование (сверхвысокие стандарты, «я должен»)',
    60: 'Навешивание ярлыков и стереотипов',
    70: 'Персонализация (приняте на свой счет, атрибутивность)',
    80: 'Субъективная аргументация (эмоциональное обоснование)',
    90: 'Произвольное умозаключение (нелогичное мышление)',
    100: 'Селективное абстрагирование (избирательное внимание)',
    110: 'Туннельное зрение',
    120: 'Чтение мыслей, ясновидение (предвидение)',
  },
  // E28 — см. комментарий в translationEn.ts.
  sessionEnding: {
    // Основатель, 2026-09-07: значение по умолчанию — не выбор человека, поэтому без «Вы выбрали»;
    // называем само умолчание и настройку, которая его меняет, — ровно так, как она подписана на
    // экране («Не выходить из приложения» в разделе «Настройки конфиденциальности»).
    // Текст основателя (2026-09-07), дословно; единственная правка — «Вы сделали» с заглавной,
    // как и остальные обращения в этом тексте.
    title: 'Скоро Вы автоматически выйдете из приложения',
    body: 'Опция «Не выходить из приложения» не включена, поэтому, как только Вы закончите текущую задачу, приложение попросит Вас войти снова. Всё, что Вы сделали, уже сохранено.\nЕсли Вы хотите дольше оставаться в приложении без необходимости повторного входа, включите опцию «Не выходить из приложения» в настройках конфиденциальности.',
    delay: 'Не сейчас',
    openPrivacySettings: 'Открыть настройки конфиденциальности',
    dismiss: 'Скрыть',
  },
  // E27 — см. комментарий в translationEn.ts.
  appBuildInfo: {
    title: 'Версия приложения',
    version: 'Версия {{version}}',
    build: 'Сборка {{build}}',
    otaRevision: 'Обновление {{revision}}',
    otaEmbedded: 'Обновление: то, что входит в эту сборку',
  },
  // E32 · «Что нового» — см. комментарий в translationEn.ts. RU утверждён основателем 2026-09-21
  // («Approve as drafted»); сами тексты объявлений публикует маркетинг и здесь их нет.
  whatsNew: {
    title: 'Что нового',
    readArticle: 'Подробнее',
    dismiss: 'Скрыть',
    releases: 'Версия {{versions}}',
    historyTitle: 'Что нового',
    openHistory: 'Что нового в CopingCard',
    openArticle: 'Читать статью',
    empty: 'Пока пусто — новые функции и статьи появятся здесь по мере выхода.',
  },
  devSessionClock: {
    title: 'Часы сессии (только dev-сборка)',
    age: 'Состарить сессию на 25 ч',
    away: '31 мин в фоне, затем вернуться',
    shortAway: '2 мин в фоне, затем вернуться (звонок)',
    idle: '16 мин без касаний, затем проверить',
  },
  oldVersionModal: {
    appOutdatedTitle: 'Приложение устарело',
    yourVersionIsOutdated:
      'Ваша версия приложения устарела и её нужно обновить',
    installWarning:
      '⚠️ Если кнопка ниже не перенаправит Вас в App/Play Store автоматически, обновите приложение вручную.',
    getUpdate: 'Обновить',
  },
  checkIn: {
    errors: {
      CHECKIN_RATING_RANGE:
        'Каждая оценка должна быть от 1 до 5. Выберите смайлик в ряду и попробуйте ещё раз.',
      CHECKIN_DATE_RANGE:
        'Записать настроение можно за сегодня или за любой из последних 7 дней. Выберите один из этих дней.',
      CHECKIN_EMOTION_UNKNOWN:
        'Одно из выбранных чувств не найдено в списке. Выберите чувства из списка ещё раз.',
      CHECKIN_UNKNOWN:
        'Эта запись настроения не найдена — возможно, она уже удалена. Обновите список.',
      CHECKIN_NOT_YOURS:
        'Вы можете удалять только свои записи настроения. Запись, сделанную терапевтом на сессии, может удалить только его практика.',
      HOMEWORK_NOT_YOUR_CLIENT:
        'Этот клиент не прикреплён к Вам в практике: он не числится Вашим клиентом здесь или отключил обмен данными с Вами. Проверьте список клиентов или попросите клиента снова включить обмен данными в приложении.',
      DIARYCARD_EMPTY:
        'В дневнике самонаблюдения должна быть хотя бы одна строка, чувство или навык. Добавьте пункт и сохраните снова.',
      DIARYCARD_DUPLICATE_TARGET:
        'У двух строк одинаковый идентификатор. Удалите одну из них и сохраните снова.',
      DIARYCARD_PRACTICE_CARD_EXISTS:
        'В Вашей практике уже есть дневник самонаблюдения для этого клиента. Откройте его и отредактируйте вместо создания второго.',
      DIARYCARD_OWN_CARD_EXISTS:
        'У Вас уже есть свой дневник. Откройте его через «Изменить мой дневник» вместо создания второго.',
      DIARYCARD_UNKNOWN_CARD:
        'Этот дневник не найден для данного клиента. Обновите страницу и откройте его снова.',
      DIARYCARD_TEMPLATE_EMPTY:
        'В шаблоне должна быть хотя бы одна строка, чувство или навык. Добавьте пункт и опубликуйте снова.',
      DIARYCARD_NO_ACTIVE_CARD:
        'У Вас пока нет дневника самонаблюдения. Сначала настройте его, а затем заполняйте.',
      DIARYCARD_RATING_RANGE: 'Одна из оценок выходит за пределы шкалы. Проверьте значения в форме и сохраните снова.',
      DIARYCARD_UNKNOWN_TARGET:
        'Одной из строк больше нет ни в одном Вашем дневнике. Откройте дневник самонаблюдения заново, чтобы увидеть актуальные строки.',
      DIARYCARD_DATE_RANGE:
        'Дневник самонаблюдения можно заполнить за сегодня или за любой из последних 7 дней. Выберите один из этих дней.',
      DIARYCARD_NO_PRACTICE_CARD:
        'Ваша практика ещё не настроила дневник самонаблюдения для этого клиента. Сначала создайте его, а затем заполняйте.',
    },
    title: 'Как Вы сегодня?',
    hint:
      'Нажмите на подходящий смайлик. Одно касание — и настроение записано.',
    mood: {
      1: 'Очень плохое',
      2: 'Плохое',
      3: 'Нормальное',
      4: 'Хорошее',
      5: 'Очень хорошее',
    },
    widget: {
      name: 'Настроение',
      description:
        'Записывайте настроение в одно касание. На главном экране не отображается ничего лишнего.',
      title: 'Как Вы?',
      tapFace: 'Нажмите на смайлик',
      saved: 'Сохранено · нажмите на смайлик, чтобы добавить ещё',
      signedOut: 'Войдите, чтобы записать настроение',
      intentTitle: 'Записать настроение',
      intentMood: 'Настроение',
    },
    scale: {
      1: 'Очень низкий',
      2: 'Низкий',
      3: 'Средний',
      4: 'Высокий',
      5: 'Очень высокий',
    },
    save: 'Сохранить запись',
    saving: 'Сохранение…',
    saved: 'Сохранено. Спасибо, что записали настроение.',
    savedOffline:
      'Сохранено на этом телефоне. Запись отправится, как только Вы подключитесь к интернету.',
    checkedInAt: 'Настроение записано в {{time}}',
    addAnother: 'Добавить ещё',
    more: 'Добавить подробности (необязательно)',
    less: 'Скрыть подробности',
    energy: 'Энергия',
    sleepQuality: 'Как Вы спали',
    sleepHours: 'Часов сна',
    sleepHoursPlaceholder: 'Например, 7,5',
    socialConnection: 'Связь с другими людьми',
    emotions: 'Чувства',
    emotionsHint:
      'Выберите подходящие чувства и укажите их силу.',
    emotionsToggle: 'Выбрать чувства',
    strength: {
      mild: 'Слабая',
      moderate: 'Умеренная',
      strong: 'Сильная',
    },
    drivers: 'Что повлияло на Ваш день?',
    driver: {
      work: 'Работа',
      family: 'Семья',
      relationships: 'Отношения',
      health: 'Здоровье',
      sleep: 'Сон',
      money: 'Деньги',
      study: 'Учёба',
      weather: 'Погода',
      other: 'Другое',
    },
    note: 'Заметка',
    notePlaceholder: 'Всё, что Вы хотите запомнить об этом дне',
    day: {
      today: 'Сегодня',
      yesterday: 'Вчера',
      pick: 'За какой день эта запись?',
    },
    myCheckIns: 'Моё настроение',
    history: {
      title: 'Моё настроение',
      range7: '7 дней',
      range30: '30 дней',
      streak_one: '{{count}} день подряд',
      streak_few: '{{count}} дня подряд',
      streak_many: '{{count}} дней подряд',
      streak_other: '{{count}} дня подряд',
      noStreak: 'Запишите настроение сегодня, чтобы начать серию',
      empty:
        'Записей настроения пока нет. Первая займёт несколько секунд.',
      emptyAction: 'Записать настроение',
      enteredInSession: 'Записано на сессии',
      enteredInSessionHint:
        'Эту запись сделал Ваш терапевт на сессии. Удалить её может только его практика.',
      noteLabel: 'Заметка',
      moodLine: 'Настроение: {{mood}}',
      chartTitle: 'Динамика настроения',
      pointLabel: '{{day}}: настроение {{mood}}',
      loadError:
        'Не удалось загрузить записи настроения. Потяните вниз, чтобы обновить.',
    },
    delete: {
      action: 'Удалить',
      title: 'Удалить эту запись настроения?',
      body:
        'Она исчезнет из Вашей истории и перестанет отображаться у Вашего терапевта.',
      confirm: 'Удалить',
      cancel: 'Оставить',
      failed:
        'Не удалось удалить запись. Попробуйте ещё раз чуть позже.',
    },
    reminder: {
      title: 'Ежедневное напоминание',
      body: 'Мягкое напоминание записать настроение.',
      set: 'Настроить напоминание',
      change: 'Изменить напоминание',
      none: 'Напоминание не настроено',
      diaryTitle: 'Напоминание о дневнике самонаблюдения',
      diaryBody: 'Мягкое напоминание заполнить дневник самонаблюдения.',
      notificationTitle: 'Как Вы сегодня?',
      notificationBody: 'Запись настроения займёт минуту.',
      diaryNotificationTitle: 'Минута для себя: как прошёл день?',
      diaryNotificationBody: 'Заполните дневник самонаблюдения.',
    },
    hub: {
      tab: 'Настроение',
      title: 'Настроение',
      range14: '14 дней',
      range30: '30 дней',
      range90: '90 дней',
      daysChecked_one:
        'Настроение записано за {{count}} день из последних {{days}}',
      daysChecked_few:
        'Настроение записано за {{count}} дня из последних {{days}}',
      daysChecked_many:
        'Настроение записано за {{count}} дней из последних {{days}}',
      daysChecked_other:
        'Настроение записано за {{count}} дня из последних {{days}}',
      empty: 'За этот период записей настроения пока нет.',
      mood: 'Настроение',
      energy: 'Энергия',
      sleepQuality: 'Качество сна',
      sleepHours: 'Сон (часы)',
      socialConnection: 'Связь с людьми',
      feelings: 'Чувства',
      drivers: 'Факторы',
      note: 'Заметка',
      enteredInSession: 'Записано на сессии',
      loadError:
        'Не удалось загрузить записи настроения. Обновите страницу и попробуйте ещё раз.',
      askForDaily:
        'Чтобы попросить ежедневно записывать настроение, назначьте это как домашнее задание (Назначить задание → Ежедневная запись настроения).',
    },
    session: {
      record: 'Записать настроение (на сессии)',
      recordTitle: 'Записать настроение: {{name}}',
      recordHint:
        'Запись сделана на сессии: она входит в записи Вашей практики, видна практике и клиенту и не считается самостоятельной записью клиента.',
      day: 'День',
      save: 'Записать настроение',
      saved: 'Настроение записано.',
      remove: 'Удалить',
      removeTitle: 'Удалить эту запись настроения?',
      removeBody:
        'Она исчезнет из истории клиента и перестанет отображаться в Вашей практике.',
      removeConfirm: 'Удалить',
      removeCancel: 'Оставить',
      removeFailed:
        'Не удалось удалить запись. Попробуйте ещё раз чуть позже.',
      recapTab: 'Сводка настроения',
      recapTitle: 'Записи настроения с прошлой сессии',
      recapSince: 'С {{date}}',
      recapFirstSession: 'Это первая сессия клиента с Вами, поэтому здесь показаны последние 14 дней.',
      recapEmpty: 'За этот период записей настроения нет.',
      recapCount_one: '{{count}} запись настроения',
      recapCount_few: '{{count}} записи настроения',
      recapCount_many: '{{count}} записей настроения',
      recapCount_other: '{{count}} записи настроения',
      recapInSession: '{{count}} записано на сессии',
      recapMoodAverage: 'Среднее настроение: {{value}}',
      recapLowest:
        'Худший день: {{day}} · настроение {{mood}}',
      recapSleep: 'Сон в среднем: {{hours}} ч',
      recapDrivers: 'Самые частые факторы',
      recapOpenEntry: 'Посмотреть запись',
      loadError:
        'Не удалось загрузить сводку настроения. Обновите страницу и попробуйте ещё раз.',
    },
  },
  diaryCard: {
    title: 'Дневник самонаблюдения',
    loading: 'Загружаем Ваш дневник самонаблюдения…',
    loadError:
      'Не удалось загрузить Ваш дневник самонаблюдения. Потяните вниз, чтобы попробовать ещё раз.',
    setUp: 'Настроить мой дневник самонаблюдения',
    editMine: 'Изменить мой дневник',
    myWeek: 'Моя неделя',
    empty: {
      title: 'Дневника самонаблюдения пока нет',
      body:
        'Дневник самонаблюдения — это минутная ежедневная запись побуждений, действий, чувств и навыков. Его может настроить Ваш терапевт, либо настройте свой собственный.',
    },
    toolkit: {
      body: 'Одна минута: как прошёл день?',
      done: 'Заполнен за сегодня.',
      open: 'Открыть мой дневник самонаблюдения',
      fill: 'Заполнить за сегодня',
      setUpBody:
        'Отслеживайте побуждения, действия, чувства и навыки день за днём. Начните с шаблона или создайте свой собственный.',
    },
    fill: {
      pickDay: 'За какой день эта запись?',
      today: 'Сегодня',
      yesterday: 'Вчера',
      replaceHint:
        'Вы уже заполнили этот день. Повторное сохранение заменит запись.',
      oneFormHint_one: 'Одна форма для {{count}} Вашего дневника.',
      oneFormHint_few:
        'Одна форма для {{count}} Ваших дневников. Строка, общая для нескольких дневников, заполняется один раз.',
      oneFormHint_many:
        'Одна форма для {{count}} Ваших дневников. Строка, общая для нескольких дневников, заполняется один раз.',
      oneFormHint_other:
        'Одна форма для {{count}} Ваших дневников. Строка, общая для нескольких дневников, заполняется один раз.',
      sharedRows: 'Во всех Ваших дневниках',
      fromPractice: 'Дневник от: {{name}}',
      fromYourTherapist: 'Дневник от Вашего терапевта',
      ownCard: 'Мой собственный дневник',
      emotions: 'Чувства сегодня',
      emotionsHint:
        'Оцените максимальную силу каждого чувства сегодня от 0 до 5.',
      skills: 'Навыки',
      skillsUsed: 'Использование навыков сегодня (0–7)',
      skillsUsedHint:
        '0 — не думали о них и не применяли, 7 — применяли, и они помогли.',
      skillsPracticed: 'Какие навыки Вы практиковали?',
      note: 'Заметка',
      notePlaceholder: 'Всё, что Вы хотите запомнить о сегодняшнем дне',
      sharedWith: 'Доступно: {{names}}',
      sharedWithOwn:
        'Доступно: {{names}}, а также сохраняется в Вашем дневнике',
      sharedUnnamed: 'терапевт',
      sharedJoin: '{{a}} и {{b}}',
      yes: 'Да',
      no: 'Нет',
      save: 'Сохранить',
      saving: 'Сохранение…',
      saved_one: 'Сохранено в {{count}} Вашем дневнике.',
      saved_few: 'Сохранено в {{count}} Ваших дневниках.',
      saved_many: 'Сохранено в {{count}} Ваших дневниках.',
      saved_other: 'Сохранено в {{count}} Ваших дневниках.',
      failed:
        'Не удалось сохранить дневник самонаблюдения. Проверьте подключение и попробуйте ещё раз.',
    },
    own: {
      title: 'Настроить мой дневник самонаблюдения',
      editTitle: 'Изменить мой дневник',
      intro:
        'Начните с шаблона, а затем настройте его под себя. Терапевт, с которым Вы делитесь данными, может видеть Ваш собственный дневник, но не может его изменять.',
      blank: 'Начать с чистого дневника',
      rowsHint:
        'Строки — это то, что Вы отслеживаете каждый день. Их можно изменить в любой момент: за прошлые дни сохранятся те строки, с которыми они заполнялись.',
      rows: 'Строки',
      rowName: 'Название строки',
      rowNamePlaceholder: 'Что Вы хотите отслеживать?',
      kind: {
        urge: 'Побуждение',
        scale: 'Шкала',
        action: 'Да / нет',
        count: 'Количество',
        text: 'Короткий текст',
      },
      scaleTo: 'От 0 до {{max}}',
      removeRow: 'Удалить эту строку',
      addRow: 'Добавить строку',
      skillsHint:
        'Выберите навыки, которые Вы осваиваете. Их можно будет изменить позже.',
      needRows:
        'Добавьте хотя бы одну строку, чувство или навык, чтобы сохранить дневник.',
      needNames: 'Укажите название для каждой строки, чтобы сохранить дневник.',
      save: 'Сохранить мой дневник',
      failed:
        'Не удалось сохранить Ваш дневник. Попробуйте ещё раз чуть позже.',
    },
    week: {
      previous: 'Раньше',
      next: 'Позже',
      range: 'С {{from}} по {{to}}',
      empty:
        'У Вас пока нет дневника самонаблюдения. Настройте его, и здесь появится Ваша неделя.',
      day: 'День',
      skillsUsed: 'Использование навыков',
      inSession: 'Заполнено на сессии',
    },
    hub: {
      tab: 'Дневник самонаблюдения',
      title: 'Дневник самонаблюдения',
      previousWeek: 'Предыдущая неделя',
      nextWeek: 'Следующая неделя',
      setUpCard: 'Настроить дневник',
      editCard: 'Изменить дневник',
      setUpTitle: 'Настроить дневник самонаблюдения для: {{name}}',
      editTitle: 'Изменить дневник самонаблюдения: {{name}}',
      setUpHint:
        'Это дневник Вашей практики для клиента: он хранится в истории Вашей практики. Повторное сохранение создаёт новую версию этого дневника; дневник другой практики для этого клиента остаётся без изменений. Клиент видит одну общую форму для всех своих дневников.',
      startFrom: 'Начать с шаблона (необязательно)',
      rowNamePlaceholder: 'Название строки',
      kind: {
        urge: 'Побуждение',
        scale: 'Шкала',
        action: 'Да / нет',
        count: 'Количество',
        text: 'Короткий текст',
      },
      scaleTo: 'От 0 до {{max}}',
      countable: 'Считать количество',
      removeRow: 'Удалить',
      addRow: 'Добавить строку',
      emotions: 'Чувства (оценка 0–5)',
      skills: 'Навыки',
      needRows:
        'Добавьте хотя бы одну строку, чувство или навык, чтобы сохранить дневник.',
      needNames: 'Укажите название для каждой строки, чтобы сохранить дневник.',
      saveCard: 'Сохранить дневник',
      cardSaved:
        'Дневник сохранён. Клиент увидит его в своей форме при следующем заполнении.',
      saveFailed:
        'Не удалось сохранить дневник. Проверьте строки и попробуйте ещё раз.',
      cancel: 'Отмена',
      day: 'День',
      practiceCardTitle: 'Дневник Вашей практики',
      clientCardTitle: 'Настроен клиентом',
      readOnly: 'Настроен клиентом · только чтение',
      filledInSession: 'Заполнено на сессии',
      skillsUsed: 'Использование навыков',
      yes: 'Да',
      no: 'Нет',
      empty:
        'Для этого клиента пока нет дневника самонаблюдения. Настройте его, и здесь появится неделя клиента.',
      loadError:
        'Не удалось загрузить дневник самонаблюдения. Обновите страницу, чтобы попробовать ещё раз.',
    },
    session: {
      fillButton: 'Заполнить на сессии',
      fillTitle: 'Заполнить дневник самонаблюдения для: {{name}}',
      fillHint:
        'Вносится на сессии: эта запись входит в историю Вашей практики, видна Вашей практике и клиенту. Она не считается самостоятельным заполнением клиента и не закрывает назначенное задание с дневником самонаблюдения.',
      day: 'День',
      skillsUsed: 'Использование навыков (0–7)',
      skillsPracticed: 'Практиковавшиеся навыки',
      note: 'Заметка',
      save: 'Сохранить для клиента',
      saved: 'Дневник самонаблюдения заполнен для клиента.',
      saveFailed:
        'Не удалось сохранить дневник самонаблюдения. Проверьте значения и попробуйте ещё раз.',
      recapTitle: 'Главное из дневника самонаблюдения (дневник Вашей практики)',
      recapNone: 'С прошлой сессии ни одна оценка не превысила ноль.',
      recapLine: '{{day}} · {{name}}: {{value}}',
      recapSkills: 'Использование навыков в среднем: {{value}}',
    },
    row: {
      't-suicide-urge': 'Побуждение к суициду',
      't-selfharm-urge': 'Побуждение к самоповреждению',
      't-drugs-urge': 'Побуждение к употреблению наркотиков',
      't-selfharm': 'Самоповреждение',
      't-binge': 'Переедание',
      't-other-urge': 'Другое побуждение',
      't-acted': 'Поддались ли Вы побуждению?',
      't-planned-meals': 'Приёмы пищи и перекусы в запланированное время',
      't-binges': 'Приступы переедания',
      't-compensating': 'Компенсаторное поведение',
      't-gap-4h': 'Перерыв больше 4 часов',
      't-eating-feeling': 'Самочувствие сегодня',
      't-alcohol-grams': 'Граммы алкоголя',
      't-drink-urge': 'Побуждение выпить',
      't-drink-trigger': 'Триггер',
    },
    emotion: {
      emotionalMisery: 'Эмоциональные страдания',
      physicalMisery: 'Физические страдания',
      joy: 'Радость',
    },
    module: {
      mindfulness: 'Осознанность',
      distressTolerance: 'Переносимость дистресса',
      emotionRegulation: 'Эмоциональная регуляция',
      interpersonalEffectiveness: 'Межличностная эффективность',
    },
    skill: {
      wiseMind: 'Мудрый разум',
      observe: 'Наблюдение',
      describe: 'Описание',
      participate: 'Участие',
      nonjudgmental: 'Безоценочно',
      oneMindful: 'Однонаправленно',
      effective: 'Эффективно',
      tipp: 'ТИПП',
      stop: 'СТОП',
      proCons: 'Плюсы и минусы',
      distract: 'Отвлечение',
      selfSoothe: 'Самоуспокоение',
      improve: 'УЛУЧШИ момент',
      radicalAcceptance: 'Радикальное принятие',
      turningTheMind: 'Поворот ума',
      willingness: 'Готовность',
      checkTheFacts: 'Проверка фактов',
      oppositeAction: 'Противоположное действие',
      problemSolving: 'Решение проблем',
      accumulatePositives: 'Накопление положительных эмоций',
      buildMastery: 'Развитие компетентности',
      copeAhead: 'Заблаговременное совладание',
      please: 'ПОЖАЛУЙСТА',
      mindfulOfEmotions: 'Осознанность текущих эмоций',
      dearMan: 'ПРОСИ ДЕЛО',
      give: 'ДРУГ',
      fast: 'ЧЕСТЬ',
      validation: 'Валидация',
      findingBalance: 'Поиск баланса',
      walkTheMiddlePath: 'Срединный путь',
    },
    template: {
      dbtStandard: {
        name: 'Дневник самонаблюдения ДБТ',
        summary:
          'Стандартный дневник ДБТ: побуждения, действия, чувства и использованные навыки день за днём',
      },
      dbtSkills: {
        name: 'Дневник навыков ДБТ',
        summary:
          'Минута в день: побуждения, страдания, поддались ли Вы им и какие навыки использовали',
      },
      eatingDay: {
        name: 'Питание за день',
        summary:
          'Как прошёл день: запланированные приёмы пищи, приступы переедания, компенсаторное поведение, большой перерыв и самочувствие',
      },
      drinkingDay: {
        name: 'Алкоголь за день',
        summary: 'Граммы алкоголя, побуждение выпить и что его вызвало',
      },
    },
  },
  // E43 · Health Data (cc-health) — generated by gen-ru-gemini.mjs (review: docs/em&es/archive/ru-reviews/RU-REVIEW-2026-10-09-E43-block-1.md)
  healthData: {
    errors: {
      HEALTH_TYPES_EMPTY: 'Выберите хотя бы один тип данных о здоровье, затем нажмите «Продолжить».',
      HEALTH_TYPE_UNKNOWN: 'Этот тип данных о здоровье не поддерживается Вашей версией CopingCard. Обновите приложение и попробуйте ещё раз.',
      HEALTH_TYPE_NOT_GRANTED: 'Этот тип данных о здоровье сейчас не передаётся в CopingCard. Откройте «Данные о здоровье» в «Настройках», чтобы посмотреть текущие доступы, и попробуйте ещё раз.',
      HEALTH_SHARING_NO_RELATION: 'Вы больше не связаны с этим терапевтом, поэтому делиться нечем. Потяните вниз, чтобы обновить список.',
      conflictRetry: 'Настройки данных о здоровье изменились в этот же момент. Пожалуйста, попробуйте ещё раз.',
    },
  },
  health: {
    types: {
      sleep: 'Сон',
      activity: 'Активность',
      heartRate: 'Пульс',
    },
    stores: {
      appleHealth: 'Apple Health («Здоровье»)',
      healthConnect: 'Health Connect от Google',
    },
    connect: {
      intro: 'CopingCard может считывать сводки за день из {{store}}, чтобы Вам не приходилось вводить их вручную. Выберите, какими данными делиться. В {{store}} ничего не записывается.',
      typeDetail: {
        sleep: 'Время в постели, время сна, пробуждения и фазы сна: одна сводка за ночь.',
        activity: 'Шаги, минуты активности и тренировки: одна сводка за день.',
        heartRate:
          'Пульс в покое и вариабельность сердечного ритма: одна сводка за день. Во время сессий экспозиции: Ваш минимальный, средний и максимальный пульс.',
      },
      privacy: 'Ваш терапевт ничего из этого не видит, пока Вы сами не включите обмен данными с ним. Используется только для заботы о Вас: никакой рекламы, никакой продажи данных.',
      continue: 'Продолжить',
      saving: 'Сохранение…',
      saveError: 'Не удалось сохранить Ваш выбор. Проверьте подключение к интернету и попробуйте ещё раз.',
      permissionError: 'Не удалось открыть разрешения в {{store}}. Попробуйте ещё раз или разрешите доступ для CopingCard вручную в {{store}}.',
      unavailable: {
        title: 'Данные о здоровье недоступны на этом устройстве',
        oldAndroid: 'Для Health Connect требуется Android 9 или новее.',
        notInstalled: 'Чтобы делиться данными о здоровье, установите Health Connect из Google Play, затем вернитесь сюда.',
        updateRequired: 'Чтобы делиться данными о здоровье, обновите Health Connect в Google Play, затем вернитесь сюда.',
        noHealthKit: 'Apple Health недоступно на этом устройстве.',
        updateApp: 'Чтобы делиться данными о здоровье, обновите CopingCard в App Store или Google Play.',
        openStore: 'Открыть Google Play',
      },
    },
    settings: {
      title: 'Данные о здоровье',
      open: 'Данные о здоровье',
      from: 'Из {{store}}',
      shared: 'Передаётся с {{date}}',
      notShared: 'Не передаётся',
      lastNight: 'Прошлой ночью: {{night}}',
      lastDay: 'За прошлый день: {{day}}',
      noDataYet: 'Пока нет данных',
      noDataHint: 'Данные пока не поступили. Если Вы отклонили доступ, разрешите CopingCard читать эти данные в {{store}}.',
      lastImport: 'Последний импорт: {{time}}',
      shareMore: 'Делиться другими данными',
      stopSharing: 'Перестать делиться…',
      openHealthApp: 'Открыть приложение «Здоровье»',
      openHealthConnect: 'Открыть Health Connect',
      loadError: 'Не удалось загрузить настройки данных о здоровье. Проверьте подключение к интернету и потяните вниз, чтобы повторить попытку.',
    },
    open: {
      sleep: 'Мой сон',
      activity: 'Моя активность',
      heartRate: 'Моё сердце',
      sharing: 'Обмен данными с терапевтом',
    },
    summary: {
      days30: '30 дней',
      empty: 'Данные пока не поступили. Они появятся, когда Вы в следующий раз откроете CopingCard с данными из {{store}} на этом телефоне.',
      loadError: 'Не удалось загрузить эти данные. Проверьте подключение к интернету и потяните вниз, чтобы повторить попытку.',
    },
    sleep: {
      title: 'Мой сон',
      subtitle: '30 ночей по данным Вашего устройства',
      averageAsleep: 'В среднем сна: {{duration}}',
      averageEfficiency: 'Средняя эффективность сна: {{percent}}%',
      inBed: 'В постели {{duration}}',
      asleep: 'Сон {{duration}}',
      efficiency: 'Эффективность {{percent}}%',
      awakenings_one: '{{count}} пробуждение',
      awakenings_few: '{{count}} пробуждения',
      awakenings_many: '{{count}} пробуждений',
      awakenings_other: '{{count}} пробуждения',
      duration: '{{hours}} ч {{minutes}} мин',
    },
    activity: {
      title: 'Моя активность',
      subtitle: '30 дней шагов, минут активности и тренировок',
      averageSteps: 'В среднем шагов: {{count}}',
      averageActiveMinutes: 'В среднем минут активности: {{count}}',
      steps: 'Шаги: {{count}}',
      activeMinutes: 'Активность: {{count}} мин',
      workout: '{{type}} · {{minutes}} мин',
      workoutTypes: {
        walking: 'Ходьба',
        running: 'Бег',
        cycling: 'Велосипед',
        swimming: 'Плавание',
        yoga: 'Йога',
        strength: 'Силовая тренировка',
        hiking: 'Хайкинг',
        dance: 'Танцы',
        other: 'Тренировка',
      },
    },
    heart: {
      title: 'Моё сердце',
      subtitle: '30 дней пульса в покое и вариабельности сердечного ритма',
      averageResting: 'Средний пульс в покое: {{bpm}} уд/мин',
      resting: 'В покое {{bpm}} уд/мин',
      hrv: 'ВСР {{value}} мс ({{metric}})',
      metricNote: 'ВСР измеряется как SDNN на iPhone и как RMSSD на Android. Это разные показатели, поэтому сравнивать значения с разных телефонов нельзя.',
    },
    sharing: {
      title: 'Обмен данными с терапевтом',
      intro: 'Выберите, что видит каждый из Ваших терапевтов в своём портале CopingCard: сводки о сне за ночь, итоги активности за день, а также пульс в покое, ВСР и пульс во время экспозиций. Никаких поминутных данных. Отключено, пока Вы не включите сами.',
      noTherapists: 'Вы пока не подключены к терапевту. Когда подключитесь, здесь можно будет выбрать, что именно он видит.',
      notSharedWithCopingCard: 'Сначала поделитесь этим с CopingCard в разделе «Данные о здоровье».',
      saveError: 'Не удалось сохранить. Проверьте подключение к интернету и попробуйте ещё раз.',
      typeHint: {
        sleep: 'Сводки о сне за ночь',
        activity: 'Шаги, минуты активности и тренировки за день',
        heartRate: 'Пульс в покое, ВСР и пульс во время экспозиций',
      },
    },
    hub: {
      tab: 'Сон и активность',
      title: 'Сон и активность: последние 30 дней',
      notShared: 'не передаётся',
      notSharedHint: 'Клиент не делится с Вами: {{type}}.',
      noDataYet: 'Данные пока не поступили.',
      loadError: 'Не удалось загрузить этот раздел. Обновите страницу и попробуйте ещё раз.',
      sleepSummary: 'В среднем сна {{asleep}} · эффективность {{efficiency}}% · ночей: {{count}} из {{days}}',
      activitySummary: 'В среднем {{steps}} шагов и {{active}} мин активности в день · дней: {{count}}',
      heartSummary: 'Средний пульс в покое {{bpm}} уд/мин · дней: {{count}}',
      hrvMetric: 'Телефон клиента измеряет ВСР как {{metric}}; сравнивать показатели SDNN и RMSSD нельзя.',
      mood: 'Настроение (записи)',
      moodSummary_one: '{{count}} день с записью настроения',
      moodSummary_few: '{{count}} дня с записью настроения',
      moodSummary_many: '{{count}} дней с записью настроения',
      moodSummary_other: '{{count}} дня с записью настроения',
      empty: 'За последние 30 дней данных нет.',
      footer: 'С телефона клиента · передаётся Вам: {{shared}} · не передаётся: {{notShared}}',
      column: {
        day: 'День',
        asleep: 'Сон',
        efficiency: 'Эффективность',
        steps: 'Шаги',
        activeMinutes: 'Активность, мин',
        restingHeartRate: 'Пульс в покое',
        hrv: 'ВСР',
        mood: 'Настроение',
        score: 'Балл',
      },
    },
    // the phone beside the E37 check-ins (Q-e43g1-6 A)
    checkIns: {
      fromPhone: 'С Вашего телефона: {{values}}',
      rowsTitle: 'С телефона клиента',
      asleepRow: 'Сон (часы)',
      activeRow: 'Минуты активности',
      notShared: 'не передаётся',
      sleepAverage: 'В среднем сна {{duration}} · эффективность {{percent}}%',
      sleepAverageNoEfficiency: 'В среднем сна {{duration}}',
      activeAverage: 'В среднем {{count}} мин активности в день',
      recapTitle: 'С телефона клиента с прошлой сессии',
      recapNotShared: '{{type}}: не передаётся Вам',
    },
    revoke: {
      title: 'Перестать делиться',
      choose: 'Выберите, чем перестать делиться',
      deleteImported: 'Также удалить импортированные данные',
      osNote: 'Чтобы полностью закрыть доступ CopingCard, также отключите его в {{store}}.',
      confirm: 'Перестать делиться',
      cancel: 'Отмена',
      saving: 'Отключение…',
      error: 'Не удалось отключить передачу данных. Проверьте подключение к интернету и попробуйте ещё раз.',
      done: 'Передача данных отключена.',
    },
  },
  safetyPlan: {
    errors: {
      SAFETYPLAN_SECTION_UNKNOWN: 'В Вашей версии CopingCard этой части плана нет. Вернитесь к плану и выберите одну из его частей.',
      SAFETYPLAN_SECTION_TOO_LONG: 'В одной части плана может быть до 10 записей. Удалите одну и сохраните снова.',
      SAFETYPLAN_CONTACT_NAME: 'У каждого человека должно быть имя. Добавьте имя в каждую запись или удалите пустые, затем сохраните снова.',
      SAFETYPLAN_NOT_ALLOWED: 'Вы можете редактировать этот план, только если клиент разрешил Вам редактировать свои записи. Попросите клиента включить для Вас редактирование в приложении и попробуйте ещё раз.',
      SAFETYPLAN_NONE: 'Здесь пока нечего пересматривать — ни одна часть плана ещё не сохранена. Сначала заполните с клиентом хотя бы одну часть, затем отметьте план как пересмотренный.',
      SAFETY_PLAN_NOT_YOURS: 'Не удалось открыть этот план. Закройте его и откройте свой план снова из раздела «Кризис».',
      HOMEWORK_NOT_YOUR_CLIENT: 'Этот клиент не связан с Вами в Вашей практике: он не числится Вашим клиентом здесь или отключил обмен данными с Вами. Проверьте список клиентов или попросите клиента снова включить обмен данными с Вами в приложении.',
      conflictRetry: 'План изменился в тот же момент. Пожалуйста, попробуйте ещё раз.',
    },
    diaryLink: 'Мой план безопасности',
    intro: 'План, который Вы составляете в устойчивом состоянии на случай, когда станет тяжело. Читайте его сверху вниз и остановитесь на первом же шаге, который поможет.',
    entry: {
      mine: 'Мой план безопасности',
      make: 'Составить план безопасности',
      mineBody: 'Шаги, которые мне помогают, и контакты тех, кому можно позвонить.',
      makeBody: 'Запишите, что Вам помогает и кому позвонить — дополнить план можно в любой момент.',
      filled: 'Заполнено: {{count}} из 7 частей',
      toolkit: 'Мой план безопасности',
      toolkitMake: 'Составить план безопасности',
    },
    sections: {
      warningSigns: {
        title: '1. Предупреждающие признаки',
        prompt: 'Что я замечаю, когда мне начинает становиться тяжело?',
        hint: 'Мысли, настроение, ситуации или ощущения в теле, например: «Перестаю отвечать на сообщения».',
      },
      copingStrategies: {
        title: '2. Что я могу сделать самостоятельно',
        prompt: 'Что я могу сделать самостоятельно, чтобы отвлечься?',
        hint: 'Например: «умыться холодной водой» или «пройтись вокруг дома».',
      },
      distractions: {
        title: '3. Люди и места, которые помогают почувствовать себя устойчивее',
        prompt: 'Куда я могу пойти или с кем побыть рядом, чтобы почувствовать себя устойчивее?',
        hint: 'Кухня друга, кафе, парк, храм — любое место, где есть люди.',
      },
      helpContacts: {
        title: '4. Люди, у которых я могу попросить о помощи',
        prompt: 'Кому я могу рассказать о том, что мне тяжело?',
        hint: 'Укажите имя и номер телефона. Можно выбрать контакт из телефонной книги.',
      },
      professionals: {
        title: '5. Специалисты и кризисные линии',
        prompt: 'Кому я могу позвонить, если не получается обеспечить себе безопасность?',
        hint: 'Ваш терапевт, лечащий врач и кризисные линии ниже.',
      },
      environmentSafety: {
        title: '6. Безопасность окружения',
        prompt: 'Что я могу сделать, чтобы обезопасить своё окружение?',
        hint: 'Лучше заполнять вместе с Вашим терапевтом.',
        note: 'Лучше заполнять вместе с Вашим терапевтом.',
      },
      reasonsForLiving: {
        title: '7. Мои причины жить',
        prompt: 'Что для меня важнее всего? Ради чего я хочу остаться?',
        hint: 'Люди, питомцы, планы, то, что Вы хотите увидеть или сделать.',
      },
    },
    empty: 'Здесь пока ничего нет.',
    addedByTherapist: 'Добавлено Вашим терапевтом',
    addedByName: 'Добавлено: {{name}}',
    yourTherapist: 'Ваш терапевт',
    action: {
      edit: 'Изменить',
      call: 'Позвонить',
      message: 'Написать',
      text: 'Написать SMS',
      share: 'Поделиться',
      save: 'Сохранить',
      saving: 'Сохранение…',
      cancel: 'Отмена',
      add: 'Добавить',
      remove: 'Удалить',
      done: 'Готово',
      openChat: 'Открыть чат',
      openLink: 'Открыть ссылку',
    },
    messageDraft: 'Мне сейчас тяжело — можешь мне позвонить?',
    shareTitle: 'Мой план безопасности',
    shareIntro: 'Мой план безопасности',
    opensDisclosure:
      'Если Вы делитесь данными с терапевтом, он видит, сколько раз в неделю Вы открываете этот план — но не когда именно и не то, что Вы читали. В момент открытия терапевту ничего не отправляется.',
    offline: 'Вы не в сети. Ваш план сохранён на этом телефоне, и Вы по-прежнему можете его читать.',
    loadError: 'Не удалось загрузить Ваш план. Проверьте подключение и потяните вниз, чтобы попробовать снова.',
    edit: {
      title: 'Изменить эту часть',
      entryText: 'Одна запись',
      entryName: 'Имя',
      entryPhone: 'Номер телефона',
      pickContact: 'Выбрать из контактов',
      kindPerson: 'Человек — нажмите, чтобы переключить на место',
      kindPlace: 'Место — нажмите, чтобы переключить на человека',
      addEntry: 'Добавить ещё',
      maxEntries: 'До 10 записей.',
      clearHint: 'Оставьте пустым, чтобы очистить эту часть.',
      saved: 'Сохранено.',
      saveError: 'Не удалось сохранить. Проверьте подключение и попробуйте ещё раз.',
      contactsDenied: 'У CopingCard нет доступа к Вашим контактам. Введите имя и номер вручную или разрешите доступ к контактам в настройках телефона.',
    },
    callError: 'С этого телефона нельзя позвонить отсюда. Наберите номер вручную.',
    hub: {
      tab: 'План безопасности',
      title: 'План безопасности',
      noPlan: 'Этот клиент ещё не составил план безопасности. Вы можете начать составлять его вместе здесь.',
      readOnly: 'Вы можете просматривать этот план; для редактирования требуется разрешение клиента на изменение его записей.',
      opensThisWeek_one: 'Открыт {{count}} раз на этой неделе',
      opensThisWeek_few: 'Открыт {{count}} раза на этой неделе',
      opensThisWeek_many: 'Открыт {{count}} раз на этой неделе',
      opensThisWeek_other: 'Открыт {{count}} раза на этой неделе',
      opensNote: 'Только количество — без времени и без того, что было прочитано. Клиент знает, что Вы видите это число.',
      opensWeeks: 'Открытий в неделю',
      weekOf: 'Неделя с {{date}}',
      lastReviewed: 'Последний пересмотр: {{date}} (с участием: {{name}})',
      lastReviewedNoName: 'Последний пересмотр: {{date}}',
      nextReview: 'Следующий пересмотр: до {{date}}',
      neverReviewed: 'Пока не пересматривался',
      edit: {
        action: 'Редактировать с клиентом',
        title: 'Редактировать с клиентом',
        save: 'Сохранить часть',
        cancel: 'Отмена',
        entry: 'Запись',
        person: 'Человек',
        place: 'Место',
        name: 'Имя',
        phone: 'Телефон',
        add: 'Добавить запись',
        remove: 'Удалить',
        saved: 'Сохранено. На телефоне клиента изменения появятся сразу.',
        error: 'Не удалось сохранить. Проверьте подключение и попробуйте ещё раз.',
      },
      review: {
        action: 'Отметить как пересмотренный',
        title: 'Отметить план как пересмотренный',
        nextReviewBy: 'Следующий пересмотр до',
        note: 'Заметка (необязательно)',
        notePlaceholder: 'Например: прошли по всем шагам; добавили вторую причину жить',
        save: 'Отметить как пересмотренный',
        saving: 'Сохранение…',
        cancel: 'Отмена',
        saved: 'Отмечено как пересмотренный.',
        error: 'Не удалось сохранить отметку о пересмотре. Проверьте подключение и попробуйте ещё раз.',
      },
      byClient: 'клиент',
      byTherapistName: '{{name}}',
    },
    history: {
      title: 'История',
      when: 'Когда',
      what: 'Что изменилось',
      empty: 'Изменений пока нет.',
      savedPart: '{{who}}: изменения в «{{section}}»',
      reviewedBy: '{{who}}: план отмечен как пересмотренный',
      nextReview: 'Следующий пересмотр: до {{date}}',
      noEntries: 'очищено',
      loadError: 'Не удалось загрузить историю. Обновите страницу и попробуйте ещё раз.',
    },
    widget: {
      name: 'Мой план',
      description: 'Открыть план в одно касание.',
      tap: 'Нажмите, чтобы открыть',
      intentTitle: 'Открыть мой план',
      intentDescription: 'Открывает Ваш план в CopingCard.',
      shortcutShort: 'Мой план',
      shortcutLong: 'Открыть мой план',
      siriPhrase: 'Открой мой план в {{app}}',
      siriPhraseAlt: 'Открой в {{app}} мой план',
      renameTitle: 'Название вне приложения',
      renameBody:
        'Это название отображается на виджете на главном экране. Его видите только Вы; ничего не записывается.',
      renameLabel: 'Название',
      renameSave: 'Сохранить',
    },
  },
  safetyPrompt: {
    title: 'Похоже, Вам сейчас очень тяжело',
    body: 'Если Вам сейчас нужна поддержка, откройте свой план безопасности или посмотрите телефоны доверия. Всё остаётся на Вашем телефоне: то, что Вы написали, никому не отправлялось.',
    openPlan: 'Открыть мой план безопасности',
    makePlan: 'Составить мой план безопасности',
    crisisLines: 'Посмотреть телефоны доверия',
    notNow: 'Не сейчас',
  },
  // ── E47 · Schema modes — the founder-APPROVED Russian wording of the fourteen modes (Q-e47g1-9 A, 2026-10-16): the names, one-line
  // descriptions, groups, presets and labels are docs/em&es/review-2026-10-16-argon-check/E47-mode-wording.ru.md AS WRITTEN (not
  // regenerated); «Копинг-режимы» is the group heading in the app (Q-e47g1-8 A). The rest of `modes.*` is generated.
  modes: {
    errors: {
      MODE_SET_EMPTY: 'В списке должен быть хотя бы один режим. Включите любой из них и сохраните снова.',
      MODE_SET_TOO_MANY: 'Слишком много режимов. Можно оставить 14 стандартных и добавить до 6 своих. Удалите лишний и сохраните снова.',
      MODE_SET_NEEDS_HEALTHY_ADULT: 'Здоровый Взрослый обязательно должен оставаться в списке режимов — он включён всегда. Включите его обратно и сохраните снова.',
      MODE_KIND_INVALID: 'Один из режимов не удалось сохранить. Собственный режим должен иметь название и относиться к детским, копинг- или критикующим режимам (Здоровый Взрослый уже добавлен). Проверьте свои режимы и сохраните снова.',
      MODE_SET_NOT_YOUR_CLIENT: 'Этот клиент не связан с Вами в практике: он не числится Вашим клиентом или отключил обмен данными с Вами. Проверьте список клиентов или попросите клиента снова включить обмен данными в приложении.',
      MODE_CHECKIN_EMPTY: 'Отметьте хотя бы один активный режим, затем сохраните.',
      MODE_UNKNOWN: 'Одного из этих режимов больше нет в Вашем списке. Откройте «Мои режимы», чтобы посмотреть актуальный список, а затем отметьте режимы снова.',
      MODE_INTENSITY_RANGE: 'Интенсивность каждого режима оценивается от 0 до 10. Передвиньте ползунок на число в этом диапазоне и сохраните снова.',
      MODE_CHECKIN_TIME: 'Отметить режимы можно за текущий момент или задним числом до 48 часов назад. Выберите время в этих пределах.',
      MODE_CARD_NOT_YOURS: 'Эту карточку не удалось найти среди Ваших копинг-карточек. Откройте свои карточки и выберите одну из них.',
      MODE_CHECKIN_NOT_YOURS: 'Удалять можно только собственные записи.',
      MODE_CHECKIN_UNKNOWN: 'Эта запись не найдена — возможно, она уже была удалена. Обновите список.',
    },
    catalog: {
      presets: { commonSeven: 'Семь основных', allFourteen: 'Все четырнадцать' },
      groups: {
        child: 'Детские режимы',
        coping: 'Копинг-режимы',
        critic: 'Критикующие режимы',
        healthy: 'Здоровый Взрослый',
      },
      kinds: {
        child: 'Детский',
        coping: 'Копинг',
        critic: 'Критик',
        healthyAdult: 'Здоровый',
        happyChild: 'Детский',
      },
      inMyWords: 'Моими словами',
      addOwn: 'Добавить свой режим',
      vc: {
        name: 'Уязвимый Ребёнок',
        description: 'чувство беспомощности, одиночества, страха или перегруженности',
      },
      ac: {
        name: 'Сердитый Ребёнок',
        description: 'злюсь и расстраиваюсь, когда мои потребности не удовлетворяются',
      },
      ec: { name: 'Разъярённый Ребёнок', description: 'ярость, которая выходит из-под контроля' },
      ic: {
        name: 'Импульсивный Ребёнок',
        description: 'сразу поддаюсь порывам, не думая о последствиях',
      },
      uc: {
        name: 'Недисциплинированный Ребёнок',
        description: 'бросаю дело, как только становится скучно или трудно',
      },
      hc: { name: 'Счастливый Ребёнок', description: 'игривость, спонтанность, спокойствие' },
      cs: {
        name: 'Послушный Капитулянт',
        description: 'уступаю и угождаю другим, забывая о собственных потребностях',
      },
      dp: {
        name: 'Отстранённый Защитник',
        description: 'отключаю чувства, замыкаюсь или отдаляюсь от всех',
      },
      ds: {
        name: 'Отстранённый Самоутешитель',
        description: 'глушу чувства или отвлекаюсь работой, соцсетями, едой и привычками',
      },
      sa: {
        name: 'Самовозвеличиватель',
        description: 'потребность чувствовать превосходство, исключительность или контроль',
      },
      ba: {
        name: 'Агрессор',
        description: 'нападаю на других или контролирую их, пока они не причинили боль мне',
      },
      pc: {
        name: 'Карающий Критик',
        description: 'жестокое самобичевание, ощущение, что я заслуживаю наказания',
      },
      dc: {
        name: 'Требовательный Критик',
        description: 'постоянное давление: всего всегда недостаточно',
      },
      ha: {
        name: 'Здоровый Взрослый',
        description: 'мудрый, заботливый и уравновешенный; заботится о моих потребностях',
      },
    },
    needs: {
      safety: 'Безопасность',
      connection: 'Близость',
      acceptance: 'Принятие',
      expression: 'Быть услышанным',
      autonomy: 'Автономия',
      play: 'Игра',
      limits: 'Границы',
    },
    screens: {
      home: 'Режимы схем',
      setup: 'Мои режимы',
      checkIn: 'Какие режимы сейчас здесь?',
      week: 'Моя неделя',
      allCheckIns: 'Все записи',
      card: 'Карточка для этого режима',
    },
    entry: {
      title: 'Режимы схем',
      body: 'Назовите режимы, которые Вы замечаете у себя, и отмечайте, какие из них активны прямо сейчас.',
    },
    list: {
      title: 'Мои режимы',
      intro: 'Режимы, которые я замечаю у себя, своими словами.',
      defaultSet: 'Это семь основных режимов. Измените список, чтобы настроить его под себя.',
      checkIn: 'Какие режимы сейчас здесь?',
      edit: 'Изменить мои режимы',
      week: 'Моя неделя',
      noCard: '+ Добавить карточку',
      tapHeading: 'Нажмите на режим, который активен сейчас',
      openCard: 'Открыть карточку',
      changedByYou: 'Изменено Вами, {{date}}',
      changedBy: 'Изменено: {{name}}, {{date}}',
      changedByTherapist: 'Изменено Вашим терапевтом, {{date}}',
    },
    setup: {
      title: 'Настроить мои режимы',
      intro: 'Выберите режимы, за которыми хотите наблюдать, назовите их своими словами и подберите для каждого цвет. Это можно изменить в любой момент.',
      presets: 'Взять за основу',
      on: 'Включено',
      alwaysOn: 'Здоровый Взрослый включён всегда',
      colour: 'Цвет',
      colourChoice: 'Цвет {{n}}',
      ownName: 'Название режима',
      ownKind: 'Категория…',
      ownAdd: 'Добавить',
      ownCancel: 'Отмена',
      ownLimit: 'Добавлено максимальное число собственных режимов: {{max}}.',
      ownBadge: 'Собственный',
      save: 'Сохранить мои режимы',
      saving: 'Сохранение…',
      saved: 'Ваши режимы сохранены.',
      failed: 'Не удалось сохранить Ваши режимы. Проверьте подключение и попробуйте ещё раз.',
    },
    card: {
      heading: 'Карточка для этого режима',
      body: 'Выберите одну из своих копинг-карточек. Когда Вы отмечаете режимы, открывается карточка самого сильного из них — та, которую Вы привязали.',
      none: 'Карточка пока не привязана.',
      linked: 'Привязана: {{name}}',
      use: 'Использовать эту карточку',
      change: 'Сменить карточку',
      unlink: 'Отвязать',
      pick: 'Выберите копинг-карточку',
      myCards: 'Мои копинг-карточки',
      create: 'Создать новую карточку',
      unnamed: 'Моя карточка',
      search: 'Поиск по моим карточкам',
      showAll: 'Показать все ({{count}})',
      noMatch: 'Подходящих карточек не нашлось. Попробуйте другие слова или создайте новую карточку.',
      close: 'Закрыть',
      noCards:
        'У Вас пока нет копинг-карточек. Создайте карточку для этого режима.',
      createdNotLinked: 'Ваша карточка сохранена, но привязать её к этому режиму не удалось. Выберите её ниже или проверьте подключение и попробуйте ещё раз.',
      saved: 'Сохранено.',
      failed: 'Не удалось привязать карточку. Проверьте подключение и попробуйте ещё раз.',
    },
    checkin: {
      title: 'Какие режимы сейчас здесь?',
      intro: 'Отметьте режимы, которые активны прямо сейчас (их может быть несколько), и оцените каждый от 0 до 10.',
      noModes: 'Сначала включите хотя бы один режим в «Моих режимах».',
      intensity: 'Насколько выражен {{mode}}? (0–10)',
      triggerLabel: 'Что стало триггером? (необязательно)',
      triggerPlaceholder: 'Например: начальник сказал, что отчёт нужно доработать',
      bodyCueLabel: 'Где это ощущается в теле? (необязательно)',
      bodyCuePlaceholder: 'Например: горит лицо, подняты плечи',
      needLabel: 'Что мне было нужно? (необязательно)',
      noteLabel: 'Заметка (необязательно)',
      whenLabel: 'Когда это было?',
      when: {
        now: 'Сейчас',
        hour1: '1 час назад',
        hour3: '3 часа назад',
        yesterday: 'Вчера',
      },
      save: 'Сохранить',
      saving: 'Сохранение…',
      saved: 'Сохранено.',
      savedOffline: 'Сохранено на этом телефоне. Запись отправится, когда появится подключение к сети.',
      failed: 'Не удалось сохранить эту запись. Проверьте введённые данные и попробуйте ещё раз.',
      week: 'Моя неделя',
      edit: 'Изменить мои режимы',
    },
    week: {
      title: 'Моя неделя',
      range7: '7 дней',
      range30: '30 дней',
      periodHeading: 'Весь период',
      periodMeta: 'Дней: {{days}} · самый выраженный: {{peak}}',
      daysHeading: 'По дням',
      daySummary: 'Записей: {{count}} · самый выраженный: {{name}} {{peak}}',
      peak: 'самый выраженный: {{n}}',
      topTriggers: 'Что чаще всего становилось триггером',
      topTriggerCount: '{{count}}×',
      healthyAdult: 'Здоровый Взрослый на этой неделе',
      healthyShare: '{{share}}% от всех моих оценок',
      healthyPresent: 'Отмечен в {{present}} из {{total}} записей',
      healthyMean: 'Средняя выраженность, когда активен: {{mean}}',
      healthyNoShare: 'На этой неделе пока нет оценок выше 0.',
      healthyNotRated: 'Здоровый Взрослый на этой неделе не оценивался.',
      switchedOff: 'выключен',
      cardOpen: 'Открыть карточку',
      edit: 'Изменить мои режимы',
      checkIn: 'Какие режимы сейчас здесь?',
      olderBlur: 'Смотрите всю историю с подпиской Premium',
      olderCount: 'Более ранних дней с записями: {{count}}',
      entries: 'Записи',
      allCheckIns: 'Все записи ({{count}})',
      empty: 'Пока нет ни одной записи. Нажмите «Какие режимы сейчас здесь?», чтобы начать.',
      menu: 'Ещё',
    },
    all: {
      title: 'Все записи',
      empty: 'За этот период записей нет.',
    },
    delete: {
      action: 'Удалить',
      title: 'Удалить эту запись?',
      body: 'Она будет удалена из «Моей недели».',
      failed: 'Не удалось удалить эту запись. Проверьте подключение и попробуйте ещё раз.',
    },
    prompts: {
      title: 'Три напоминания в день',
      body: 'Негромкое напоминание в 11:00, 15:00 и 20:00, чтобы заметить активные режимы. Время можно изменить.',
      on: 'Включено: напоминаний в день — {{n}}',
      off: 'Выключено',
      turnOn: 'Включить напоминания',
      turnOff: 'Выключить напоминания',
      notificationTitle: 'Какие режимы сейчас здесь?',
      notificationBody: 'Короткая пауза: отметьте режимы, которые активны прямо сейчас.',
    },
    hub: {
      title: 'Режимы схем',
      displayOnly: 'Собственные слова и оценки клиента без изменений — без оповещений, баллов и рекомендаций.',
      loadError: 'Не удалось загрузить режимы. Проверьте подключение и попробуйте ещё раз.',
      loading: 'Загрузка режимов…',
      emptyPeriod: 'За этот период записей режимов нет. Они появятся здесь, когда {{name}} отметит режимы на телефоне.',
      period: {
        title: 'Весь период',
        meta: 'Дней: {{days}} · самый выраженный: {{peak}}',
        label: 'Период',
        d7: '7 дней',
        d30: '30 дней',
        d90: '90 дней',
        custom: 'Произвольный',
        from: 'С',
        to: 'По',
        range: '{{from}} – {{to}}',
      },
      map: {
        title: 'Карта режимов',
        card: 'карточка',
        noCard: 'карточки пока нет',
        switchedOff: 'выключен',
        own: 'собственный режим',
      },
      timeline: {
        title: 'По дням',
        hint: 'Максимальная оценка каждого режима за день, друг над другом.',
        segment: '{{mode}} — пик: {{peak}}',
      },
      matrix: {
        title: 'Триггеры и режимы',
        hint: 'Сколько раз каждый режим встречался с этим триггером.',
        trigger: 'Триггер',
        empty: 'За этот период триггеры не указывались.',
      },
      ha: {
        title: '{{mode}} по неделям',
        week: 'Неделя с {{date}}',
        share: '{{percent}} % от общей интенсивности',
        noFigure: 'нет данных',
        notRated: 'не оценивался на этой неделе',
        present: 'отмечен в {{present}} из {{total}} записей',
        mean: 'средняя выраженность: {{mean}}, когда активен',
        empty: 'За этот период записей нет.',
      },
      counts: {
        thisWeek: 'Записей на этой неделе: {{count}}',
        inRange: 'Записей за этот период: {{count}}',
      },
      lastChange: {
        client: 'Изменено клиентом: {{date}}',
        therapist: 'Изменено: {{name}}, {{date}}',
        therapistNoName: 'Изменено терапевтом: {{date}}',
        you: 'Изменено Вами: {{date}}',
        never: 'Режимы пока не менялись — показаны семь основных.',
      },
      setup: {
        open: 'Настроить режимы',
        title: 'Настроить режимы: {{name}}',
        hint: 'Выберите режимы, которые нужно включить для {{name}}, и назовите их словами клиента. Действует последнее изменение, кто бы его ни внёс: {{name}} тоже может изменить их на телефоне.',
        enable: 'Включить {{mode}}',
        alwaysOn: 'всегда включён',
        name: 'Название словами клиента',
        colour: 'Цвет для {{mode}}',
        ownTitle: 'Собственные режимы',
        ownName: 'Название нового режима',
        ownKind: 'Категория',
        ownLimit: 'До {{max}} собственных режимов в дополнение к 14 стандартным.',
        remove: 'Удалить',
        save: 'Сохранить режимы для {{name}}',
        saved: 'Сохранено. Режимы уже на телефоне {{name}}.',
        error: 'Не удалось сохранить режимы. Проверьте подключение и попробуйте ещё раз.',
        needsName: 'Укажите название для каждого собственного режима, затем сохраните.',
      },
      assign: {
        defaultTitle: 'Замечайте свои режимы — три записи в день на этой неделе',
        defaultInstructions: 'Как только заметите сильные чувства, отметьте активные режимы.',
      },
    },
  },

  rose: {
    screens: {
      home: 'Роза ветров',
      describe: 'Стратегия поведения',
      rate: 'Восемь потребностей',
      choose: 'Примерить и выбрать',
      plan: 'Мой план',
    },
    credit: 'Техника доктора психологических наук Дмитрия Дьякова',
    needs: {
      loveAcceptance: 'Любовь и принятие',
      empathyUnderstanding: 'Сопереживание и понимание',
      predictabilityReliability: 'Предсказуемость и надёжность отношений',
      safety: 'Безопасность',
      competence: 'Компетентность',
      autonomy: 'Автономность',
      selfExpression: 'Свобода самовыражения',
      spontaneity: 'Спонтанность в действиях',
    },
    home: {
      intro: 'Стратегия поведения — это не просто слова, а то, как Вы действуете день за днём. Оцените её по восьми потребностям, чтобы увидеть форму, затем наложите другую стратегию и сделайте выбор.',
      empty: 'Здесь пока ничего нет. Начните с привычной стратегии поведения.',
      describeNow: 'Описать привычную стратегию',
      describeAnother: 'Описать другую стратегию',
      rateIt: 'Оценить по восьми потребностям',
      tryOnAndChoose: 'Примерить и выбрать',
      chartLabel: 'Роза ветров: каждая стратегия поведения отображается на восьми лучах, по одному на каждую потребность',
      ringHelp: 'Окружность на отметке 8 означает «достаточно». Баллы выше отображаются на графике, но не увеличивают среднее значение.',
      mean: 'Среднее (не выше 8): {{mean}}',
      rawMean: 'Среднее по всем оценкам: {{mean}}',
      kind: {
        current: 'Привычная стратегия',
        alternative: 'Другая стратегия',
      },
      basis: {
        lived: 'прожитая',
        imagined: 'воображаемая',
      },
      chosenTag: 'выбранная',
      chosenHeading: 'Выбранная стратегия',
      chosenValue: 'Ценность: {{value}}',
      beliefs: 'Убеждения, служащие опорой',
      sharedBy: 'Люди, которые её разделяют',
      history: 'История оценок',
      writePlan: 'Составить план',
      viewPlan: 'Мой план',
      rateAgain: 'Оценить выбранную стратегию снова',
      loadError: 'Не удалось загрузить розу ветров. Проверьте подключение и попробуйте ещё раз.',
      retry: 'Попробовать снова',
    },
    describe: {
      titleNow: 'Привычная стратегия',
      titleAnother: 'Другая стратегия',
      bodyNow: 'Дайте название привычной стратегии и опишите, как Вы действуете на самом деле. Указывать действия здесь необязательно.',
      bodyAnother: 'Опишите другую возможную стратегию: дайте ей название и укажите хотя бы одно конкретное действие. Именно поведение, а не результат.',
      help: 'Стратегия поведения — это название и конкретные действия, а не желаемый результат.',
      name: 'Название',
      namePlaceholder: 'Например: Жить легко',
      behaviorsNow: 'Что я делаю (необязательно)',
      behaviorsAnother: 'Что я буду делать (хотя бы одно)',
      behavior: 'Действие {{n}}',
      behaviorPlaceholder: 'Например: Записаться в гончарную студию по четвергам',
      addBehavior: 'Добавить ещё одно',
      behaviorsFull: 'Уже десять — это максимум для одной стратегии.',
      inspired: 'Откуда эта идея? (необязательно)',
      inspiredKind: {
        myPast: 'Моё прошлое',
        someoneClose: 'Кто-то из близких',
        someoneFar: 'Кто-то далёкий',
        bookOrFilm: 'Книга или фильм',
        valuesList: 'Мой список ценностей',
        other: 'Другой источник',
      },
      inspiredRef: 'Кто или что',
      inspiredRefPlaceholder: 'Имя, название или карточка',
      notCompleteNow: 'Дайте название стратегии, чтобы продолжить.',
      notCompleteAnother: 'Дайте стратегии название и укажите хотя бы одно действие.',
      save: 'Сохранить и оценить',
      saving: 'Сохранение…',
      error: 'Не удалось сохранить стратегию. Проверьте подключение и попробуйте ещё раз.',
    },
    rate: {
      title: 'Оценить по восьми потребностям',
      bodyLived: 'Закройте глаза и представьте, как живёте по только что описанной стратегии. Оцените её от 1 до 10 по каждой из восьми потребностей. Вы хорошо её знаете — она уже прожита.',
      bodyImagined: 'Закройте глаза и представьте жизнь по этой стратегии. Оцените её от 1 до 10 по каждой из восьми потребностей. Вы пока так не жили — она воображаемая.',
      help: '1 означает, что стратегия почти не закрывает эту потребность, 10 — закрывает с избытком. Добавьте краткий пример, если приходит на ум.',
      example: 'Пример (необязательно)',
      notComplete: 'Оцените все восемь потребностей, чтобы построить розу ветров.',
      save: 'Построить розу ветров',
      saving: 'Построение…',
      error: 'Не удалось сохранить оценку. Проверьте подключение и попробуйте ещё раз.',
    },
    choose: {
      tryOnTitle: 'Примерить',
      tryOnProgress: 'Стратегия {{n}} из {{total}}',
      tryOnPrompt: 'Закройте глаза. Представьте, что живёте так целую неделю: что Вы делаете, кто рядом с Вами, как ощущает себя Ваше тело. Побудьте с этим минуту.',
      tryOnQuestion: 'Что Вы замечаете? На этом шаге ничего не сохраняется.',
      listen: 'Слушать аудиогид',
      nextWay: 'Примерить следующую стратегию',
      toChoice: 'Выбрать',
      skipToChoice: 'Перейти сразу к выбору',
      title: 'Выбрать стратегию',
      body: 'Выберите стратегию, назовите ценность, которую она воплощает, и укажите, на что она опирается.',
      help: 'Убеждения служат внутренней опорой стратегии, а люди, которые её разделяют, — внешней опорой. Прежде чем выбрать стратегию, её необходимо оценить.',
      value: 'Ценность, которую она воплощает',
      valuePlaceholder: 'Например: Открытость к людям',
      beliefs: 'Убеждения, служащие опорой',
      beliefPlaceholder: 'Убеждение своими словами',
      addBelief: 'Добавить ещё одно убеждение',
      sharedBy: 'Люди, которые её разделяют',
      sharedPlaceholder: 'Имя',
      addShared: 'Добавить ещё одного человека',
      notComplete: 'Выберите стратегию и укажите её ценность, чтобы продолжить.',
      nothingRated: 'Сначала оцените хотя бы одну стратегию по восьми потребностям, затем вернитесь к выбору.',
      save: 'Выбрать эту стратегию',
      saving: 'Сохранение…',
      error: 'Не удалось сохранить Ваш выбор. Проверьте подключение и попробуйте ещё раз.',
    },
    plan: {
      body: 'Напишите, что Вы будете делать: на этой неделе, в этом месяце, в этом году. Укажите, кто в этом участвует и что для этого нужно.',
      week: 'На этой неделе',
      month: 'В этом месяце',
      year: 'В этом году',
      what: 'Что сделать',
      withWhom: 'С кем',
      resources: 'Что для этого нужно',
      addItem: 'Добавить шаг',
      save: 'Сохранить план',
      saving: 'Сохранение…',
      saved: 'Ваш план сохранён.',
      error: 'Не удалось сохранить Ваш план. Проверьте подключение и попробуйте ещё раз.',
      nothingChosen: 'Сначала выберите стратегию, затем составьте для неё план.',
      notComplete: 'Напишите хотя бы один шаг, чтобы сохранить план.',
      doorsTitle: 'Из Вашего плана',
      doorsBody: 'Превратите шаг из плана на эту неделю в конкретное действие.',
      withWhomLine: 'С кем: {{who}}',
      addActivity: 'Добавить в мои действия',
      addActivityConfirm: 'Добавить',
      difficulty: 'Насколько это сложно? 1 — самое лёгкое, 10 — самое трудное.',
      activityAdded: 'Добавлено в Ваши действия.',
      activityError: 'Не удалось добавить это действие. Проверьте подключение и попробуйте ещё раз.',
      planStep: 'Запланировать первый шаг',
      askHelp: 'Попросить о помощи',
      beliefsTitle: 'Сделать копинг-карточку из убеждения',
      beliefsBody: 'Убеждение, служащее опорой для Вашей стратегии, может стать карточкой, к которой легко обратиться в нужный момент.',
      beliefCard: 'Создать копинг-карточку',
    },
    hub: {
      title: 'Роза ветров',
      empty: 'Клиент пока не начал розу ветров.',
      loadError: 'Не удалось загрузить розу ветров. Обновите страницу и попробуйте ещё раз.',
      credit: 'Техника доктора психологических наук Дмитрия Дьякова',
      mean: 'Среднее (с ограничением в 8)',
      rawMean: 'Среднее по баллам',
      kindCurrent: 'Привычная стратегия',
      kindAlternative: 'Другая стратегия',
      chosen: 'Выбранная',
      chosenValue: 'Ценность',
      beliefs: 'Убеждения, служащие опорой',
      sharedBy: 'Люди, которые её разделяют',
      plan: 'План клиента',
      planWeek: 'На этой неделе',
      planMonth: 'В этом месяце',
      planYear: 'В этом году',
      enteredInSession: 'Внесено на сессии',
      details: 'Оценки и план',
      inspired: 'Источник: {{kind}}{{who}}',
      history: {
        title: 'Динамика',
        empty: 'Пока только одна оценка — динамики ещё нет.',
        way: 'Стратегия',
        date: 'Дата',
        basis: 'Основа',
        entered: 'Внесено',
        basisLived: 'прожитая',
        basisImagined: 'воображаемая',
      },
      session: {
        title: 'Вместе с клиентом',
        intro: 'Опишите, оцените и выберите стратегию вместе на сессии. Внесённые данные сохраняются в записях практики и не считаются домашним заданием клиента.',
        describe: 'Описать стратегию',
        describeFirst: 'Сначала опишите стратегию.',
        rateFirst: 'Сначала оцените стратегию.',
        describeRequired: 'Укажите название стратегии, а для другой стратегии — хотя бы одно действие клиента.',
        rateRequired: 'Оцените все восемь потребностей от 1 до 10.',
        chooseRequired: 'Выберите оценённую стратегию и назовите ценность, которую она воплощает.',
        inspiredRef: 'Кто или что',
        lastRating: 'Последняя: {{mean}} · {{basis}} · {{date}}',
        lastScore: 'последняя {{n}}',
        name: 'Название',
        kind: 'Какая стратегия',
        behaviors: 'Что делает или будет делать клиент (по одному действию на строку)',
        save: 'Сохранить',
        cancel: 'Отмена',
        saved: 'Сохранено.',
        error: 'Не удалось сохранить. Проверьте данные и попробуйте ещё раз.',
        rate: 'Оценить стратегию',
        way: 'Стратегия',
        basis: 'Основа',
        rateSave: 'Сохранить оценку',
        choose: 'Выбрать стратегию',
        value: 'Ценность, которую она воплощает',
        beliefs: 'Убеждения, служащие опорой (по одному на строку)',
        sharedBy: 'Люди, которые её разделяют (по одному на строку)',
        chooseSave: 'Сохранить выбор',
      },
    },
  },
  values: {
    screens: {
      profile: 'Мои ценности',
      sortIntro: 'Сортировка карточек',
      sort: 'Сортировка',
      sortResult: 'Мои главные ценности',
      wheelSetup: 'Колесо ценностей',
      wheelRate: 'Оценить колесо',
      wheel: 'Колесо ценностей',
      obstacle: 'Препятствие',
      commit: 'Обязательство действовать',
      vlq: 'Опросник',
      vlqResult: 'Результат опросника',
      activities: 'Действия',
    },
    entry: {
      title: 'Ценности',
      body: 'Что для Вас важно и как Вы воплощаете это в жизни.',
      bodyFilled: 'Ваши главные ценности и то, что Вы делаете ради них.',
    },
    profile: {
      intro: 'Выбранные Вами ценности и то, что сделано ради них. Записи из других инструментов можно связывать с ними.',
      empty: 'Начните с сортировки карточек, чтобы найти самые важные ценности. Колесо и опросник покажут, как Вы воплощаете их в жизни.',
      doors: {
        sort: 'Сортировка карточек',
        sortBody: 'Разложите карточки ценностей — около 4 минут для краткого набора.',
        wheel: 'Колесо ценностей',
        wheelBody: 'Где Вы сейчас и к чему стремитесь — по каждой сфере жизни.',
        vlq: 'Опросник',
        vlqBody: 'Десять сфер жизни: насколько они важны и как Вы следовали им на этой неделе.',
        windRose: 'Роза ветров',
        windRoseBody: 'Оцените стратегию поведения по восьми потребностям, сравните её с другой и сделайте выбор.',
      },
      rose: {
        line: 'Выбранная стратегия: {{name}} · среднее {{mean}} (не выше 8)',
      },
      lastSort: 'Последняя сортировка: {{date}}',
      rank: 'Номер {{rank}}',
      unranked: 'Остальные',
      wheelLargest: 'Наибольший разрыв на колесе · {{sector}}: сейчас {{current}}, желаемое {{ideal}} (разрыв {{gap}})',
      wheelNone: 'Колесо · {{sector}}: пока без оценки',
      vlqLargest: 'Наибольший разрыв в опроснике · {{area}}: важность {{importance}}, следование {{consistency}} (разрыв {{gap}})',
      nothingYet: 'Пока ничего нет — запланируйте действие ради этой ценности.',
      actionsHeading: 'Мои обязательства',
      activitiesHeading: 'Действия',
      activitiesCount_one: 'Действий: {{count}}',
      activitiesCount_few: 'Действий: {{count}}',
      activitiesCount_many: 'Действий: {{count}}',
      activitiesCount_other: 'Действий: {{count}}',
      linksCount: 'Связано: {{count}}',
      actionOpen: 'к выполнению',
      actionDone: 'выполнено',
      plan: 'Запланировать действие',
      loadError: 'Не удалось загрузить ценности. Проверьте подключение и попробуйте ещё раз.',
      retry: 'Попробовать снова',
    },
    sort: {
      intro: {
        title: 'Найдите то, что важно для Вас',
        body: 'Карточки будут появляться по одной. Решите, насколько эта ценность важна для Вас: очень важно, важно или не важно, — а затем расставьте самые важные по порядку.',
        quick: 'Краткий набор · 30 карточек · около 4 минут',
        full: 'Полный набор · 83 карточки · около 10 минут',
        citation: 'В основе — методика Personal Values Card Sort ({{citation}}), общественное достояние.',
        start: 'Начать сортировку',
        starting: 'Запуск…',
        resume: 'Продолжить начатую сортировку',
        loadError: 'Не удалось загрузить карточки. Проверьте подключение и попробуйте ещё раз.',
        startError: 'Не удалось начать сортировку. Пожалуйста, попробуйте ещё раз.',
      },
      sorting: {
        progress: 'Карточка {{n}} из {{total}}',
        prompt: 'Насколько это важно для Вас?',
        veryImportant: 'Очень важно',
        important: 'Важно',
        notImportant: 'Не важно',
        swipeHint: 'Смахните вправо: очень важно · вверх: важно · влево: не важно',
        undo: 'На одну карточку назад',
        rankTitle: 'Расставьте самые важные ценности по порядку',
        rankBody: 'Самая первая важна для Вас больше всего. Сохранится до 10 ценностей в выбранном порядке.',
        up: 'Переместить выше',
        down: 'Переместить ниже',
        dragHandle: 'Перетащите, чтобы изменить порядок: {{name}}',
        dragHint: 'Нажмите и удерживайте, затем перетащите. Или используйте «Переместить выше» и «Переместить ниже».',
        needMore: 'Нужно хотя бы 3 самые важные ценности. Добавьте их из категории «Важно»:',
        promote: 'Добавить',
        done: 'Готово',
        saving: 'Сохранение…',
        saveError: 'Не удалось сохранить сортировку. Пожалуйста, попробуйте ещё раз.',
        loadError: 'Не удалось загрузить эту сортировку. Вернитесь назад и начните её снова.',
      },
      result: {
        body: 'Эти ценности Вы поставили на первые места. Теперь они сохранены в Вашем профиле.',
        piles: '{{very}} очень важно · {{important}} важно · {{not}} не важно',
        toWheel: 'Перенести на колесо',
        toActivities: 'Запланировать действие',
        toProfile: 'Мой профиль',
        loadError: 'Не удалось загрузить этот результат. Откройте профиль, чтобы посмотреть свои ценности.',
      },
    },
    wheel: {
      setup: {
        title: 'Настройте своё колесо',
        body: 'Колесо состоит из сфер жизни, на которые Вы хотите взглянуть. Каждую из них Вы оцениваете дважды: где Вы сейчас и к чему стремитесь. Выберите готовый набор сфер — или укажите свои.',
        create: 'Создать моё колесо',
        creating: 'Создание…',
        customHint: 'Укажите от 2 до 12 сфер.',
        customName: 'Название сферы',
        addArea: 'Добавить сферу',
        removeArea: 'Удалить',
        error: 'Не удалось создать колесо. Пожалуйста, попробуйте ещё раз.',
        presets: {
          lava5: 'Пять сфер (по умолчанию)',
          bullsEye4: 'Четыре сферы (мишень)',
          wheelOfLife8: 'Восемь сфер (колесо жизни)',
          custom: 'Свои сферы',
        },
      },
      preset: {
        bullsEye4: {
          workEducation: 'Работа и образование',
          leisure: 'Досуг',
          relationships: 'Отношения',
          personalGrowthHealth: 'Личностный рост и здоровье',
        },
        lava5: {
          relationships: 'Отношения',
          educationCareer: 'Образование и карьера',
          recreation: 'Отдых и увлечения',
          mindBodySpirit: 'Разум, тело и дух',
          dailyResponsibilities: 'Повседневные обязанности',
        },
        wheelOfLife8: {
          career: 'Карьера',
          finances: 'Финансы',
          health: 'Здоровье',
          family: 'Семья и друзья',
          romance: 'Романтические отношения',
          growth: 'Личностный рост',
          recreation: 'Отдых и развлечения',
          environment: 'Дом и окружение',
        },
      },
      rate: {
        body: 'Для каждой сферы напишите в одну строку, что для Вас важно. Затем отметьте, где Вы сейчас и к чему стремитесь: 0 — совсем далеко от этого, 10 — живёте в полном согласии с этим.',
        statement: 'Что для меня важно здесь',
        now: 'Где я сейчас',
        ideal: 'К чему я стремлюсь',
        save: 'Сохранить оценку',
        saving: 'Сохранение…',
        error: 'Не удалось сохранить оценку. Пожалуйста, попробуйте ещё раз.',
        notComplete: 'Поставьте обе отметки для каждой сферы, чтобы сохранить.',
      },
      view: {
        title: 'Ваше колесо',
        empty: 'У Вас пока нет колеса. Настройте его, чтобы увидеть, где Вы сейчас и к чему стремитесь.',
        setUp: 'Настроить моё колесо',
        notRated: 'Пока без оценки',
        nowIdeal: 'Сейчас {{current}} · желаемое {{ideal}}',
        gap: 'Разрыв {{gap}}',
        before: 'Раньше: {{current}} → {{ideal}}',
        rateAgain: 'Оценить снова',
        rateFirst: 'Оценить моё колесо',
        addObstacle: 'Добавить препятствие',
        obstacle: '{{obstacle}} (мешает мне: {{severity}} из 7)',
        commit: 'Взять обязательство',
        actionOpen: 'к выполнению',
        actionDone: 'выполнено',
        ratedAt: 'Последняя оценка: {{date}}',
        ratedWithTherapist: 'Оценка на сессии с терапевтом: {{name}} · {{date}}',
        ratedWithTherapistNoName: 'Оценка на сессии с Вашим терапевтом: {{date}}',
        earlier: 'Предыдущих оценок: {{count}}',
        loadError: 'Не удалось загрузить колесо. Проверьте подключение и попробуйте ещё раз.',
      },
      obstacle: {
        title: 'Препятствие в сфере «{{sector}}»',
        body: 'Что стоит между тем, где Вы сейчас, и тем, к чему стремитесь?',
        text: 'Препятствие',
        severity: 'Насколько это мне мешает? 1 — совсем не мешает, 7 — полностью останавливает.',
        save: 'Сохранить',
        saving: 'Сохранение…',
        error: 'Не удалось сохранить препятствие. Пожалуйста, попробуйте ещё раз.',
      },
    },
    commit: {
      body: 'Одно конкретное действие и когда его выполнить. Оно появится в Вашем списке дел.',
      forValue: 'Для: {{label}}',
      what: 'Что я сделаю',
      when: 'Когда',
      save: 'Добавить в список дел',
      saving: 'Сохранение…',
      done: 'Добавлено в Ваш список дел',
      doneBody: 'Вы найдёте его в разделе «Домашние задания» и сможете отметить как выполненное.',
      openHomework: 'Открыть домашние задания',
      back: 'Назад',
      error: 'Не удалось сохранить. Пожалуйста, попробуйте ещё раз.',
      calendar: {
        add: 'Добавить в календарь',
        hint: 'Копия сохранится в Вашем календаре. Если Вы измените запись здесь позже, в календаре она не изменится.',
        failed: 'Не удалось открыть календарь. Пожалуйста, добавьте запись вручную.',
        eventTitle: '{{title}} — CopingCard',
        eventNotes: 'Открыть в CopingCard: {{link}}',
      },
    },
    vlq: {
      title: 'Опросник жизни по ценностям',
      body: 'Десять сфер жизни. Оцените каждую: насколько она важна для Вас и насколько последовательно Вы следовали ей на прошедшей неделе — от 1 (минимум) до 10 (максимум).',
      important: 'Насколько это важно для меня?',
      lived: 'Насколько последовательно я следовал этому на прошедшей неделе?',
      submit: 'Посмотреть результат',
      submitting: 'Сохранение…',
      notComplete: 'Оцените все десять сфер по обоим вопросам, чтобы продолжить.',
      error: 'Не удалось сохранить Ваши ответы. Пожалуйста, попробуйте ещё раз.',
      areas: {
        family: 'Семья (кроме брака и воспитания детей)',
        marriage: 'Брак, романтические и близкие отношения',
        parenting: 'Воспитание детей',
        friends: 'Друзья и социальная жизнь',
        work: 'Работа',
        education: 'Образование и обучение',
        recreation: 'Отдых и развлечения',
        spirituality: 'Духовность',
        citizenship: 'Гражданская позиция и сообщество',
        selfCare: 'Забота о физическом здоровье',
      },
      result: {
        title: 'Ваш результат',
        composite: 'Ваш балл: {{composite}} из 100',
        compositeBody: 'Балл рассчитывается умножением важности каждой сферы на то, насколько последовательно Вы ей следовали. Чем выше балл, тем ближе Ваша жизнь к тому, что для Вас действительно важно.',
        change: 'С прошлого раза: {{change}}',
        first: 'Это Ваш первый опросник. Пройдите его снова позже, чтобы отследить изменения.',
        gapHeading: 'Сначала сферы с наибольшим разрывом',
        line: 'Важность {{importance}} · следование {{consistency}} · разрыв {{gap}}',
        plan: 'Запланировать действие',
        loadError: 'Не удалось загрузить результат. Проверьте подключение и попробуйте ещё раз.',
      },
    },
    activities: {
      title: 'Действия для «{{value}}»',
      body: 'Небольшие конкретные действия, которые можно совершить ради этой ценности: от самых лёгких до самых сложных.',
      empty: 'Действий пока нет. Добавьте действие ниже или запросите идеи.',
      difficulty: 'Сложность {{n}}',
      status: {
        idea: 'идея',
        committed: 'запланировано',
        done: 'выполнено',
      },
      doThisWeek: 'Сделать на этой неделе',
      add: {
        heading: 'Добавить действие',
        title: 'Действие',
        difficulty: 'Насколько это сложно? 1 — самое лёгкое, 10 — самое трудное.',
        save: 'Добавить',
        saving: 'Добавление…',
        error: 'Не удалось добавить. Пожалуйста, попробуйте ещё раз.',
      },
      suggest: {
        heading: 'Идеи',
        body: 'Опишите ценность своими словами и получите список идей: сначала самые лёгкие. Вы сами выбираете, какие оставить.',
        text: 'Что мне хотелось бы сделать',
        button: 'Предложить идеи',
        asking: 'Думаем…',
        adopt: 'Оставить',
        none: 'Сейчас новых идей нет.',
        refused: {
          RATE_LIMITED: 'Сервис подбора идей сейчас перегружен. Пожалуйста, попробуйте ещё раз через несколько минут.',
          CONTENT_FILTERED: 'Не удалось подобрать идеи по этому описанию. Попробуйте описать немного иначе.',
          ERROR: 'Не удалось получить идеи. Пожалуйста, попробуйте ещё раз.',
        },
        error: 'Не удалось запросить идеи. Пожалуйста, попробуйте ещё раз.',
      },
      loadError: 'Не удалось загрузить действия. Проверьте подключение и попробуйте ещё раз.',
    },
    link: {
      chip: 'Связано с ценностью',
      none: 'Не связано с ценностью',
      add: 'Связать с ценностью',
      hintSort: 'Сначала разложите карточки, чтобы появились ценности, с которыми можно связать запись.',
      remove: 'Удалить связь',
      error: 'Не удалось изменить связь. Пожалуйста, попробуйте ещё раз.',
    },
    hub: {
      tab: 'Ценности',
      title: 'Ценности',
      purpose: 'Что важно для клиента: выбранные им ценности, колесо и роза ветров — его собственные ответы, без автоматических оценок.',
      empty: 'Работы с ценностями пока нет. Клиент раскладывает карточки ценностей и настраивает колесо на своём телефоне.',
      emptyAssign: 'Задать сортировку карточек',
      loadError: 'Не удалось загрузить ценности этого клиента. Обновите страницу, чтобы попробовать снова.',
      profile: {
        title: 'Профиль ценностей',
        colValue: 'Ценность',
        colWheel: 'На колесе',
        colVlq: 'Опросник',
        colSteps: 'Шаги',
        wheelCell: '{{sector}}: {{current}} → {{ideal}} (разрыв {{gap}})',
        vlqCell: '{{area}}: важность {{importance}}, следование {{consistency}} (разрыв {{gap}})',
        roseCell: 'Роза ветров: {{name}} · среднее {{mean}}',
        empty: 'Ценностей пока нет. Клиент раскладывает карточки на телефоне, и выбранные им ценности появляются здесь.',
        lastSort: 'Последняя сортировка: {{date}}',
        composite: 'Балл по опроснику: {{composite}} из 100',
        actionOpen: 'к выполнению',
        actionDone: 'выполнено',
        activitiesCount_one: 'Действий: {{count}}',
        activitiesCount_few: 'Действий: {{count}}',
        activitiesCount_many: 'Действий: {{count}}',
        activitiesCount_other: 'Действий: {{count}}',
        linksCount: 'Связанных записей: {{count}}',
      },
      wheel: {
        title: 'Колесо ценностей',
        empty: 'Клиент пока не настроил колесо. Сначала он создаёт его на телефоне, после чего Вы сможете оценить его вместе здесь.',
        sector: 'Сфера',
        statement: 'Что здесь важно',
        now: 'Сейчас',
        ideal: 'Желаемое',
        gap: 'Разрыв (желаемое − сейчас)',
        steps: 'Шаги и препятствия',
        ratedAt: 'Последняя оценка: {{date}}',
        ratedInSession: 'Оценка на сессии: {{name}} · {{date}}',
        ratedInSessionNoName: 'Оценка на сессии: {{date}}',
        notRated: 'Пока без оценки',
        obstacle: '{{obstacle}} (мешает: {{severity}} из 7)',
        rate: {
          open: 'Оценить колесо вместе с клиентом',
          title: 'Оценить колесо вместе с {{name}}',
          intro: 'Оцените колесо вместе: что важно для клиента в каждой сфере, где он сейчас и к чему стремится (от 0 до 10). За основу берётся его последняя оценка. Это Ваша совместная запись сессии — она не завершает колесо, заданное клиенту как домашнее задание.',
          statement: 'Что здесь важно',
          now: 'Сейчас (0–10)',
          ideal: 'Желаемое (0–10)',
          save: 'Сохранить оценку',
          cancel: 'Отмена',
          saved: 'Оценка сохранена. На колесе клиента она будет отображаться как оценка на сессии.',
          error: 'Не удалось сохранить оценку. Проверьте отметки и попробуйте снова.',
          notComplete: 'Поставьте обе отметки для каждой сферы, чтобы сохранить.',
        },
      },
      assign: {
        exercises: {
          valuesSort: 'Сортировка карточек ценностей',
          valuesWheel: 'Колесо ценностей',
          valuedLivingQuestionnaire: 'Опросник жизни по ценностям',
          windRose: 'Роза ветров',
        },
        defaultTitle: {
          valuesSort: 'Сортировать карточки ценностей',
          valuesWheel: 'Оценить колесо ценностей',
          valuedLivingQuestionnaire: 'Заполнить опросник жизни по ценностям',
          windRose: 'Опишите привычную стратегию поведения и оцените её по восьми потребностям',
        },
      },
    },
    errors: {
      DECK_TOO_SMALL: 'В колоде должно быть не менее 10 карточек. Добавьте карточки и опубликуйте снова.',
      DECK_PRESET_UNKNOWN_CARD: 'В наборе указана карточка, которой нет в колоде. Удалите её из набора или добавьте карточку в колоду, затем опубликуйте снова.',
      DECK_TRANSLATION_MISSING: 'Для каждой карточки нужен текст на каждом языке колоды. Заполните недостающие строки и опубликуйте снова.',
      DECK_UNKNOWN: 'Эта сортировка карточек сейчас недоступна. Вернитесь назад и начните её снова; если ошибка повторяется, обновите приложение.',
      SORT_NOT_OPEN: 'Эта сортировка уже завершена или не найдена. Вернитесь назад и начните новую.',
      SORT_RANK_NOT_IN_PILE: 'Расставлять по приоритету можно только карточки из стопки «Очень важно». Вернитесь назад и выберите одну из них.',
      SORT_RANK_COUNT: 'Расставьте по приоритету от 3 до 10 карточек из категории самых важных, затем сохраните.',
      SORT_CARD_UNSORTED: 'Некоторые карточки ещё не разложены. Вернитесь назад, распределите все карточки по стопкам и сохраните.',
      WHEEL_SECTOR_COUNT: 'В колесе должно быть от 2 до 12 сфер. Добавьте или удалите сферы и попробуйте снова.',
      WHEEL_SECTOR_DUPLICATE: 'У двух сфер одинаковые названия. Дайте каждой сфере своё название и попробуйте снова.',
      WHEEL_SECTOR_UNRATED: 'В каждой сфере нужны обе оценки. Оцените пропущенные сферы и сохраните.',
      WHEEL_MARK_RANGE: 'Оценка должна быть от 0 до 10. Исправьте оценку, которая выходит за эти рамки, и сохраните.',
      WHEEL_UNKNOWN: 'Это колесо не найдено. Вернитесь назад и откройте своё колесо снова или создайте новое.',
      WHEEL_SECTOR_UNKNOWN: 'Этой сферы нет на Вашем колесе. Вернитесь назад и выберите одну из сфер на экране.',
      WHEEL_SEVERITY_RANGE: 'Оцените препятствие от 1 (совсем не мешает) до 7 (полностью останавливает), затем сохраните.',
      VALUES_ACTION_EMPTY: 'Запишите, что Вы сделаете, затем сохраните.',
      VLQ_INCOMPLETE: 'Оцените все десять сфер от 1 до 10 по обоим вопросам, затем отправьте.',
      VALUES_ACTIVITY_EMPTY: 'Укажите действие (или ценность, для которой нужны идеи) и попробуйте снова.',
      VALUES_DIFFICULTY_RANGE: 'Сложность оценивается от 1 (самое лёгкое) до 10 (самое трудное). Выберите число в этом диапазоне.',
      VALUES_SUGGEST_COUNT: 'За один раз можно запросить от 5 до 30 идей.',
      VALUES_LINK_EXISTS: 'Это уже связано с этой ценностью.',
      VALUES_LINK_FOCUS_TYPE: 'Такую запись пока нельзя связать с ценностью.',
      VALUES_LINK_UNKNOWN: 'Эта связь уже удалена. Обновите экран, чтобы увидеть актуальный список.',
      ROSE_NAME_EMPTY: 'Дайте название этой стратегии поведения, затем сохраните.',
      ROSE_BEHAVIOR_REQUIRED: 'Для другой стратегии нужно хотя бы одно конкретное действие. Опишите его, затем сохраните.',
      ROSE_STRATEGY_UNKNOWN: 'Не удалось найти эту стратегию поведения. Вернитесь к своей розе ветров и откройте её снова.',
      ROSE_NEED_MISSING: 'Оцените все восемь потребностей от 1 до 10, затем сохраните.',
      ROSE_SCORE_RANGE: 'Баллы должны быть от 1 до 10. Исправьте значение вне этого диапазона, затем сохраните.',
      ROSE_NOT_RATED: 'Сначала оцените эту стратегию по восьми потребностям, затем выберите её.',
      ROSE_STRATEGY_NOT_CHOSEN: 'Сначала выберите эту стратегию, затем составьте для неё план.',
      ROSE_PLAN_EMPTY: 'Добавьте хотя бы один шаг в план, затем сохраните.',
      HOMEWORK_NOT_YOUR_CLIENT: 'Этот клиент не подключён к Вам в практике: он не числится Вашим клиентом здесь или выключил обмен данными с Вами. Проверьте список клиентов или попросите клиента снова включить обмен данными с Вами в приложении.',
      conflictRetry: 'Данные изменились в этот же момент. Пожалуйста, попробуйте ещё раз.',
    },
    deck: {
      miller: {
        acceptance: 'ПРИНЯТИЕ — быть принятым таким, какой я есть',
        accuracy: 'ТОЧНОСТЬ — быть точным в своих мнениях и убеждениях',
        achievement: 'ДОСТИЖЕНИЯ — добиваться значимых результатов',
        adventure: 'ПРИКЛЮЧЕНИЯ — получать новый и захватывающий опыт',
        attractiveness: 'ПРИВЛЕКАТЕЛЬНОСТЬ — быть физически привлекательным',
        authority: 'АВТОРИТЕТ — руководить другими и отвечать за них',
        autonomy: 'АВТОНОМИЯ — быть самостоятельным и независимым',
        beauty: 'КРАСОТА — ценить красоту вокруг себя',
        caring: 'ЗАБОТА — поддерживать тех, кто рядом, и помогать им',
        challenge: 'ВЫЗОВ — браться за сложные задачи и проблемы',
        change: 'ПЕРЕМЕНЫ — вести жизнь, полную новизны и разнообразия',
        comfort: 'КОМФОРТ — жить приятно и удобно',
        commitment: 'ПРЕДАННОСТЬ — связывать себя прочными и значимыми обязательствами',
        compassion: 'СОСТРАДАНИЕ — сопереживать людям и откликаться на их нужды',
        contribution: 'ВКЛАД — оставить заметный след в мире',
        cooperation: 'СОТРУДНИЧЕСТВО — слаженно работать вместе с другими',
        courtesy: 'ВЕЖЛИВОСТЬ — быть тактичным и предупредительным с окружающими',
        creativity: 'ТВОРЧЕСТВО — находить новые и оригинальные идеи',
        dependability: 'НАДЁЖНОСТЬ — быть человеком, на которого можно положиться',
        duty: 'ДОЛГ — выполнять свои обязанности и обещания',
        ecology: 'ЭКОЛОГИЯ — жить в гармонии с окружающей средой',
        excitement: 'ОСТРЫЕ ОЩУЩЕНИЯ — вести жизнь, полную драйва и сильных впечатлений',
        faithfulness: 'ВЕРНОСТЬ — быть преданным и искренним в отношениях',
        fame: 'ИЗВЕСТНОСТЬ — быть узнаваемым и получать признание',
        family: 'СЕМЬЯ — иметь счастливую и любящую семью',
        fitness: 'ФИЗИЧЕСКАЯ ФОРМА — быть сильным и поддерживать тело в тонусе',
        flexibility: 'ГИБКОСТЬ — легко приспосабливаться к новым обстоятельствам',
        forgiveness: 'ПРОЩЕНИЕ — уметь прощать других',
        friendship: 'ДРУЖБА — иметь близких друзей, готовых поддержать',
        fun: 'ВЕСЕЛЬЕ — радоваться жизни и развлекаться',
        generosity: 'ЩЕДРОСТЬ — делиться с другими тем, что у меня есть',
        genuineness: 'ПОДЛИННОСТЬ — быть собой и поступать в согласии со своей природой',
        godsWill: 'БОЖЬЯ ВОЛЯ — стремиться познать волю Бога и следовать ей',
        growth: 'РАЗВИТИЕ — постоянно меняться и расти над собой',
        health: 'ЗДОРОВЬЕ — быть физически крепким и полным сил',
        helpfulness: 'ОТЗЫВЧИВОСТЬ — приходить на помощь другим и быть полезным',
        honesty: 'ЧЕСТНОСТЬ — быть искренним и говорить правду',
        hope: 'НАДЕЖДА — сохранять позитивный и оптимистичный настрой',
        humility: 'СКРОМНОСТЬ — оставаться простым и непритязательным',
        humor: 'ЮМОР — видеть забавные стороны в себе и окружающем мире',
        independence: 'НЕЗАВИСИМОСТЬ — не зависеть от других людей',
        industry: 'ТРУДОЛЮБИЕ — усердно и качественно справляться со своими делами',
        innerPeace: 'ДУШЕВНЫЙ ПОКОЙ — чувствовать внутреннее умиротворение и спокойствие',
        intimacy: 'БЛИЗОСТЬ — делиться с другими самыми сокровенными переживаниями',
        justice: 'СПРАВЕДЛИВОСТЬ — отстаивать честное и равное отношение ко всем',
        knowledge: 'ЗНАНИЯ — учиться новому и вносить вклад в ценные знания',
        leisure: 'ОТДЫХ — находить время для расслабления и удовольствия',
        loved: 'БЫТЬ ЛЮБИМЫМ — чувствовать любовь близких людей',
        loving: 'ЛЮБИТЬ — дарить любовь окружающим',
        mastery: 'МАСТЕРСТВО — умело справляться со своими повседневными задачами',
        mindfulness: 'ОСОЗНАННОСТЬ — проживать настоящий момент внимательно и чутко',
        moderation: 'УМЕРЕННОСТЬ — избегать крайностей и держаться золотой середины',
        monogamy: 'МОНОГАМИЯ — быть в одних близких, любящих отношениях',
        nonConformity: 'НОНКОНФОРМИЗМ — ставить под сомнение авторитеты и общепринятые нормы',
        nurturance: 'ЗАБОТЛИВОСТЬ — опекать других и помогать им расти',
        openness: 'ОТКРЫТОСТЬ — быть восприимчивым к новому опыту, идеям и возможностям',
        order: 'ПОРЯДОК — вести упорядоченную и организованную жизнь',
        passion: 'СТРАСТЬ — глубоко и увлечённо относиться к идеям, делам или людям',
        pleasure: 'УДОВОЛЬСТВИЕ — чувствовать себя хорошо и радоваться жизни',
        popularity: 'ПОПУЛЯРНОСТЬ — нравиться многим людям',
        power: 'ВЛАСТЬ — иметь контроль и влияние на других',
        purpose: 'ЦЕЛЬ — иметь смысл и ясные ориентиры в жизни',
        rationality: 'РАЦИОНАЛЬНОСТЬ — опираться на разум и логику',
        realism: 'РЕАЛИЗМ — смотреть на вещи трезво и поступать практично',
        responsibility: 'ОТВЕТСТВЕННОСТЬ — принимать взвешенные решения и отвечать за них',
        risk: 'РИСК — рисковать и пробовать неизведанное',
        romance: 'РОМАНТИКА — переживать яркую и волнующую любовь',
        safety: 'БЕЗОПАСНОСТЬ — быть в безопасности и чувствовать защищённость',
        selfAcceptance: 'САМОПРИНЯТИЕ — принимать себя таким, какой я есть',
        selfControl: 'САМОКОНТРОЛЬ — быть дисциплинированным в своих действиях',
        selfEsteem: 'САМОУВАЖЕНИЕ — ценить себя и быть в ладу с собой',
        selfKnowledge: 'САМОПОЗНАНИЕ — глубоко и честно понимать себя',
        service: 'СЛУЖЕНИЕ — приносить пользу и помогать людям',
        sexuality: 'СЕКСУАЛЬНОСТЬ — вести насыщенную и приносящую радость сексуальную жизнь',
        simplicity: 'ПРОСТОТА — жить просто, довольствуясь малым',
        solitude: 'УЕДИНЕНИЕ — иметь время и личное пространство наедине с собой',
        spirituality: 'ДУХОВНОСТЬ — расти и развиваться духовно',
        stability: 'СТАБИЛЬНОСТЬ — сохранять устойчивый и предсказуемый уклад жизни',
        tolerance: 'ТЕРПИМОСТЬ — принимать и уважать тех, кто отличается от меня',
        tradition: 'ТРАДИЦИИ — следовать проверенным устоям прошлого',
        virtue: 'ДОБРОДЕТЕЛЬ — вести нравственно чистую и достойную жизнь',
        wealth: 'БОГАТСТВО — иметь много денег',
        worldPeace: 'МИР ВО ВСЁМ МИРЕ — содействовать миру на Земле',
      },
    },
  },
  sleep: {
    errors: {
      SLEEP_TIMES_ORDER: 'Время указано не по порядку. Проверьте последовательность: сначала Вы легли в постель, затем погасили свет, проснулись и встали с постели.',
      SLEEP_NIGHT_FUTURE: 'Эта ночь ещё не закончилась. Заполните запись утром.',
      SLEEP_NIGHT_TOO_OLD: 'Ночь можно добавить максимум за три предыдущих дня: запись спустя несколько дней — это воспоминания, а не дневник. Ваш терапевт может внести более раннюю ночь из Вашего бумажного дневника.',
      SLEEP_NIGHT_KIND_INVALID: 'Для этой ночи указано не всё время. Заполните все поля со временем или выберите «Я совсем не спал(а)» либо «Я спал(а) не в своей обычной постели».',
      SLEEP_DURATIONS_EXCEED: 'Время засыпания и ночных пробуждений в сумме превышает отрезок между выключением света и окончательным подъёмом. Проверьте эти два значения.',
      SLEEP_WINDOW_TOO_SHORT: 'Окно сна не может быть короче 5 часов (6 часов по протоколу BBTI). Сдвиньте время отхода ко сну на более раннее или время подъёма на более позднее.',
      SLEEP_WINDOW_ORDER: 'Время подъёма должно идти после времени отхода ко сну. Проверьте оба значения — например, 23:30 и 06:00.',
      SLEEP_WINDOW_NOT_YOUR_CLIENT: 'Этот клиент находится не под Вашим наблюдением, поэтому Вы не можете менять его дневник сна или окно сна. Обновите список клиентов и попробуйте ещё раз.',
      SLEEP_WINDOW_NONE: 'У этого клиента нет окна сна, которое можно было бы завершить. Обновите страницу, чтобы увидеть текущее состояние.',
      conflictRetry: 'Дневник сна изменился в этот же момент. Пожалуйста, попробуйте ещё раз.',
      loadFailed: 'Не удалось загрузить дневник сна. Потяните вниз, чтобы попробовать ещё раз.',
      saveFailed: 'Не удалось сохранить эту ночь. Проверьте подключение и попробуйте ещё раз.',
    },
    units: {
      hoursMinutes: '{{hours}} ч {{minutes}} мин',
      minutes: '{{count}} мин',
      percent: '{{count}}%',
    },
    entry: {
      title: 'Дневник сна',
      body: 'Прошедшая ночь за две минуты и общая картина по неделям.',
    },
    screens: {
      morning: 'Дневник сна',
      diary: 'Прошедшая ночь',
      week: 'Мои недели',
      window: 'Моё окно сна',
    },
    morning: {
      title: 'Доброе утро',
      subtitle: 'Запишите, как прошла ночь. Это займёт около двух минут.',
      fromWatch: 'Данные с часов',
      watchLine: 'В постели {{from}}–{{to}} · сон около {{duration}}',
      emptyNight: 'Ещё не заполнено',
      fill: 'Заполнить',
      caughtUp: 'Всё заполнено. Прошедшая ночь уже в дневнике.',
      olderNote: 'Можно добавить ночь за последние три дня.',
      weeks: 'Мои недели',
      window: 'Моё окно сна',
    },
    prompt: {
      title: 'Утреннее напоминание',
      body: 'Напоминание каждое утро, чтобы записать данные о сне по свежей памяти.',
      on: 'Включено — каждое утро в {{time}}',
      off: 'Выключено',
      turnOn: 'Включить',
      turnOff: 'Выключить',
      notificationTitle: 'Сон прошлой ночью',
      notificationBody: 'Запишите, как Вы спали. Это займёт около двух минут.',
    },
    diary: {
      title: 'Прошедшая ночь',
      forNight: 'Ночь на {{date}}',
      watchNote: 'Время с часов подставилось автоматически. Исправьте то, что не совпадает с ощущениями.',
      timeHint: 'Время в 24-часовом формате (часы и минуты), например 23:10.',
      bedTime: 'Я лёг(ла) в постель в',
      lightsOut: 'Я погасил(а) свет в',
      sleepOnset: 'Засыпание заняло примерно столько минут',
      awakenings: 'За ночь я просыпался(лась) столько раз',
      wakeMinutes: 'Всего за ночь я не спал(а) столько минут',
      finalWake: 'Окончательно я проснулся(лась) в',
      outOfBed: 'Я встал(а) с постели в',
      quality: 'Как спалось?',
      qualityOption: {
        1: 'Очень плохо',
        2: 'Плохо',
        3: 'Так себе',
        4: 'Хорошо',
        5: 'Очень хорошо',
      },
      watchBeside: 'Часы насчитали около {{duration}} сна',
      optional: 'По желанию',
      napStart: 'Дневной сон начался в',
      napMinutes: 'Длительность дневного сна, минут',
      caffeine: 'Кофе, чай или кола после полудня',
      alcohol: 'Алкогольные напитки',
      sleepAid: 'Принятое снотворное',
      note: 'Что ещё стоит отметить об этой ночи',
      noSleep: 'Я совсем не спал(а)',
      noSleepHint: 'Нужно указать только когда Вы легли в постель и встали с неё. Эта ночь запишется как ночь без сна.',
      skip: 'Я спал(а) не в своей обычной постели — пропустить эту ночь',
      skipHint: 'Эта ночь не будет учитываться в недельных показателях.',
      kindTitle: 'Как Вы хотите записать эту ночь?',
      kindFull: 'Вся ночь целиком',
      save: 'Сохранить',
      saving: 'Сохранение…',
      timeInvalid: 'Укажите время в формате часов и минут, например 23:10.',
      numberInvalid: 'Введите целое число.',
      qualityRequired: 'Выберите, как Вы спали.',
      timesRequired:
        'Заполните все поля со временем или выберите вверху другой способ записать эту ночь.',
      error: 'Не удалось сохранить эту ночь. Проверьте подключение и попробуйте ещё раз.',
    },
    week: {
      title: 'Мои недели',
      weekOf: 'Неделя с {{date}}',
      earlier: 'Предыдущая неделя',
      later: 'Следующая неделя',
      averages: 'В среднем за неделю',
      nights: 'Заполнено ночей: {{count}}',
      noNights: 'На этой неделе пока нет заполненных ночей.',
      inBed: 'В постели',
      asleep: 'Сон',
      efficiency: 'Эффективность',
      efficiencyHelp: 'время сна ÷ время в постели; Ваш терапевт использует этот показатель в работе с Вами',
      fellAsleep: 'Засыпание за',
      awakeInNight: 'Бодрствование ночью',
      quality: 'Качество',
      watch: 'Ваши часы: {{duration}}',
      skipped: 'пропущено',
      noSleep: 'без сна',
      fromPaper: 'внесено Вашим терапевтом из бумажного дневника',
      windowLine: 'Ваше окно: {{bedtime}} – {{riseTime}}, с {{date}}',
      weeksBefore: 'Предыдущие недели',
    },
    window: {
      title: 'Моё окно сна',
      body: 'Ложитесь в постель не раньше {{bedtime}} и вставайте в {{riseTime}} каждый день.',
      from: 'С {{date}}',
      upcoming: 'Начинается {{date}}',
      setWith: 'Настроено вместе с: {{name}}',
      note: 'От Вашего терапевта',
      none: 'Ваш терапевт определит окно сна вместе с Вами, когда придёт время.',
      remindMe: 'Напоминать мне',
      remind: {
        title: 'Напоминания об окне сна',
        body: 'Два напоминания, привязанных к Вашему окну сна: когда пора готовиться ко сну и когда вставать.',
        on: 'Включено — подготовка ко сну в {{windDown}}, подъём в {{getUp}}',
        off: 'Выключено',
        turnOn: 'Включить',
        turnOff: 'Выключить',
        windDownTitle: 'Пора готовиться ко сну',
        windDownBody: 'Время отхода ко сну — через час.',
        getUpTitle: 'Пора вставать',
        getUpBody: 'Наступило время подъёма.',
        moved: 'Ваше окно сна изменилось. Включите напоминания снова, чтобы перенести их.',
      },
    },
    hub: {
      tab: 'Дневник сна',
      title: 'Дневник сна',
      intro: 'Ночи по записям Вашего клиента, а рядом — показатели часов, если клиент делится с Вами данными о сне.',
      weekOf: 'Неделя с {{date}}',
      earlier: 'Предыдущая неделя',
      later: 'Следующая неделя',
      loadFailed: 'Не удалось загрузить дневник сна. Обновите, чтобы попробовать ещё раз.',
      notShared: 'Клиент не делится этим с Вами.',
      noNights: 'На этой неделе пока нет заполненных ночей.',
      weeklyAverages: 'Средние показатели за неделю',
      nights: {
        title: 'Ночи',
      },
      empty: 'В дневнике пока нет заполненных ночей. Назначьте дневник сна, и {{name}} будет заполнять ночь каждое утро.',
      emptyAssign: 'Назначить дневник сна',
      emptyPaper: 'Внести ночь из бумажного дневника',
      nightsFilled: 'Ночей: {{count}}',
      inBed: 'В постели',
      asleep: 'Сон',
      efficiency: 'Эффективность',
      fellAsleep: 'Засыпание за',
      awakeInNight: 'Бодрствование ночью',
      quality: 'Качество',
      reported: 'По дневнику',
      watch: 'Часы',
      watchNotShared: 'нет доступа',
      skipped: 'пропущено',
      noSleep: 'без сна',
      fromPaper: 'бумажный дневник · {{name}}',
      windowEnded: 'завершено {{date}}',
      noWindow: 'Окно сна не задано.',
      usualRule: {
        forYou: 'Для Вас, не для клиента:',
        cbti: 'Эффективность {{efficiency}}% (ночей: {{nights}}) → стандартное правило: {{action}}. Решение за Вами.',
        bbti: 'Засыпание — {{fellAsleep}} мин, бодрствование ночью — {{awake}} мин (ночей: {{nights}}) → стандартное правило: {{action}}. Решение за Вами.',
        moreInBed: 'на 15 минут больше в постели',
        keep: 'сохранить окно сна',
        lessInBed: 'на 15 минут меньше в постели',
        atFloor: 'окно сна уже на минимуме — сохранить его',
        none: 'За последнюю неделю нет заполненных ночей, чтобы применить правило.',
      },
      window: {
        card: 'Окно сна',
        current: '{{bedtime}} – {{riseTime}} · с {{date}} · {{protocol}}',
        upcoming: 'начнётся позже',
        setBy: 'задано: {{name}}',
        setFirst: 'Задать окно сна',
        setNew: 'Задать новое окно сна',
        replaces: 'Заменяет {{window}}',
        earlier: 'Предыдущие окна сна ({{count}})',
        last: 'Предыдущее окно сна:',
        timesRequired: 'Укажите время отхода ко сну и время подъёма в 24-часовом формате, например 23:30.',
        dateRequired: 'Выберите дату начала окна сна.',
        title: 'Задать окно сна',
        screening: 'Перед ограничением сна проверьте, есть ли у этого клиента: биполярное расстройство, судорожные приступы, парасомнии, апноэ во сне, работа за рулём.',
        bedtime: 'Время отхода ко сну (24-часовой формат, например 23:30)',
        riseTime: 'Время подъёма (24-часовой формат, например 06:00)',
        effectiveFrom: 'Дата начала',
        protocol: 'Протокол',
        cbti: 'CBT-I — корректировка по эффективности (не менее 5 часов)',
        bbti: 'BBTI — корректировка по времени засыпания и бодрствования ночью (не менее 6 часов)',
        basis: 'На основе: ночей: {{nights}} · сон {{asleep}} · эффективность {{efficiency}}%',
        fewNights: 'В дневнике меньше пяти ночей за последние семь дней. За основу можно взять бумажный дневник.',
        note: 'Заметка для клиента',
        set: 'Задать окно сна',
        saved: 'Окно сна задано.',
        error: 'Не удалось задать окно сна. Проверьте время и попробуйте ещё раз.',
        end: {
          title: 'Завершить окно сна',
          body: 'Экран клиента вернётся к состоянию «окно сна не задано».',
          reason: 'Причина (необязательно)',
          action: 'Завершить окно сна',
          done: 'Окно сна завершено.',
          error: 'Не удалось завершить окно сна. Обновите страницу и попробуйте ещё раз.',
        },
      },
      assign: {
        defaultTitle: 'Вести дневник сна две недели',
        defaultInstructions: 'Каждое утро, прежде чем проверять что-либо ещё в телефоне.',
      },
    },
  },
  sleepDiary: {
    enter: {
      title: 'Внести ночь',
      body: 'Из бумажного дневника клиента, на сессии или после неё — до четырнадцати дней назад. В телефоне клиента отобразится как внесённое Вами.',
      night: 'Ночь на (дата)',
      bedTime: 'В постель (24-часовой формат, например 23:10)',
      lightsOut: 'Выключение света',
      sleepOnset: 'Минут до засыпания',
      awakenings: 'Пробуждения',
      wakeMinutes: 'Минут бодрствования ночью',
      finalWake: 'Окончательное пробуждение',
      outOfBed: 'Подъём с постели',
      quality: 'Качество (1 — очень плохо, 5 — очень хорошо)',
      note: 'Заметка из дневника',
      kind: 'Эта ночь',
      kindSlept: 'Полная ночь',
      kindNoSleep: 'Совсем не спал(а)',
      kindSkipped: 'Не в своей обычной постели / пропустить',
      save: 'Сохранить ночь',
      saved: 'Ночь добавлена в дневник.',
      error: 'Не удалось сохранить ночь. Проверьте время и дату и попробуйте ещё раз.',
      open: 'Внести ночь',
      timesRequired:
        'Заполните все поля со временем для полной ночи в 24-часовом формате (например, 23:10).',
      noSleepRequired: 'Укажите время, когда легли в постель и встали с постели, в 24-часовом формате.',
      minutesRequired: 'Укажите минуты целым числом.',
      qualityRequired: 'Выберите качество сна от 1 до 5.',
      nightRequired: 'Выберите ночь — до четырнадцати дней назад.',
    },
  },
  ba: {
    entry: {
      title: 'Поведенческая активация',
      body: 'Замечайте, чем Вы занимаетесь, планируйте следующий небольшой шаг и смотрите, как Вы себя чувствовали.',
    },
    screens: {
      home: 'Поведенческая активация',
      log: 'Отметить час',
      choose: 'Выбрать занятия',
      rank: 'Порядок занятий',
      ladder: 'Мой список занятий',
      plan: 'Запланировать занятие',
      agenda: 'Мой план',
      done: 'Выполнено',
      missed: 'Не состоялось',
      support: 'Попросить о поддержке',
      week: 'Эта неделя',
    },
    areas: {
      relationships: 'Отношения',
      educationCareer: 'Учёба и работа',
      recreation: 'Отдых и интересы',
      mindBodySpirit: 'Разум, тело и дух',
      dailyResponsibilities: 'Повседневные обязанности',
    },
    barrier: {
      noTime: 'Не было времени',
      tooHard: 'Слишком сложно',
      lowMood: 'Подавленное настроение',
      forgot: 'Забылось',
      otherPeople: 'Другие люди',
      other: 'Что-то другое',
    },
    home: {
      body: 'Записывайте, чем Вы занимались час за часом, отмечая удовольствие и важность каждого дела. Закономерности проявятся быстро — именно на них мы опираемся при планировании.',
      today: 'Сегодня',
      prevDay: 'Раньше',
      nextDay: 'Позже',
      empty: 'В этот день пока ничего не отмечено. Нажмите на нужный час ниже или отметьте его прямо сейчас.',
      ratings: 'Удовольствие {{enjoyment}} · Важность {{importance}}',
      fromPlan: 'запланированное занятие',
      gaps: 'Пока не отмечено',
      mood: 'Настроение из Вашей записи: {{mood}} из 5',
      log: 'Отметить час',
      removeHint: 'Нажмите и удерживайте, чтобы удалить эту запись',
      doors: 'Следующие шаги',
      doorChoose: 'Выбрать занятия',
      doorLadder: 'Мой список занятий',
      doorPlan: 'Мой план',
      doorWeek: 'Эта неделя',
    },
    suggest: {
      heading: 'Из данных о здоровье',
      body: 'Прогулки и тренировки, которые записал Ваш телефон, но которых пока нет в Ваших записях. Ничто не будет отмечено, пока Вы сами этого не сделаете.',
      line: '{{kind}} на {{minutes}} мин в {{start}} — отметить?',
      title: '{{kind}} ({{minutes}} мин)',
      log: 'Отметить',
      dismiss: 'Пропустить',
      kind: {
        walking: 'прогулка',
        running: 'пробежка',
        cycling: 'велопрогулка',
        swimming: 'плавание',
        yoga: 'йога',
        strength: 'силовая тренировка',
        hiking: 'хайкинг',
        dance: 'танцы',
        other: 'тренировка',
      },
    },
    remove: {
      body: 'Удалить эту запись? Позже Вы сможете отметить этот час снова.',
      confirm: 'Удалить',
      cancel: 'Оставить',
      error: 'Не удалось удалить запись. Обновите день и попробуйте ещё раз.',
    },
    prompts: {
      title: 'Напоминания отметить час',
      body: 'Три ненавязчивых напоминания в день: «Чем Вы занимались с…?» Меняйте время в любой момент.',
      on: 'Включено напоминаний: {{n}}.',
      off: 'Пока нет напоминаний.',
      turnOn: 'Напоминать три раза в день',
      turnOff: 'Выключить напоминания',
      notificationTitle: 'Чем Вы занимались?',
      notificationBody: 'Уделите минуту, чтобы отметить прошедшие часы.',
    },
    log: {
      body: 'Чем Вы занимались и как всё прошло? Здесь нет правильных ответов.',
      when: 'Когда',
      earlier: 'На час раньше',
      later: 'На час позже',
      longer: 'Сделать дольше',
      shorter: 'Сделать короче',
      what: 'Чем Вы занимались?',
      whatPlaceholder: 'Например: сходили в магазин',
      enjoyment: 'Удовольствие',
      enjoymentHint: 'Сколько удовольствия это принесло? 0 — совсем никакого, 10 — максимум.',
      importance: 'Важность',
      importanceHint: 'Насколько важным это было для Вас? 0 — совсем не важно, 10 — максимум.',
      faces: 'Использовать смайлики',
      numbers: 'Использовать числа',
      face: {
        0: 'Нисколько',
        2: 'Немного',
        5: 'Средне',
        8: 'Довольно много',
        10: 'Максимум',
      },
      save: 'Сохранить',
      saving: 'Сохранение…',
      saveNext: 'Сохранить и отметить предыдущий час',
      error: 'Не удалось сохранить час. Проверьте подключение и попробуйте ещё раз.',
    },
    choose: {
      body: 'Соберите занятия, которые помогут наполнить Ваши дни. Начните с того, что уже помогает, а затем посмотрите идеи того, что для Вас важно.',
      use: 'Выбрать',
      rank: 'Расставить занятия по порядку',
      week: {
        heading: 'Из Вашей недели',
        body: 'Часы за последние две недели, которые принесли удовольствие или были важны.',
        empty: 'Сначала отметьте несколько часов: те, которые Вам понравились, появятся здесь.',
      },
      ideas: {
        heading: 'Идеи под Ваши ценности',
        body: 'Сначала идут идеи для того, что важно именно Вам. Сложность каждого занятия здесь лишь приблизительная.',
        empty: 'Пока нет опубликованных идей. Добавьте свои занятия ниже.',
        difficulty: 'сложность: примерно {{n}} из 10',
        forValue: 'для: {{value}}',
        more: 'Показать ещё идеи',
        fewer: 'Показать меньше идей',
      },
      mine: {
        heading: 'Мои занятия',
        empty: 'У Вас пока нет занятий. Выберите идею выше или добавьте своё.',
        add: 'Добавить своё',
        ai: 'подобрано для Вас',
      },
    },
    adopt: {
      heading: 'Сделать моим занятием',
      what: 'Своими словами',
      value: 'Ради чего это',
      otherValue: 'Или укажите другую ценность',
      difficulty: 'Насколько сложным это кажется? 1 — самое лёгкое, 10 — самое сложное.',
      suggestAi: 'Предложить ещё с помощью ИИ',
      save: 'Добавить в мои занятия',
      saving: 'Добавление…',
      cancel: 'Отмена',
      error: 'Не удалось добавить занятие. Проверьте подключение и попробуйте ещё раз.',
    },
    rank: {
      title: 'Расставить по порядку',
      body: 'Отметьте до пятнадцати занятий и расставьте их по порядку: самое простое наверху. Начните с простого и двигайтесь к более сложному.',
      count: 'Выбрано: {{n}} из {{max}}',
      order: 'Ваш порядок',
      orderHint: 'Сначала самое простое. Перемещайте занятия стрелками.',
      up: 'Переместить вверх',
      down: 'Переместить вниз',
      save: 'Сохранить список занятий',
      saving: 'Сохранение…',
      error:
        'Не удалось сохранить список занятий. Проверьте подключение и попробуйте ещё раз.',
    },
    ladder: {
      body: 'Ваши занятия от самого сложного наверху до самого простого внизу. Начинайте снизу.',
      empty:
        'Списка занятий пока нет. Выберите занятия и расставьте их по порядку.',
      plan: 'Запланировать',
      support: 'Попросить о поддержке',
      rerank: 'Изменить список занятий',
    },
    plan: {
      againTitle: 'Запланировать снова',
      body: 'Выберите день и время. От одного до трёх самых простых шагов в день вполне достаточно.',
      againBarrier: 'В прошлый раз: {{barrier}}. Это полезно знать — можно уменьшить шаг или перенести его на другое время.',
      what: 'Что Вы сделаете?',
      whatPlaceholder: 'Например: двадцатиминутная прогулка',
      day: 'День',
      today: 'Сегодня',
      tomorrow: 'Завтра',
      time: 'Время',
      duration: 'Сколько по времени',
      minutes: '{{n}} мин',
      predict: 'Как, по Вашим ожиданиям, всё пройдёт?',
      certainty: 'Насколько Вы уверены, что сделаете это?',
      certaintyHint: 'Необязательно. 1 — совсем не уверены, 10 — абсолютно уверены.',
      certaintyLow: 'Если меньше {{n}}, может помочь уменьшить шаг или позвать кого-то на помощь. Совершенно необязательно.',
      smaller: 'Уменьшить шаг',
      help: 'Попросить о помощи',
      save: 'Запланировать',
      saving: 'Планирование…',
      saved: 'Запланировано',
      savedBody: 'Занятие появилось в списке «Домашние задания», и в назначенное время Вам придёт напоминание.',
      free: {
        heading: 'Найти свободное время',
        body: 'CopingCard проверяет, когда в календаре есть свободное время, — только на Вашем телефоне. Ничего из календаря никуда не отправляется и не сохраняется.',
        ask: 'Предложить свободное время',
        checking: 'Проверяем календарь…',
        slot: '{{day}} в {{time}}',
        pick: 'Нажмите на нужный вариант или выберите время сами ниже.',
        none: 'На ближайшие семь дней свободного часа не нашлось. Выберите время сами ниже.',
        denied: 'Доступ к календарю выключен, поэтому предложений нет. Чтобы получать их, разрешите CopingCard доступ к календарю в настройках телефона. Вы всегда можете выбрать время сами.',
        unavailable: 'Этот телефон не может предложить свободное время. Выберите время сами ниже.',
        error: 'Сейчас не удалось прочитать календарь. Выберите время сами ниже.',
      },
      toAgenda: 'Посмотреть мой план',
      error: 'Не удалось сохранить план. Проверьте подключение и попробуйте ещё раз.',
      calendar: {
        add: 'Добавить в календарь',
        hint: 'В календарь добавится копия. Если Вы измените план позже, обновите его и в календаре.',
        failed: 'Не удалось открыть календарь. Вы можете добавить событие вручную.',
        eventTitle: '{{title}}',
        eventNotes: 'Запланировано в CopingCard. {{link}}',
      },
    },
    agenda: {
      prev: 'Раньше',
      next: 'Позже',
      weekOf: 'Неделя с {{date}}',
      counts: 'Запланировано: {{planned}} · Выполнено: {{done}} на этой неделе',
      empty: 'На этой неделе пока ничего не запланировано.',
      plan: 'Запланировать занятие',
      done: 'Выполнено',
      missed: 'Не состоялось',
      again: 'Запланировать снова',
      rated: 'Удовольствие {{enjoyment}} · Важность {{importance}}',
      status: {
        planned: 'Запланировано',
        done: 'Выполнено',
        missed: 'Не состоялось',
        replanned: 'Запланировано снова',
      },
    },
    done: {
      title: 'Как всё прошло?',
      body: 'Оцените занятие теперь, когда оно позади. Всё прошло так, как Вы ожидали?',
      predicted: 'Вы ожидали: Удовольствие {{enjoyment}} · Важность {{importance}}',
      note: 'Что Вы заметили (необязательно)',
      save: 'Сохранить',
      saving: 'Сохранение…',
      saved: 'Сохранено. Занятие отмечено в списке «Домашние задания».',
      better: 'Сохранено. Всё прошло лучше, чем Вы ожидали.',
      close: 'Назад',
      notHappened: 'Не состоялось',
      error: 'Не удалось сохранить. Проверьте подключение и попробуйте ещё раз.',
    },
    missed: {
      body: 'Это полезно знать, а не неудача. Что помешало?',
      barrier: 'Что помешало',
      note: 'Что-то ещё (необязательно)',
      save: 'Сохранить',
      saving: 'Сохранение…',
      saved: 'Сохранено. Вы можете запланировать его снова: уменьшить шаг или выбрать другое время.',
      error: 'Не удалось сохранить. Проверьте подключение и попробуйте ещё раз.',
    },
    support: {
      body: 'До трёх человек и то, чем именно каждый мог бы помочь. А когда к ним обратиться — решите Вы сами.',
      privacy: 'CopingCard ничего не отправляет этим людям. Кнопки сообщения и звонка открывают Ваши обычные сообщения и телефон.',
      name: 'Имя',
      how: 'Чем он мог бы помочь?',
      pick: 'Выбрать из контактов',
      pickDenied: 'Телефон не дал доступ к контактам. Вы можете ввести имя вручную.',
      message: 'Написать: {{name}}',
      call: 'Позвонить: {{name}}',
      draft: 'Привет, {{name}}! Можешь помочь мне с этим: {{what}}? {{how}}',
      add: 'Добавить ещё человека',
      save: 'Сохранить',
      saving: 'Сохранение…',
      saved: 'Сохранено',
      error: 'Не удалось сохранить договор. Проверьте подключение и попробуйте ещё раз.',
    },
    week: {
      plans: 'Планы',
      planned: 'Запланировано: {{n}}',
      done: 'Выполнено: {{n}}',
      missed: 'Не состоялось: {{n}}',
      barrier: 'Чаще всего мешало: {{barrier}}',
      predicted: 'Ожидание и реальность',
      predictedHint: 'Для планов, которые Вы выполнили. Часто всё оказывается лучше, чем Вы ожидали.',
      enjoyment: 'Удовольствие: ожидание {{predicted}}, реальность {{actual}}',
      importance: 'Важность: ожидание {{predicted}}, реальность {{actual}}',
      areas: 'Часы по сферам жизни',
      hours: '{{n}} h',
      emptyAreas: 'Пока нет часов в: {{areas}}',
      mood: 'Настроение и занятия',
      noMood: 'нет записи настроения',
      activitiesDone: 'выполнено: {{n}}',
      health: 'С Вашего телефона',
      healthLine: 'Активных дней: {{days}} · активных минут: {{minutes}} · прогулок: {{walks}}',
      planNext: 'Запланировать следующую неделю',
    },
    homework: {
      planned: 'Это запланированное занятие. Оцените его, когда выполните, или укажите, что помешало.',
    },
    errors: {
      LIBRARY_TOO_SMALL: 'В библиотеке должно быть не менее 20 идей, чтобы её можно было опубликовать.',
      LIBRARY_TRANSLATION_MISSING: 'У каждой идеи должны быть строки на английском и русском языках. Добавьте недостающую и опубликуйте снова.',
      LIBRARY_DIFFICULTY_RANGE: 'Для каждой идеи укажите сложность от 1 (самая лёгкая) до 10 (самая сложная).',
      LIBRARY_AREA_UNKNOWN: 'Каждая идея относится к одной из пяти сфер жизни. Выберите сферу из списка.',
      BA_RATING_RANGE: 'Оценки выставляются от 0 до 10, а уверенность — от 1 до 10. Выберите число из этого диапазона.',
      BA_TIME_RANGE: 'Время окончания часа должно быть позже времени его начала. Измените время и попробуйте ещё раз.',
      BA_LOG_IN_FUTURE: 'Этот час ещё не наступил. Отмечайте только те часы, которые уже прошли.',
      BA_LOG_EMPTY: 'Напишите в нескольких словах, чем Вы занимались в этот час.',
      BA_LOG_UNKNOWN: 'Эта запись уже удалена. Обновите день, чтобы увидеть актуальный список.',
      BA_RANKING_TOO_LONG:
        'В списке может быть не более 15 занятий. Снимите отметку с нескольких и сохраните снова.',
      BA_RANKING_EMPTY:
        'Отметьте хотя бы одно занятие, чтобы добавить его в Ваш список.',
      BA_RANK_DUPLICATE:
        'Каждое занятие может быть в списке только один раз, на своём месте. Проверьте порядок и сохраните снова.',
      BA_ACTIVITY_UNKNOWN: 'Этого занятия больше нет в Вашем списке. Выберите занятие из раздела «Мои занятия».',
      BA_PLAN_IN_PAST: 'Это время уже прошло. Выберите время позже текущего.',
      BA_REPLAN_NOT_MISSED: 'Запланировать заново можно только то, что отмечено как несостоявшееся.',
      BA_PLAN_EMPTY: 'Напишите в нескольких словах, что Вы планируете сделать.',
      BA_PLAN_UNKNOWN: 'Этого плана больше нет. Откройте «Мой план», чтобы увидеть актуальный список.',
      BA_PLAN_CLOSED: 'Этот план уже отмечен как выполненный или несостоявшийся. Вы можете запланировать его снова из раздела «Мой план».',
      BA_PLAN_NOT_YET: 'Этот план назначен на другой день. Вернитесь к нему, когда наступит этот день.',
      BA_BARRIER_UNKNOWN: 'Выберите одну из причин в списке.',
      BA_CONTRACT_EMPTY: 'Добавьте хотя бы одного человека и укажите, чем он мог бы помочь.',
      BA_CONTRACT_TOO_MANY: 'В договоре может быть не более трёх человек. Удалите одного и сохраните снова.',
      HOMEWORK_NOT_YOUR_CLIENT: 'Этот клиент не связан с Вами в Вашей практике: он не числится Вашим клиентом здесь или отключил обмен данными с Вами. Проверьте список клиентов или попросите клиента снова включить обмен данными с Вами в приложении.',
      conflictRetry: 'Данные изменились одновременно с этим действием. Пожалуйста, попробуйте ещё раз.',
    },
    hub: {
      tab: 'Поведенческая активация',
      title: 'Поведенческая активация',
      purpose: 'Неделя клиента: что запланировано и сделано, ожидаемые и реальные удовольствие и важность, настроение рядом с занятиями. Только цифры.',
      loadError: 'Не удалось загрузить данные активации. Обновите страницу; если ошибка повторяется, проверьте, делится ли клиент данными с Вами.',
      ratings: 'Удовольствие {{enjoyment}} · Важность {{importance}}',
      week: {
        title: 'Эта неделя',
        counts: 'Запланировано {{planned}} · выполнено {{done}} · не состоялось {{missed}}',
        nothing: 'На этой неделе пока ничего не отмечено.',
        noAreas: 'На этой неделе пока нет часов с указанным занятием.',
        day: 'День',
        activities: 'Выполненные занятия',
        phone: 'Телефон: активные минуты',
      },
      plans: {
        title: 'Планы',
        empty: 'На этой неделе ничего не запланировано.',
        when: 'Когда',
        what: 'Что',
        expected: 'Ожидание',
        actual: 'Реальность',
        status: 'Статус',
        inSession: 'запланировано вместе',
      },
      grid: {
        title: 'Сетка мониторинга',
        empty: 'На этой неделе пока нет отмеченных часов.',
        area: 'Сфера жизни',
      },
      ladder: {
        title: 'Список занятий',
        empty: 'Клиент пока не расставил занятия по порядку.',
      },
      plan: {
        title: 'Запланировать занятие вместе с клиентом',
        open: 'Запланировать занятие',
        required: 'Укажите само занятие, день и время, а также обе ожидаемые оценки (от 0 до 10).',
        ladder: 'Из списка занятий',
        durationLabel: 'Длительность в минутах (5–240)',
        intro: 'Запланируйте следующий небольшой шаг вместе. Он появится в телефоне клиента и в его списке «Домашние задания».',
        when: 'День и время',
        expectedEnjoyment: 'Ожидаемое удовольствие (0–10)',
        expectedImportance: 'Ожидаемая важность (0–10)',
        submit: 'Запланировать',
        saved: 'Запланировано. Появилось в телефоне клиента и в его списке «Домашние задания».',
        error: 'Не удалось сохранить план. Проверьте данные и попробуйте ещё раз.',
      },
      assign: {
        defaultTitle: {
          activityMonitoring: 'Отмечать свои дни',
          activityRanking: 'Выбрать и расставить свои занятия по порядку',
          activityPlanning: 'Запланировать первое занятие',
          supportContract: 'Попросить кого-то помочь со сложным шагом',
        },
      },
    },
    library: {
      ideas: {
        'idea-0001': 'Отправьте другу короткое сообщение просто чтобы поздороваться',
        'idea-0002': 'Скажите близкому человеку, за что именно Вы его цените',
        'idea-0003': 'Посмотрите старые фотографии вместе с кем-то из семьи',
        'idea-0004': 'Позвоните другу на десять минут',
        'idea-0005': 'Позвоните родственнику, с которым давно не общались',
        'idea-0006': 'Напишите короткую благодарность тому, кто Вам помог',
        'idea-0007': 'Выпейте чаю с партнёром, отложив телефоны в сторону',
        'idea-0008': 'Спросите кого-нибудь, как прошёл день, и выслушайте ответ до конца',
        'idea-0009': 'Ответьте на сообщение, которое давно откладывали',
        'idea-0010': 'Позовите друга на прогулку',
        'idea-0011': 'Приготовьте простое блюдо для близкого человека',
        'idea-0012': 'Предложите соседу небольшую помощь',
        'idea-0013': 'Сыграйте в игру с ребёнком или младшим родственником',
        'idea-0014': 'Выпейте кофе с коллегой, не говоря о работе',
        'idea-0015': 'Устройте тихий домашний вечер вдвоём',
        'idea-0016': 'Запишите то, что хочется сказать человеку, а потом решите, отправлять ли это',
        'idea-0017': 'Сходите с другом поесть в место, где ни один из Вас ещё не был',
        'idea-0018': 'Навестите кого-то из родных во второй половине дня',
        'idea-0019': 'Расскажите человеку, которому доверяете, как Вы на самом деле себя чувствуете',
        'idea-0020': 'Посвятите час тому, чтобы помочь другу с делом, в котором он застрял',
        'idea-0021': 'Напишите тому, с кем давно потеряли связь',
        'idea-0022': 'Организуйте небольшую встречу для семьи или друзей',
        'idea-0023': 'Обсудите с партнёром или близким другом то, о чём давно думаете',
        'idea-0024': 'Найдите группу по интересам и сходите на одну встречу',
        'idea-0025': 'Сделайте первый шаг навстречу человеку после размолвки',
        'idea-0026': 'Примите приглашение, от которого обычно бы отказались',
        'idea-0027': 'Заговорите с незнакомым человеком на занятиях, в клубе или в очереди',
        'idea-0028': 'Проведите целый день вместе с семьёй за общим делом',
        'idea-0029': 'Прямо попросите близкого человека о поддержке, которая Вам нужна',
        'idea-0030': 'Пригласите к себе нескольких друзей на вечер',
        'idea-0031': 'Прочитайте одну страницу из книги или текста, который ещё не открывали',
        'idea-0032': 'Запишите три вещи, которым Вам хотелось бы научиться',
        'idea-0033': 'Уделите десять минут порядку на рабочем или учебном месте',
        'idea-0034': 'Посмотрите короткую лекцию или урок на интересную Вам тему',
        'idea-0035': 'Откройте задачу, которую откладывали, и позанимайтесь ей пять минут',
        'idea-0036': 'Составьте короткий список дел, которые хотите завершить на этой неделе',
        'idea-0037': 'Потренируйте какой-нибудь навык в течение пятнадцати минут',
        'idea-0038': 'Послушайте подкаст по своей специальности или на новую тему',
        'idea-0039': 'Ответьте на одно письмо, которое давно откладывали',
        'idea-0040': 'Найдите курс или занятие, которое могло бы Вам понравиться',
        'idea-0041': 'С вечера составьте план трёх главных задач на завтра',
        'idea-0042': 'Разберите одно упражнение или задачу из книги либо курса',
        'idea-0043': 'Задайте коллеге или сокурснику вопрос, который давно не решались задать',
        'idea-0044': 'Напишите страницу размышлений об идее, которую хочется исследовать',
        'idea-0045': 'Сходите в библиотеку, музей или на лекцию по теме, которая Вам интересна',
        'idea-0046': 'Завершите небольшое начатое дело, которое когда-то бросили',
        'idea-0047': 'Добавьте в резюме или профиль то, чем Вы по-настоящему гордитесь',
        'idea-0048': 'Отключите уведомления и уделите час важному для Вас проекту',
        'idea-0049': 'Предложите коллеге или сокурснику помощь с его задачей',
        'idea-0050': 'Запишитесь на мастер-класс, воркшоп или онлайн-курс',
        'idea-0051': 'Поставьте одну конкретную цель на следующий месяц и запишите первый шаг',
        'idea-0052': 'Спросите совета по работе или учёбе у человека, которого Вы уважаете',
        'idea-0053': 'Возьмитесь за ту часть проекта, в которой Вы меньше всего уверены',
        'idea-0054': 'Поделитесь идеей на встрече или в группе',
        'idea-0055': 'Подайте заявку на то, до чего Вам пока кажется трудно дотянуться',
        'idea-0056': 'Выделите утро для сосредоточенной работы и сохраните это время только для себя',
        'idea-0057': 'Научите кого-нибудь навыку, которым владеете сами',
        'idea-0058': 'Запланируйте разговор с наставником или человеком, чьей работой Вы восхищаетесь',
        'idea-0059': 'Сделайте первый реальный шаг к переменам в работе или учёбе',
        'idea-0060': 'Завершите проект, который давно хотелось довести до конца',
        'idea-0061': 'Включите песню, которую когда-то любили',
        'idea-0062': 'Выйдите на улицу и пару минут посмотрите на небо',
        'idea-0063': 'Посмотрите смешное видео и посмейтесь от души',
        'idea-0064': 'Приготовьте любимый напиток и выпейте его не торопясь',
        'idea-0065': 'Порисуйте каракули или наброски пять минут безо всякой цели',
        'idea-0066': 'Послушайте музыкальный альбом от начала до конца',
        'idea-0067': 'Посидите на скамейке в парке и понаблюдайте за прохожими',
        'idea-0068': 'Возьмите музыкальный инструмент и поиграйте десять минут',
        'idea-0069': 'Прочитайте главу из книги, выбранной ради удовольствия',
        'idea-0070': 'Примите долгий душ или ванну в своё удовольствие',
        'idea-0071': 'Потанцуйте у себя в комнате под несколько любимых песен',
        'idea-0072': 'Прогуляйтесь там, где обычно не бываете',
        'idea-0073': 'Приготовьте новое блюдо по рецепту, к которому давно присматривались',
        'idea-0074': 'Посмотрите фильм, который давно собирались увидеть',
        'idea-0075': 'Сфотографируйте на прогулке то, что покажется Вам красивым',
        'idea-0076': 'Сыграйте в любимую игру — в одиночку или с кем-то',
        'idea-0077': 'Разгадайте кроссворд, решите головоломку или соберите пазл',
        'idea-0078': 'Уделите полчаса своему хобби',
        'idea-0079': 'Проведите полдня на рынке, в галерее или в незнакомом районе',
        'idea-0080': 'Сходите в кафе с книгой или блокнотом и посидите там подольше',
        'idea-0081': 'Попробуйте заняться спортом или сыграть в игру, которая Вам раньше нравилась',
        'idea-0082': 'Переставьте вещи в одном из уголков комнаты, чтобы сделать его уютнее',
        'idea-0083': 'Сходите на концерт, кинопоказ или спектакль',
        'idea-0084': 'Проведите утро на свежем воздухе: в парке, на холме или у озера',
        'idea-0085': 'Начните небольшой творческий проект: рисунок, рассказ или поделку из дерева',
        'idea-0086': 'Сыграйте в спортивную или настольную игру с другими людьми',
        'idea-0087': 'Съездите на день туда, где Вы ещё ни разу не были',
        'idea-0088': 'Сходите на творческое занятие: керамику, живопись, танцы или музыку',
        'idea-0089': 'Запланируйте на выходные долгую прогулку или поездку на велосипеде',
        'idea-0090': 'Запланируйте короткую поездку, хотя бы на одну ночь',
        'idea-0091': 'Сделайте то, что давно хотели попробовать, и забронируйте это',
        'idea-0092': 'Сделайте пять медленных вдохов и выдохов, делая выдох длиннее вдоха',
        'idea-0093': 'Выпейте стакан воды и потяните руки и спину',
        'idea-0094': 'Обратите внимание на пять вещей, которые Вы можете увидеть, услышать или почувствовать прямо сейчас',
        'idea-0095': 'Откройте окно и подышите свежим воздухом пару минут',
        'idea-0096': 'Запишите одно дело, которое Вы сегодня сделали достаточно хорошо',
        'idea-0097': 'Прогуляйтесь десять минут',
        'idea-0098': 'Попробуйте короткую медитацию с голосовым сопровождением или сканирование тела',
        'idea-0099': 'Ложитесь спать сегодня точно в намеченное время',
        'idea-0100': 'Посидите в тишине со свечой или чашкой чая и просто побудьте с собой',
        'idea-0101': 'Запишите три приятные мелочи, которые сегодня удались',
        'idea-0102': 'Сделайте мягкую растяжку',
        'idea-0103': 'Сделайте дома короткую тренировку, пусть даже самую простую',
        'idea-0104': 'Приготовьте блюдо с чем-то новым для себя',
        'idea-0105': 'Прочитайте пару страниц текста, который приносит Вам смысл или утешение',
        'idea-0106': 'Уделите десять минут записям о своём состоянии, ни в чём себя не осуждая',
        'idea-0107': 'Поешьте не торопясь и без экранов',
        'idea-0108': 'Уделите время занятию, которое предназначено только для Вас',
        'idea-0109': 'Выделите полчаса на прогулку, пробежку или поездку на велосипеде',
        'idea-0110': 'Посетите значимое для Вас место: храм, парк или тихий уголок',
        'idea-0111': 'Запишитесь на осмотр или консультацию, которую Вы давно откладывали',
        'idea-0112': 'Посвятите пятнадцать минут практике осознанности',
        'idea-0113': 'Попробуйте видеоурок по йоге, тайцзи или растяжке',
        'idea-0114': 'Запишитесь на групповую тренировку или в секцию',
        'idea-0115': 'Примите участие в важной для Вас церемонии, службе или встрече',
        'idea-0116': 'Напишите себе письмо о том, чего Вы хотите от ближайших месяцев',
        'idea-0117': 'Составьте меню на неделю и купите для него продукты',
        'idea-0118': 'Поставьте спортивную цель на эту неделю и проведите первую тренировку',
        'idea-0119': 'Посвятите час тому, что отражает именно Вас, а не ожидания других',
        'idea-0120': 'Проведите целый вечер за отдыхом без экранов',
        'idea-0121': 'Проведите полдня в тихих размышлениях или уединении',
        'idea-0122': 'Запишитесь на долгую прогулку, забег или мероприятие и начните готовиться',
        'idea-0123': 'Заправьте постель',
        'idea-0124': 'Уберите на место пять вещей, которые лежат не там',
        'idea-0125': 'Помойте одну чашку или тарелку',
        'idea-0126': 'Откройте почту и сложите письма в одну стопку',
        'idea-0127': 'Выбросьте мусор из одной комнаты',
        'idea-0128': 'Запустите стирку',
        'idea-0129': 'Выпишите счета или дела, срок которых подходит на этой неделе',
        'idea-0130': 'Протрите кухонные поверхности и вымойте раковину',
        'idea-0131': 'Вынесите мусор и вторсырьё',
        'idea-0132': 'Спланируйте, что Вы будете есть завтра',
        'idea-0133': 'Загляните в календарь и выпишите встречи на неделю',
        'idea-0134': 'Помойте посуду сразу после еды',
        'idea-0135': 'Оплатите один счёт или ответьте на письмо, которое давно откладывали',
        'idea-0136': 'Пропылесосьте или подметите одну комнату',
        'idea-0137': 'Сходите в магазин за продуктами с коротким списком',
        'idea-0138': 'Разберите один ящик или полку',
        'idea-0139': 'Сделайте звонок, который давно откладывали',
        'idea-0140': 'Проверьте счета и запишите, сколько Вы потратили за эту неделю',
        'idea-0141': 'Посвятите полчаса домашнему делу, которое давно откладывали',
        'idea-0142': 'Поменяйте постельное бельё',
        'idea-0143': 'Приготовьте и заморозьте порцию еды на загруженный день',
        'idea-0144': 'Разберитесь с бланком, записью на приём или документом, который давно ждёт',
        'idea-0145': 'Отнесите ненужные вещи в пункт приёма или на переработку',
        'idea-0146': 'Помойте ванную комнату',
        'idea-0147': 'Составьте простой бюджет на месяц',
        'idea-0148': 'Разберите один шкаф или гардероб',
        'idea-0149': 'Разберитесь с официальным письмом или административной задачей',
        'idea-0150': 'Наведите полный порядок дома — комната за комнатой, с перерывами',
        'idea-0151': 'Сходите на встречу или приём, которых Вы избегали',
        'idea-0152': 'Посвятите один час крупному делу, которое над Вами висит',
      },
    },
  },
  fa: {
    errors: {
      FA_TARGET_NAME_REQUIRED: 'Опишите несколькими словами поведение, в котором хотите разобраться, и сохраните.',
      FA_TARGET_TOO_MANY: 'Одновременно можно отслеживать не больше трёх видов поведения. Закройте то, работу с которым Вы закончили, и добавьте новое.',
      FA_NOT_YOUR_CLIENT: 'Этот клиент не связан с Вами в практике: он не числится Вашим клиентом здесь или отключил обмен данными с Вами. Проверьте список клиентов или попросите клиента снова включить обмен данными с Вами в приложении.',
      FA_TARGET_UNKNOWN: 'Это поведение не найдено — возможно, оно уже закрыто. Вернитесь к списку и обновите его.',
      FA_INSTANCE_TIME: 'Запись или нажатие можно сохранить за сегодня или за последние 7 дней, а для запланированного изменения — не раньше его начала. Выберите день в этом диапазоне.',
      FA_URGE_RANGE: 'Сила побуждения оценивается от 0 до 10. Передвиньте ползунок на число в этом диапазоне и сохраните ещё раз.',
      FA_NOT_YOUR_TARGET: 'Это поведение выбрано вместе с Вашим терапевтом, поэтому изменить или закрыть его можно только на сессии. Вы по-прежнему можете делать записи и планировать изменения.',
      FA_CHANGE_UNKNOWN: 'Это запланированное изменение не найдено — возможно, соответствующее поведение уже закрыто. Вернитесь к списку и обновите его.',
      FA_VALUE_INVALID: 'Не удалось сохранить часть данных в этой форме. Проверьте выделенные ответы и попробуйте ещё раз.',
    },
    screens: {
      my: 'Функциональный анализ',
      record: 'Запись',
      noticed: 'Что удалось заметить',
      intro: 'Как это работает',
    },
    tile: {
      title: 'Функциональный анализ',
      description: 'Выберите поведение, записывайте, что к нему ведёт и что за ним следует, и смотрите, что повторяется.',
    },
    measure: {
      frequency: 'частота (сколько раз)',
      duration: 'длительность (в минутах)',
      intensity: 'интенсивность (0–10)',
    },
    function: {
      escapeAvoidance: 'Избегание или уход',
      attention: 'Внимание',
      tangible: 'Осязаемая выгода',
      automaticRelief: 'Автоматическое облегчение',
      unknown: 'Пока не знаю',
    },
    functionLine: {
      escapeAvoidance: 'помогает уйти от чего-то трудного или пугающего либо избежать этого',
      attention: 'привлекает других: они обращают внимание, интересуются, как дела, или помогают',
      tangible: 'позволяет получить желаемое: перерыв, угощение или какую-то вещь',
      automaticRelief: 'сразу успокаивает чувство или ощущение в теле',
      unknown: 'Пока не понимаю, что это мне даёт',
    },
    functionHint: 'Выберите один или несколько вариантов — или только «Пока не знаю».',
    vulnerability: {
      sleep: 'Плохой сон',
      tired: 'Усталость / истощение',
      hunger: 'Голод / пропуск еды',
      illness: 'Болезнь',
      pain: 'Боль',
      substances: 'Алкоголь или вещества',
      hardDay: 'Тяжёлый день',
      other: 'Другое…',
    },
    link: {
      event: 'Что произошло',
      thought: 'О чём я подумал(а)',
      feeling: 'Что я почувствовал(а)',
      body: 'Что я заметил(а) в теле',
      action: 'Что я сделал(а)',
    },
    tool: {
      thoughtTest: 'Тест мыслей',
      copingCard: 'Копинг-карточка',
      exposure: 'Экспозиция',
      plannedActivity: 'Запланированное занятие',
      crisisKit: 'Кризисный набор',
      meditation: 'Медитация',
      abcModel: 'ABC-модель',
      worksheet: 'Рабочий лист',
    },
    done: {
      yes: 'Да',
      partly: 'Частично',
      no: 'Нет',
    },
    my: {
      title: 'Функциональный анализ',
      add: '+ Добавить поведение',
      empty: {
        line1: 'Выберите одно действие, в котором Вы хотите разобраться: например, пропуск лекции или листание ленты в постели.',
        line2: 'Записывайте его, когда оно происходит или когда Вы чувствуете только побуждение. Несколько записей покажут закономерность.',
      },
      record: 'Записать',
      thisWeek: 'На этой неделе',
      thisWeekNothing: 'На этой неделе: пока ничего',
      times_one: '{{count}} раз',
      times_few: '{{count}} раза',
      times_many: '{{count}} раз',
      times_other: '{{count}} раза',
      urgesOnly_one: '{{count}} только побуждение',
      urgesOnly_few: '{{count}} только побуждения',
      urgesOnly_many: '{{count}} только побуждений',
      urgesOnly_other: '{{count}} только побуждения',
      recordsSoFar: '{{n}} из {{max}} записей — ещё немного, и я покажу, что удалось заметить',
      recordsCount_one: 'пока {{count}} запись',
      recordsCount_few: 'пока {{count}} записи',
      recordsCount_many: 'пока {{count}} записей',
      recordsCount_other: 'пока {{count}} записи',
      noticedLink: 'Что удалось заметить',
      fromDiaryCard: 'из дневника самонаблюдения',
      addedBy: 'Выбрано с моим терапевтом',
      trying: 'Пробую с {{date}}: {{what}}',
      tryingLater: 'Запланировано с {{date}}: {{what}}',
      doneOn: 'выполнено в {{done}} из {{marked}} дней',
      changeToday: 'Сегодня я выполнил(а) запланированное изменение',
      plan: 'Запланировать изменение',
      done: 'Прекратить отслеживать это поведение',
    },
    intro: {
      link: 'Впервые здесь? Посмотрите, как это работает (3 карточки)',
      title: 'Как это работает',
      progress: '{{n}} из 3',
      next: 'Далее',
      close: 'Понятно',
      article: 'Читать подробнее: что Вам даёт поведение',
      cards: {
        record: {
          title: 'Запись',
          body: 'Когда это происходит или когда Вы чувствуете только побуждение, запишите, что к этому привело, что последовало за этим и что это Вам дало. Это займёт минуту.',
        },
        rightAwayLater: {
          title: 'Сразу и потом',
          body: '«Сразу» — это то, что оно дало Вам в первые минуты. «Потом» — чем за него пришлось заплатить позже. Верно может быть и то, и другое одновременно.',
        },
        afterAFew: {
          title: 'Через несколько записей',
          body: 'Примерно через пять записей Вы увидите, что удалось заметить, и сможете выбрать одну небольшую деталь, чтобы попробовать поступить иначе.',
        },
      },
    },
    own: {
      title: 'Добавить поведение для исследования',
      body: 'Действие, в котором Вы хотите разобраться. Ваш терапевт увидит его на Вашей странице.',
      name: 'В чём Вы хотите разобраться?',
      namePlaceholder: 'Например: листание ленты в постели за полночь',
      description: 'Что считается за один раз',
      descriptionPlaceholder: 'Например: телефон в постели после 23:30',
      measure: 'Как измерять',
      function: 'Что это мне даёт',
      add: 'Добавить',
      saved: 'Добавлено в «Функциональный анализ».',
    },
    record: {
      title: 'Что произошло',
      when: 'Когда',
      whenNow: 'Только что',
      whenEarlier: 'Раньше',
      before: {
        title: 'До этого · что сделало меня уязвимым(ой)',
        from: 'Ранее:',
        otherPlaceholder: 'Несколькими словами',
      },
      trigger: {
        title: 'Что запустило это',
        placeholder: 'Что произошло прямо перед этим?',
      },
      then: 'Затем',
      linkPlaceholder: 'Несколько слов',
      addLink: 'Добавить',
      didIt: 'Я это сделал(а)',
      onlyUrge: 'Только побуждение',
      urge: 'Побуждение',
      amount: {
        frequency: 'Сколько раз',
        duration: 'Сколько минут',
        intensity: 'Насколько сильно (0–10)',
      },
      rightAway: {
        title: 'Сразу',
      },
      later: {
        title: 'Потом',
      },
      nextTime: {
        title: 'Что изменить в следующий раз',
      },
      hint: {
        rightAway: 'Что это дало Вам в первые минуты?',
        later: 'А позже, через часы или дни. Чем за это пришлось заплатить?',
        nextTime: 'Какой шаг мог пойти иначе и что могло бы помочь?',
      },
      tool: 'Инструмент, который может помочь',
      offered: 'Вы выбирали это {{n}} раз',
      anotherTool: 'Другой инструмент…',
      noTool: 'Без инструмента',
      openTool: 'Открыть',
      save: 'Сохранить',
      saved: 'Сохранено.',
      queued: 'Сохранено на телефоне — отправится, когда Вы будете в сети.',
      failed: 'Не удалось сохранить эту запись. Проверьте написанное и попробуйте ещё раз.',
    },
    noticed: {
      title: 'Что удалось заметить',
      records_one: '{{name}} · {{count}} запись',
      records_few: '{{name}} · {{count}} записи',
      records_many: '{{name}} · {{count}} записей',
      records_other: '{{name}} · {{count}} записи',
      notYet: 'Пока {{n}} из {{max}} записей — ещё немного, и картина станет яснее.',
      setOff: 'Что запускало это чаще всего',
      thoughtFeltDid: 'О чём я думал(а), что чувствовал(а) и делал(а)',
      thought: 'думал(а)',
      feeling: 'чувствовал(а)',
      body: 'в теле',
      action: 'сделал(а)',
      event: 'произошло',
      rightAway: 'Сразу',
      later: 'Потом',
      ideas: 'Мои идеи на следующий раз',
      times: '×{{n}}',
      why: 'Почему поведение может продолжаться — частые причины',
      escape: 'Избегание. Помогает уйти от чего-то трудного или пугающего. Облегчение реально, поэтому действие может повторяться.',
      attention: 'Внимание. Привлекает других людей: они обращают внимание, интересуются, как дела, или помогают.',
      reward: 'Награда. Позволяет получить желаемое: перерыв, угощение или приятные ощущения.',
      relief: 'Облегчение. Сразу успокаивает чувство или ощущение в теле.',
      plan: 'Запланировать изменение',
    },
    change: {
      own: {
        title: 'Запланировать изменение',
        whatChanges: 'Что я попробую',
        fromIdeas: 'Из Ваших идей: Вы записали это {{n}} раз. Если хотите, измените.',
        expected: 'Чего я ожидаю',
        from: 'С',
        plan: 'Запланировать',
        saved: 'Запланировано. Каждый день Вы можете нажимать «да», «частично» или «нет».',
      },
      title: 'Запланировать изменение',
      intro: 'Измените одну деталь — то, что предшествует поведению или следует за ним, — начиная с определённой даты, и укажите, чего Вы ожидаете. Тогда сводка разделит записи на сделанные до и после неё.',
      whatChanges: 'Что меняется',
      expected: 'Чего мы ожидаем',
      from: 'С',
      plan: 'Запланировать',
      saved: 'Изменение запланировано.',
      fewRecords: 'Пока меньше {{max}} записей ({{n}}). Оценить изменение проще примерно после {{max}} — но Вы можете запланировать его прямо сейчас.',
      prefill: 'Идея, которую клиент отмечал чаще всего ({{n}} раз). Измените её, если Вы оба предпочтёте что-то другое.',
      context: 'Что предшествует ему и следует за ним',
      ideas: 'Идеи клиента',
      required: 'Напишите, что меняется, и выберите дату начала.',
    },
    changeDay: {
      title: 'Сегодня',
      trying: 'Пробую с {{date}}',
      did: 'Сегодня я выполнил(а) запланированное изменение',
      progress: '{{day}} · пока выполнено в {{done}} из {{marked}} дней',
      saved: 'Записано.',
    },
    retire: {
      own: {
        title: 'Прекратить отслеживать это поведение',
        why: 'Почему я прекращаю отслеживать?',
        note: 'Ваши записи сохранятся. Поведение исчезнет из Вашего списка.',
        done: 'Прекратить отслеживать',
        saved: 'Удалено из Вашего списка. Ваши записи сохранятся.',
      },
      title: 'Закрыть',
      intro: 'Прекратите отслеживать это поведение, когда работа завершена. Записи сохранятся.',
      reason: 'Причина',
      retire: 'Закрыть',
      saved: 'Поведение закрыто. Записи сохранятся.',
    },
    hub: {
      title: 'Функциональный анализ',
      purpose: 'Что поведение предположительно даёт клиенту, судя по его записям — гипотеза для проверки, а не окончательный вывод.',
      recordsTitle: 'Записи',
      measureLine: 'Как измерять: {{measure}} · Базовый период: {{weeks}}',
      baselineWeeks_one: '{{count}} неделя',
      baselineWeeks_few: '{{count}} недели',
      baselineWeeks_many: '{{count}} недель',
      baselineWeeks_other: '{{count}} недели',
      planOpen: 'Запланировать изменение',
      retireOpen: 'Закрыть',
      empty:
        'Поведение пока не выбрано. Выберите его вместе с клиентом: сформулируйте его словами клиента, укажите, что считается за один раз, как его измерять и что оно предположительно даёт клиенту.',
      pick: 'Поведение',
      closed: 'Закрыто',
      byClient: 'Добавлено клиентом',
      byClientChange: 'запланировано клиентом',
      records: 'Сделано записей',
      recordsLine: 'цепочек: {{chains}} · только побуждений: {{urges}}',
      function: 'Функция (гипотеза)',
      functionNote: 'Что это предположительно даёт клиенту — гипотеза для проверки, а не окончательный вывод.',
      set: {
        title: 'Целевое поведение',
        add: 'Выбрать поведение',
        edit: 'Редактировать',
      },
      before: 'До изменения',
      after: 'После (с {{date}})',
      perWeek: '{{n}} в неделю',
      meanUrge: 'побуждение {{n}}',
      did: 'действие совершено',
      urgeOnly: 'только побуждение',
      weeks: 'По неделям',
      weekOf: 'Неделя с {{date}}',
      changeDays: 'изменение выполнено в {{done}} из {{marked}} дней (да: {{yes}} · частично: {{partly}})',
      noChangeDays: 'пока нет отмеченных дней',
      recurs: 'Что повторяется',
      count: 'Количество',
      vulnerabilities: 'До этого',
      promptingEvents: 'Что запустило это',
      rightAway: 'Сразу',
      later: 'Потом',
      nextTime: 'Что изменить в следующий раз',
      link: {
        event: 'Что произошло',
        thought: 'О чём я подумал(а)',
        feeling: 'Что я почувствовал(а)',
        body: 'Что я заметил(а) в теле',
        action: 'Что я сделал(а)',
      },
      suggestion: 'Идея для следующего изменения',
      suggestionLine: 'Идея, которую клиент отмечал чаще всего: {{instead}} ({{times}} раз)',
      noSuggestion: 'Пока нет отмеченных идей.',
      fromDiaryCard: 'из дневника самонаблюдения',
      changes: 'Запланированные изменения',
      sections: {
        set: 'Выбрать поведение',
        assign: 'Назначить записи',
        formulation: 'Концептуализация',
        plan: 'Запланировать изменение',
        retire: 'Закрыть',
      },
    },
    target: {
      title: 'Целевое поведение',
      intro:
        'Выберите вместе с клиентом поведение, в котором хотите разобраться: опишите его словами клиента, укажите, что считается за один раз, как его измерять и какую функцию, как Вы оба считаете, оно выполняет. Любому изменению предшествует неделя записей.',
      nameRequired: 'Опишите поведение словами клиента.',
      name: 'Поведение словами клиента',
      description: 'Что считается за один раз',
      measure: 'Как измерять',
      baseline: 'Базовый период (недели записей до изменения)',
      function: 'Что это предположительно даёт клиенту (функция)',
      save: 'Сохранить',
      saved: 'Поведение сохранено.',
    },
    assign: {
      title: 'Назначить записи',
      intro: 'Попросите делать запись каждый раз, когда это происходит, а также когда возникает только побуждение. Любому изменению предшествует базовый период записей.',
      assignTitle: 'Название',
      refRequired: 'Выберите поведение для записи.',
      needsBehavior: 'Сначала выберите поведение.',
      closed: 'Это поведение закрыто.',
      defaultTitle: 'Записывать каждый раз, когда это происходит или почти происходит: {{name}}',
      instructions: 'Инструкции',
      defaultInstructions: 'В том числе когда Вы почувствовали только побуждение.',
      weeks: 'Недели',
      assign: 'Назначить',
      saved: 'Записи назначены.',
    },
  },
  mi: {
    errors: {
      MI_GOAL_LABEL_REQUIRED: 'Опишите в нескольких словах изменение, о котором Вы думаете, затем сохраните.',
      MI_GOAL_TOO_MANY: 'Одновременно может быть открыто не больше трёх изменений. Закройте то, с которым Вы закончили или от которого решили отказаться, затем добавьте новое.',
      MI_NOT_YOUR_CLIENT: 'Этот клиент не прикреплён к Вам в практике или отключил обмен данными с Вами. Проверьте список клиентов или попросите клиента снова включить обмен данными с Вами в приложении.',
      MI_RULER_RANGE: 'Каждая шкала оценивается от 0 до 10. Выберите число в этом диапазоне и сохраните ещё раз.',
      MI_GOAL_UNKNOWN:
        'Не удалось найти это изменение. Вернитесь в «Мотивационное интервьюирование» и откройте его снова.',
      MI_GOAL_CLOSED: 'Это изменение закрыто. Сначала откройте его заново, чтобы добавить записи.',
      MI_GOAL_OPEN: 'Это изменение уже открыто.',
      MI_BALANCE_EMPTY: 'Заполните хотя бы одно из четырёх полей, затем сохраните.',
      MI_PLAN_CHANGE_REQUIRED: 'Напишите, что именно Вы измените, затем сохраните план.',
      MI_TALK_EMPTY: 'Опишите в нескольких словах то, что Вы заметили, затем сохраните.',
      MI_VALUE_INVALID: 'Не удалось сохранить данные этой формы. Проверьте ответы и попробуйте ещё раз.',
    },
    tile: {
      title: 'Мотивационное интервьюирование',
      description: 'Изменение, о котором Вы думаете: насколько оно важно, плюсы и минусы, а также план действий, когда Вы будете готовы.',
    },
    screens: {
      list: 'Мотивационное интервьюирование',
      set: 'Изменение, о котором я думаю',
      change: 'Моё изменение',
      rulers: 'Шкалы',
      balance: 'Плюсы и минусы',
      plan: 'Мой план изменений',
      talk: 'Разговор об изменениях',
    },
    ruler: {
      importance: 'Важность',
      confidence: 'Уверенность',
      readiness: 'Готовность',
    },
    status: {
      open: 'Открыто',
      closed: 'Закрыто',
    },
    outcome: {
      done: 'Завершено',
      decidedNotTo: 'Решено не менять',
      other: 'Другое',
    },
    stage: {
      precontemplation: 'Пока не думаю об изменениях',
      contemplation: 'Размышляю об изменениях',
      action: 'Готовлюсь или вношу изменения',
      maintenance: 'Поддерживаю изменения',
    },
    list: {
      title: 'Мотивационное интервьюирование',
      intro: 'Изменение, о котором Вы думаете, не обязательно должно быть обещанием. Взгляните на него со всех сторон в удобном для Вас темпе.',
      empty: 'Здесь пока ничего нет. Начните с одного изменения, о котором Вы думаете, и опишите его своими словами.',
      add: 'Изменение, о котором я думаю',
      values: 'Ради чего: {{values}}',
      closedAs: 'Закрыто · {{outcome}}',
      loadError: 'Не удалось загрузить Ваши изменения. Проверьте подключение и попробуйте ещё раз.',
    },
    goal: {
      title: 'Изменение, о котором я думаю',
      intro: 'Опишите всё своими словами. Это возможность исследовать тему, а не обязательство.',
      label: 'Изменение',
      labelPlaceholder: 'Например: ходить на работу пешком дважды в неделю',
      values: 'Ради чего это важно (необязательно)',
      valuesHint: 'Выберите из своих ценностей, если Вы их уже распределили.',
      noValues: 'Распределите ценности в разделе «Ценности», чтобы связать их здесь.',
      save: 'Сохранить',
      saved: 'Сохранено.',
      rename: 'Переименовать',
    },
    rulers: {
      title: 'Шкалы',
      intro: 'Выберите число от 0 до 10 для каждой шкалы. Здесь нет правильных чисел — это лишь Ваш взгляд на сегодня.',
      importanceQ: 'Насколько это изменение важно для Вас прямо сейчас?',
      confidenceQ: 'Насколько Вы уверены, что сможете осуществить это, если решитесь?',
      readinessQ: 'Насколько Вы готовы начать прямо сейчас?',
      scaleLow: '0 · совсем нет',
      scaleHigh: '10 · полностью',
      focus: 'Вопросы по шкале:',
      focusHint: 'Нажмите на другую шкалу, чтобы ответить на вопросы о ней.',
      whyNotLower: 'Почему {{value}}, а не 0?',
      whyNotLowerHint: 'Почему оценка уже такая высокая?',
      whatWouldRaise: 'Что помогло бы поднять её до {{next}}?',
      noQuestions: 'Если все шкалы на одной и той же крайней отметке, дополнительных вопросов на этот раз нет.',
      save: 'Сохранить',
      saved: 'Ваши шкалы сохранены.',
    },
    balance: {
      title: 'Плюсы и минусы',
      intro: 'Будьте честны с собой по поводу обеих сторон. В том, чтобы оставить всё как есть, тоже есть свои плюсы — и полезно записать их.',
      prosOfStaying: 'Оставить всё как есть · что в этом хорошего',
      consOfStaying: 'Оставить всё как есть · что в этом не очень хорошего',
      consOfChange: 'Пойти на изменения · что в этом не очень хорошего',
      prosOfChange: 'Пойти на изменения · что в этом хорошего',
      linesHint: 'Каждый пункт с новой строки',
      save: 'Сохранить',
      saved: 'Плюсы и минусы сохранены.',
    },
    plan: {
      title: 'Мой план изменений',
      intro: 'Когда почувствуете готовность, спланируйте изменения в виде небольших конкретных шагов.',
      changes: 'Что я изменю',
      changesPlaceholder: 'Например: ходить на работу пешком по вторникам и четвергам',
      reasons: 'Мои причины',
      steps: 'Шаги и когда их сделать',
      step: 'Шаг',
      when: 'Когда',
      addStep: '+ Добавить шаг',
      helpers: 'Кто может помочь',
      obstacles: 'Что может помешать и что я тогда сделаю',
      obstacle: 'Что может помешать',
      response: 'Что я тогда сделаю',
      addObstacle: '+ Добавить ещё',
      signsOfSuccess: 'Как я пойму, что всё получается',
      toHomework: 'Добавить в мои домашние задания',
      remove: 'Удалить',
      save: 'Сохранить',
      saved: 'Ваш план сохранён.',
    },
    talk: {
      title: 'Разговор об изменениях',
      intro: 'Заметили причину для изменений, желание или сделанный шаг? Запишите это своими словами.',
      talk: 'Что удалось заметить',
      placeholder: 'Например: утром после прогулки мне было лучше',
      kind: 'Это… (необязательно)',
      kinds: {
        desire: 'То, чего я хочу',
        ability: 'То, что я могу сделать',
        reason: 'Причина',
        need: 'То, что мне нужно',
        commitment: 'То, что я сделаю',
        takingSteps: 'Сделанный шаг',
      },
      save: 'Сохранить',
      saved: 'Сохранено в Ваш дневник.',
    },
    journey: {
      title: 'Моё изменение',
      values: 'Ради чего: {{values}}',
      rulers: 'Динамика шкал',
      rulersEmpty: 'Оценок пока нет.',
      rulerLine: 'Важность {{importance}} · Уверенность {{confidence}} · Готовность {{readiness}}',
      reasons: 'Мои причины своими словами',
      reasonsEmpty: 'Здесь появятся Ваши ответы на вопрос «почему не 0?».',
      balance: 'Плюсы и минусы',
      balanceEmpty: 'Ещё не записано.',
      plan: 'Мой план изменений',
      planEmpty: 'Плана пока нет — составьте его, когда почувствуете готовность.',
      journal: 'Разговор об изменениях',
      journalEmpty: 'Здесь появятся Ваши записи.',
      urica: 'Стадия изменений: {{stage}} (готовность {{readiness}})',
      uricaTaken: 'Пройден {{date}}, об изменениях в целом',
      uricaTake: 'Насколько я готов(а) к изменениям? (опросник URICA)',
      closedLine: 'Закрыто {{date}} · {{outcome}}',
      rate: 'Оценить',
      writeBalance: 'Плюсы и минусы',
      writePlan: 'План изменений',
      noteTalk: 'Записать разговор об изменениях',
      loadError: 'Не удалось загрузить это изменение. Вернитесь назад и попробуйте ещё раз.',
    },
    close: {
      open: 'Завершить работу над изменением',
      title: 'Завершить работу над изменением',
      intro: 'Решение ничего не менять — тоже полноценный ответ. Изменение останется в Вашей истории, и Вы сможете открыть его заново в любой момент.',
      outcome: 'Чем всё закончилось',
      note: 'Заметка (необязательно)',
      notePlaceholder: 'Например: шесть недель ходьбы на работу пешком',
      button: 'Завершить работу над изменением',
      cancel: 'Отмена',
      closed: 'Работа над изменением завершена.',
    },
    reopen: {
      intro: 'Откройте его заново, чтобы продолжить — оценки по шкалам, плюсы и минусы, план и заметки сохранятся.',
      button: 'Открыть заново',
      reopened: 'Изменение снова открыто.',
    },
    hub: {
      title: 'Мотивационное интервьюирование',
      intro: 'Изменения, о которых думает этот клиент, его собственными словами: динамика шкал, причины, плюсы и минусы, а также план.',
      empty: 'Пока не записано ни одного изменения. Запишите его вместе с клиентом на сессии.',
      notShared: 'Этот клиент не делится с Вами своими данными.',
      loadError: 'Не удалось загрузить изменения клиента. Обновите страницу и попробуйте ещё раз.',
      setBy: 'Записано на сессии',
      rulers: 'Шкалы',
      rulersEmpty: 'Ещё не оценено.',
      changeTalk: 'Словами клиента',
      changeTalkEmpty: 'Ответов пока нет.',
      journal: 'Разговор об изменениях',
      balance: 'Плюсы и минусы',
      plan: 'План изменений',
      closed: 'Закрыто {{date}} · {{outcome}}',
      urica: 'Стадия изменений (URICA): {{stage}}, готовность {{readiness}}',
      uricaTaken: 'Пройден {{date}}, об изменениях в целом',
      date: 'Дата',
      summary: 'Важность {{importance}} · Уверенность {{confidence}} · Готовность {{readiness}} · {{date}}',
      goal: {
        title: 'Записать изменение вместе с клиентом',
        intro: 'Запишите изменение, о котором думает клиент, его собственными словами.',
        label: 'Изменение',
        values: 'Ради чего это важно (необязательно)',
        valuesHint: 'Выберите из ценностей клиента.',
        save: 'Сохранить',
        saved: 'Изменение сохранено.',
      },
      assign: {
        title: 'Назначить перед сессией',
        intro: 'Попросите клиента оценить изменение по шкалам, записать плюсы и минусы или составить план до встречи.',
        what: 'Что сделать',
        changeRating: 'Три шкалы',
        decisionalBalance: 'Плюсы и минусы',
        changePlan: 'План изменений',
        goal: 'Какое изменение',
        anyGoal: 'Любое изменение',
        assignTitle: 'Название',
        defaultTitle: {
          changeRating: 'Перед встречей: три шкалы',
          decisionalBalance: 'Перед встречей: плюсы и минусы',
          changePlan: 'Перед встречей: план изменений',
        },
        instructions: 'Инструкции',
        defaultInstructions: {
          changeRating: 'Две минуты — и ответьте на вопрос «почему не 0?».',
          decisionalBalance: 'Будьте честны по поводу обеих сторон: оставить всё как есть и пойти на изменения.',
          changePlan: 'Небольшие конкретные шаги и то, что Вы сделаете, если что-то помешает.',
        },
        due: 'Срок',
        assign: 'Назначить',
        saved: 'Назначено.',
      },
    },
  },
};
